<template>
  <section class="section is-size-7">
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <div class="container-fluid">
      <div class="card">
       <div class="card-header">Email Tracking
          <button type="button" name="button" @click="getEmailCases()" class="btn btn-light btn-pill card-header-actions"  >
              <!--<b-icon class="is-small" icon="refresh"></b-icon>-->
          </button>
        </div>
        <div class="card-body">
          <b-tabs v-model="selectedTab">
            <b-tab title="Case List" @click="switchTab('Case List')">
              <div v-if="activeComponent == 'Case List'">
                <div v-if="showReAllocationForm && userRole.toLowerCase() !== 'associate'">
                  <form name="tlreallocation" @submit.prevent="reallocateCase()">
                      <div class="card-header"> Re-Allocate Email </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-1">
                            <div role="group" class="mb-0 form-group">
                              Agent
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <select v-model="reallocate.agent" class="is-hovered form-control" required>
                                <option value="">--Select Agent--</option>
                                <option :value="agent" v-for="(agent,index) in activeAgents" :key="index">{{agent}}</option>
                              </select>
                            </div>
                          </div>

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                            <button type="submit" name="Reallocate" class="btn-primary" title="Reallocate Ticket">Re-Allocate</button>
                            </div>
                          </div>
                        </div>
                      </div>
                  </form>
                </div>
                <!-- <div class="card-header">
                  <i class=" fa fa-filter filter" data-toggle="collapse1" v-b-toggle.collapse aria-expanded="true"
                    title="Search Filter">&nbsp;&nbsp;&nbsp;Filter</i>
                </div>
                <b-collapse id="collapse" class=""> -->
                <div class="col-lg-12" id="printPoContent" >
                  <!-- <loading :active.sync="isLoading" :is-full-page="fullPage"></loading> -->
                  <b-card style="background-color: transparent; border: 0px solid transparent; margin-bottom: 0;">
                    <h5 class="modal-title" style="display: inline;">Search</h5>
                    <!-- <button type="button" aria-label="Close" @click="isSearchModal=false" class="close">×</button> -->
                      <div class="card-body modal-content">
                        <form @submit.prevent="applyFilter()" class="">
                            <div class="card-body">

                               <div id ="date_data" class="row" >
                                
                                  <div class="col-sm-3">   
                                  <input @click="onCheckCreatedDate( $event )" type="radio" name="Date" value="Created_Date" Checked>
                                  <label>Search by Created Date</label><br>
                                  </div>
                                  <div class="col-sm-3">
                                  <input @click="onCheckModifiedDate( $event )" type="radio" name="Date" value="Modfied_Date" >
                                  <label>Search by Modified Date</label><br>
                                  </div>
                                    <div class="col-sm-3" v-if = "AI_ENABLED == true">
                                  <input type="checkbox" name="aiassisted" v-model="filter.aiassisted" >
                                  <label>Show AI drafts</label><br>
                                  </div>
                                
                              </div>  
                              <div class="row">
                                <div class="col-sm-2">
                                  <div role="group" class="form-group">
                                    <label class="col-form-label"> From Date : </label>
                                    <date-picker style="width: 100%;" lang="en" type="date" :required="!filter.caseid && !filter.fromemail && !filter.fcaccountid" v-model='filter.fromDate' :not-after="filter.toDate" v-on:change="onChange"></date-picker>
                                  </div>
                                </div>
                                <div class="col-sm-2">
                                  <div role="group" class="form-group">
                                  <label class="col-form-label"> To Date : </label>
                                  <date-picker style="width: 100%;" lang="en" :required="!filter.caseid && !filter.fromemail && !filter.fcaccountid" type="date" v-model='filter.toDate' :not-before="filter.fromDate" :not-after="maxToDate" v-on:change="onChange"></date-picker>
                                  </div>
                                </div>
                                <div class="col-2">
                                  <div role="group" class="form-group">
                                    <label  class="col-form-label">Status</label>
                                      <select v-model="filter.status" class="form-control">
                                        <option value="">--Select--</option>
                                        <option value="allocationpending" v-if="userRole.toLowerCase() !== 'associate'">AllocationPending</option>
                                        <option value="allocated">Allocated</option>
                                        <option value="inprocess">InProcess</option>
                                        <option value="followup">Follow up</option>
                                        <option value="close">Close</option>
                                        <option value="spam">Spam</option>
                                        <option value="trash" v-if="userRole.toLowerCase() !== 'associate'">Trash</option>
                                      </select>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div role="group" class="form-group">
                                    <label class="col-form-label"> Agent : </label>
                                    <select v-model="filter.agent" v-if="userRole.toLowerCase() !== 'associate'" class="form-control">
                                      <option value="">All</option>
                                      <option :value="agent" v-for="(agent,index) in activeAgents" :key="index">{{agent}}</option>
                                    </select>
                                    <select v-model="filter.agent" v-if="userRole.toLowerCase() === 'associate'" class="form-control">
                                      <option :value="filter.agent">{{filter.agent}}</option>
                                    </select>
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div role="group" class="form-group">
                                  <label class="col-form-label"> Email Case ID : </label>
                                  <input type="text" placeholder="Enter Case ID" class="form-control" v-model.trim="filter.caseid" @keypress="checkIsNumber()">
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-3">
                                  <div role="group" class="form-group">
                                  <label class="col-form-label"> Email From : </label>
                                  <input type="text" class="form-control" placeholder=" Enter Email From" v-model.trim="filter.fromemail">
                                  </div>
                                </div>

                                <div class="col-3">
                                  <div role="group" class="form-group">
                                  <label class="col-form-label"> Email To : </label>
                                  <input type="text" class="form-control" placeholder=" Enter Email To" v-model.trim="filter.toemail">
                                  </div>
                                </div>
                                <div class="col-3">
                                  <div role="group" class="form-group">
                                    <label class="col-form-label"> Email CC : </label>
                                    <input type="text" class="form-control" placeholder=" Enter Email CC" v-model.trim="filter.ccemail">
                                  </div>
                                </div>
                                <div class="col-sm-3">
                                  <div role="group" class="form-group">
                                  <label  class="col-form-label">Email Subject</label>
                                  <input type="text" class="form-control" placeholder=" Enter Email Subject" v-model.trim="filter.subject">
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-9">
                                  <div role="group" class="form-group">
                                  </div>
                                </div>
                                 <div class="col-3">
                                  <div role="group" class="form-group">
                                    <div>
                                      <button type="submit" class="btn btn-primary" variant="primary" name="searchButton" size="sm">Search</button>
                                      <button type="button" class="btn btn-danger" @click="resetFilter()" size="sm"> Reset </button>
                                      <button type="button" class="btn btn-primary"  v-if="userRole === constantVariable.TEAM_LEADER" @click="exportEmailerAIReport()" variant="primary" name="searchButton" size="sm">Export</button>&nbsp;       
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </form>
                      </div>
                  </b-card>
                <!-- </b-collapse> -->
                </div>

                <loading :active.sync="loadCount"></loading>
                <div>Total Count: <strong>{{totalCount}}</strong>
                  <!-- <div v-on:click="toggleModal()" style="float:right;"><span><i class="fa fa-search"></i></span></div> -->
                </div>
                <div class="card-body">
                  <div>
                    <div class="rowFullTable" v-if="emailCasesArray.length">
                      <table class="table table-fixed table-hover tableFixHeadBottom table-text-cente">
                        <thead class="table-head">
                          <th class="row-ID">
                            <input v-model="allSelected" @click="selectAllCase" type="checkbox" :disabled="checkAllSelected" name="Select All">
                          </th>
                          <th class="row-ID">CaseID</th>
                          <th class="row-Desc" style="column-width:300px;">AssignTo</th>
                          <th class="row-ID" style="column-width:100px;" v-if = 'AI_ENABLED == true'>Category</th>
                          <th class="row-incident-level">EmailInfo</th>
                          <th class="row-Date">Status</th>
                          <th class="row-Date">Attachment</th>
                          <th class="row-ID" style="column-width:100px;">Preview</th>
                          <th class="row-ID" style="column-width:100px;" v-if = "AI_ENABLED == true">AI</th>
                          <th v-if="userRole.toLowerCase() === 'associate'  && filter.status.toLowerCase() !=='spam'" class="row-ID">Action</th>
                          <th v-else-if="userRole.toLowerCase() === 'team leader'
                          && filter.status.toLowerCase()!=='allocationpending'
                          && filter.status.toLowerCase()!=='allocated'
                          && filter.status.toLowerCase()!=='inprocess'
                          && filter.status.toLowerCase()!=='trash'
                          && filter.status.toLowerCase()!=='spam'"
                          class="row-ID">Action</th>
                        </thead>
                        <tbody class="position-relative">
                          <tr v-for="(emailCase,index) in emailCasesArray">
                            <td><input :value="emailCase.caseid" :id="emailCase.caseid" v-model="selectedCaseIds"
                                type="checkbox" @click="selectCase( emailCase, $event )" name="Select All"></td>
                            <td>
                             <button type="button" class="btn btn-link px-0" @click="selectedTab=1;showModelPOPs(emailCase.caseid)" title="View Email Case Log">{{emailCase.caseid}}</button>
                             <br><span
                                :class="{'tag is-warning':emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes'}"
                                v-if="emailCase.isrepeatcount && emailCase.isrepeatcount.toLowerCase() === 'yes'">RepeatEmail</span>
                           </td>
                            <td>
                              <div class="media-body">
                                <b>Assigned To : </b>
                                <span class="text-muted">{{emailCase.assignedto}}</span><br>
                                <b>Created Date :</b>
                                <span class="text-muted">{{formaEmailtDate(emailCase.emaildate)}}</span><br>
                                <b>Last Modified By : </b>
                                <span class="text-muted">{{emailCase.lastmodifiedby}}</span><br>
                                <b>Last Modified Date : </b>
                                <span class="text-muted">{{emailCase.lastmodifieddate | dateFilter}}</span>
                              </div>
                            </td>
                              <td  v-if = 'AI_ENABLED == true'>
                              <div class="media-body">
                                <b>{{emailCase.maintypename}}</b>
                                </div>
                            </td>
                            <td>
                              <b>From:</b> <span class="text-muted">
                                {{emailCase.fromid}}
                              </span> <br>
                              <b>Subject:</b> <span>
                                <span class="text-muted"
                                  v-if="emailCase.subject && emailCase.subject && emailCase.subject.length <=200">{{emailCase.subject}}</span>
                                <span class="text-muted" v-else-if="emailCase.subject && emailCase.subject">
                                  <b-tooltip :label="emailCase.subject" multilined>
                                    {{emailCase.subject.substring(0, 200)}} ...
                                  </b-tooltip>
                                </span>
                              </span> <br>
                              <b>Originate Source:</b>
                              <span v-if="emailCase.originatesource">
                                <span class="text-muted"
                                  v-if="emailCase.originatesource.toLowerCase() === 'cbfeedbackemail'">
                                  CB
                                </span>
                                <span class="text-muted"
                                  v-else-if="emailCase.originatesource.toLowerCase() === 'feedbackemail'">
                                  Web
                                </span>
                                <span class="text-muted"
                                  v-else-if="emailCase.originatesource.toLowerCase() === 'needhelp'">
                                  Need Help
                                </span>
                              </span>
                              <span class="text-muted" v-else> CCEmail</span></td>
                            <td>
                             <h6>
                                <span v-if="emailCase.status == 'allocationpending'" v-bind:class="[emailCase.status == 'allocationpending' ? 'badge badge-warning is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span v-if="emailCase.status == 'allocated'" v-bind:class="[emailCase.status == 'allocated' ? 'badge badge-danger is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span v-if="emailCase.status == 'inprocess'" v-bind:class="[emailCase.status == 'inprocess' ? 'badge badge-info is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span v-if="emailCase.status == 'Close'" v-bind:class="[emailCase.status == 'Close' ? 'badge badge-success is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span v-if="emailCase.status == 'spam'" v-bind:class="[emailCase.status == 'spam' ? 'badge badge-secondary is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span v-if="emailCase.status == 'trash'" v-bind:class="[emailCase.status == 'trash' ? 'badge badge-dark is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span v-if="emailCase.status == 'followup'" v-bind:class="[emailCase.status == 'followup' ? 'badge badge-info is-capitalized' : '' ]">{{emailCase.status}}</span>
                                <span style="background-color:#e32d5e;line-height: 2.8; font-size: 14px;" v-if="emailCase.priority == 0" ><b>CEOEscalation</b></span>
                            </h6>
                            </td>
                            <td>
                              <span
                                v-if="emailCase && emailCase.isattachment && emailCase.isattachment.toLowerCase() ==='yes'">
                                <router-link
                                  :to="{ path: encodeURI('/emailattachment'), query: {inboxID : emailCase.inboxid, caseID:emailCase.caseid} }"
                                  id="link" title="View Attachment" target="_blank">
                                  <a>
                                    <button variant="outline-primary">
                                      <i class="fa fa-paperclip"></i>
                                    </button>
                                  </a>
                                </router-link>
                              </span>
                              <span v-else>
                                No
                              </span>
                            </td>
                            <td><p v-if="userRole.toLowerCase() === 'associate' ">

                                      <EmailPreview :setCaseID="[emailCase.caseid]" v-if="emailCase.status.toLowerCase()==='inprocess' || emailCase.status.toLowerCase()==='allocated' || emailCase.status.toLowerCase()==='close' || emailCase.status.toLowerCase()==='followup'" :buttonType="'eye'"></EmailPreview>
                                      <b-button variant="outline-primary btn-sm"  v-else title="Email Preview" @click="notAllowedPreview(emailCase.caseid,emailCase.status)"><i class="fa fa-eye"></i></b-button>

                                    </p>
                                    <p v-else>
                                      <EmailPreview :setCaseID="[emailCase.caseid]" :buttonType="'eye'"></EmailPreview>
                                    </p>
                            </td>
                             <td v-if = 'AI_ENABLED == true'>
                              <b-button variant="outline-primary btn-sm"  v-if = "AI_ENABLED == true && emailCase.aiassisted == 'Y'"><i class="fa fa-user"></i></b-button>
                            </td>
                          
                            <td v-if=" (userRole.toLowerCase() === 'associate'  && filter.status.toLowerCase()!=='spam' ) ||  (userRole.toLowerCase() === 'team leader'
                                && filter.status.toLowerCase()!=='allocationpending'
                                && filter.status.toLowerCase()!=='allocated'
                                && filter.status.toLowerCase()!=='inprocess'
                                && filter.status.toLowerCase()!=='trash'
                                && filter.status.toLowerCase()!=='spam')" width="10%">

                              <div v-if="filter.status.toLowerCase()!=='spam' && emailCase.status.toLowerCase() ==='allocated' || emailCase.status.toLowerCase() ==='inprocess'">
                                <b-dropdown text="Settings" variant="p-0" right>
                                <template slot="button-content">
                                  <i class="fa fa-cogs"></i>
                                </template>
                                <b-dropdown-item v-if="emailCase.status.toLowerCase() ==='inprocess'"
                                  @click="actionType('raiseticket',emailCase)">Raise Ticket</b-dropdown-item>
                                <b-dropdown-item v-if="emailCase.status.toLowerCase() ==='allocated'"
                                  @click="actionType('assigntome',emailCase)" >Assign To Me</b-dropdown-item>
                                <b-dropdown-item v-if="emailCase.status.toLowerCase() !=='spam'"
                                  @click="actionType('markasspam',emailCase)">Mark As Spam</b-dropdown-item>
                                <b-dropdown-item
                                  @click="actionType('autoreply',emailCase)">Auto Reply</b-dropdown-item>
                                </b-dropdown>
                              </div>
                              <div v-else>
                                   <b-dropdown text="Settings" variant="p-0" right>
                                    <template slot="button-content">
                                      <i  class="fa fa-cogs"></i>
                                    </template>
                                    <b-dropdown-item
                                      @click="getDetailLevel( emailCase, index )" >View Tickets</b-dropdown-item>
                                      <b-dropdown-item v-if="emailCase.status.toLowerCase() ==='followup' &&  userRole.toLowerCase() === 'associate'"
                                      @click="actionType('autoreply',emailCase)">Auto Reply</b-dropdown-item>
                                    <b-dropdown-item v-if="emailCase.status.toLowerCase() ==='followup' &&  userRole.toLowerCase() === 'associate'"
                                      @click="getDetailTicketStatusClose( emailCase, index )">Auto Close</b-dropdown-item>
                                    </b-dropdown>
                              </div>
                            </td>
                          </tr>
                          <tr v-if="emailCasesArray.length==0">
                            <td colspan="7" align="center">Records not found</td>
                          </tr>
                        </tbody>
                      </table>
                       <div>
                          <paginate v-if="totalPages>1" :page-count="totalPages" :margin-pages="3" :click-handler="getPaginationData"
                            ref="paginate" :prev-text="'⏮'" :next-text="'⏭'" :container-class="'pagination'"
                            :page-class="'page-item'" :pageLinkClass="'page-link-item'">
                          </paginate>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
            <!-- <b-tab title="Email Case Log" @click="switchTab('Email Case')">
              <div class="card-body" v-if="activeComponent == 'Email Case'">
                <div>
                  <div class="rowFullTable" v-if="emailCaseLog.length">
                    <table class="table table-fixed table-hover tableFixHeadBottom table-text-cente">
                      <thead class="table-head">
                        <th class="row-ID">Case ID</th>
                        <th class="row-Desc">Allocation Type</th>
                        <th class="row-incident-level">Created By</th>
                        <th class="row-Date">Created Date</th>
                        <th class="row-Date">Email Status</th>
                        <th class="row-ID">Comment</th>
                        <th>Email Preview</th>
                      </thead>
                      <tbody class="position-relative">
                        <tr v-for="(emailCase,index) in emailCaseLog">
                          <td><span>{{emailCase.caseid}}</span></td>
                          <td><span>{{emailCase.allocationtype || '-'}}</span></td>
                          <td><span>{{emailCase.createdby}}</span></td>
                          <td><span>{{emailCase.createddate | dateFilter}}</span></td>
                          <td><span>{{emailCase.status}}</span></td>
                          <td><span>{{emailCase.comment}}</span></td>
                          <td> <span v-if="emailCase.caseid && emailCase.status && emailCase.status.toLowerCase() ==='close'">
                               <EmailPreview :setCaseID="[emailCase.caseid]" :buttonType="'eye'">Preview</EmailPreview>
                              </span>
                              <span v-else>-</span>
                          </td>
                        </tr>
                        <tr v-if="emailCaseLog.length==0">
                          <td colspan="7" align="center">Records not found</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </b-tab> -->
          </b-tabs>
        </div>
        <!--  Search Modal End-->
      </div>
    </div>

    <b-modal size="vlg" v-model="isSearchModal_1" :no-enforce-focus="true">
      <div class="col-lg-12" id="printPoContent" v-show="isSearchModal_1">
        <div class="rowFullTable" v-if="emailCaseLog.length">
          <table class="table table-fixed table-hover tableFixHeadBottom table-text-cente">
            <thead class="table-head">
              <th class="row-ID">Case ID</th>
              <th class="row-Desc">Allocation Type</th>
              <th class="row-incident-level">Created By</th>
              <th class="row-Date">Created Date</th>
              <th class="row-Date">Email Status</th>
              <th class="row-ID">Comment</th>
             <!-- <th>Email Preview</th>-->
              <th><button type="button" aria-label="Close" @click="isSearchModal_1=close"
              class="close">×</button></th>
            </thead>
            <tbody class="position-relative">
              <tr v-for="(emailCase,index) in emailCaseLog">
                <td><span>{{emailCase.caseid}}</span></td>
                <td><span>{{emailCase.allocationtype || '-'}}</span></td>
                <td><span>{{emailCase.createdby}}</span></td>
                <td><span>{{emailCase.createddate | dateFilter}}</span></td>
                <td><span>{{emailCase.status}}</span></td>
                <td><span>{{emailCase.comment}}</span></td>
               <!-- <td> <span v-if="emailCase.caseid && emailCase.status && emailCase.status.toLowerCase() ==='close'">
                      <EmailPreview :setCaseID="[emailCase.caseid]" :buttonType="'eye'">Preview</EmailPreview>
                    </span>
                    <span v-else>-</span>
                </td>-->
              </tr>
              <tr v-if="emailCaseLog.length==0">
                <td colspan="7" align="center">Records not found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-modal>
    <!-- <b-modal size="vlg" v-model="isSearchModal" :no-enforce-focus="true">
      <div class="col-lg-12" id="printPoContent" v-show="isSearchModal">
        <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        <b-card style="background-color: transparent; border: 0px solid transparent; margin-bottom: 0;">
          <h5 class="modal-title" style="display: inline;">Search</h5>
          <button type="button" aria-label="Close" @click="isSearchModal=false" class="close">×</button>
            <div class="card-body modal-content">
              <form @submit.prevent="applyFilter()" class="">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-sm-3">
                        <div role="group" class="form-group">
                          <label class="col-form-label"> From Date : </label>
                          <date-picker style="width: 100%;" lang="en" type="date" :required="!filter.caseid && !filter.fromemail && !filter.fcaccountid" v-model='filter.fromDate' :not-after="filter.toDate" v-on:change="onChange"></date-picker>
                        </div>
                      </div>
                      <div class="col-sm-3">
                        <div role="group" class="form-group">
                         <label class="col-form-label"> To Date : </label>
                         <date-picker style="width: 100%;" lang="en" :required="!filter.caseid && !filter.fromemail && !filter.fcaccountid" type="date" v-model='filter.toDate' :not-before="filter.fromDate" :not-after="maxToDate" v-on:change="onChange"></date-picker>
                        </div>
                      </div>
                       <div class="col-3">
                        <div role="group" class="form-group">
                           <label  class="col-form-label">Status</label>
                            <select v-model="filter.status" class="form-control">
                              <option value="">--Select--</option>
                              <option value="allocationpending" v-if="userRole.toLowerCase() !== 'associate'">AllocationPending</option>
                              <option value="allocated">Allocated</option>
                              <option value="inprocess">InProcess</option>
                              <option value="followup">Follow up</option>
                              <option value="close">Close</option>
                              <option value="spam">Spam</option>
                              <option value="trash" v-if="userRole.toLowerCase() !== 'associate'">Trash</option>
                            </select>
                        </div>
                      </div>
                       <div class="col-sm-3">
                        <div role="group" class="form-group">
                          <label class="col-form-label"> Agent : </label>
                           <select v-model="filter.agent" v-if="userRole.toLowerCase() !== 'associate'" class="form-control">
                            <option value="">All</option>
                            <option :value="agent" v-for="(agent,index) in activeAgents" :key="index">{{agent}}</option>
                          </select>
                          <select v-model="filter.agent" v-if="userRole.toLowerCase() === 'associate'" class="form-control">
                            <option :value="filter.agent">{{filter.agent}}</option>
                          </select>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-3">
                        <div role="group" class="form-group">
                         <label class="col-form-label"> Email Case ID : </label>
                         <input type="text" placeholder="Enter Case ID" class="form-control" v-model.trim="filter.caseid" @keypress="checkIsNumber()">
                        </div>
                      </div>

                      <div class="col-3">
                        <div role="group" class="form-group">
                         <label class="col-form-label"> Email From : </label>
                        <input type="email" class="form-control" placeholder=" Enter Email From" v-model.trim="filter.fromemail">
                        </div>
                      </div>

                      <div class="col-3">
                        <div role="group" class="form-group">
                         <label class="col-form-label"> Email To : </label>
                        <input type="email" class="form-control" placeholder=" Enter Email To" v-model.trim="filter.toemail">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-3">
                        <div role="group" class="form-group">
                        <label class="col-form-label"> Email CC : </label>
                       <input type="email" class="form-control" placeholder=" Enter Email CC" v-model.trim="filter.ccemail">
                          </div>
                          </div>
                      <div class="col-sm-3">
                        <div role="group" class="form-group">
                        <label  class="col-form-label">Email Subject</label>
                        <input type="text" class="form-control" placeholder=" Enter Email Subject" v-model.trim="filter.subject">
                        </div>
                      </div>

                      <div class="col-3">
                        <div role="group" class="form-group">
                        </div>
                      </div>
                       <div class="col-3">
                        <div role="group" class="form-group">
                          <div>
                            <button type="submit" class="btn btn-primary" variant="primary" name="searchButton" size="sm">Search</button>
                            <button type="button" class="btn btn-danger" @click="resetFilter()" size="sm"> Reset </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </form>
            </div>
        </b-card>
      </div>
    </b-modal> -->
    <!-- Raise Ticket Modal -->
    <b-modal size="vlg" ref="modal" @show="resetModal"
      @hidden="resetModal" v-model="isTicketModal" :no-close-on-backdrop="true">
      <loading :active.sync="isModalLoading" :is-full-page="fullPage"></loading>
      <div>
        <b-card>
          <h5 class="modal-title">Raise Ticket</h5>
          <button type="button" aria-label="Close" @click="resetraiseticketform()" style="display: inline;position: relative;bottom: 30px;" class="close">×</button>
          <div class="card-body modal-content">
            <div v-if="shipmentResult === false && shipments.length == 0 && ticketResultMsg == ''">
              <form ref="form" @submit.stop.prevent="handleSubmit">
                <div class="row">
                  <div class="col-sm-12">
                    <b-form-group
                      label="Enter Shipping Ids"
                      label-for="name-input"
                      invalid-feedback="Shipping Ids is required"
                      :state="shippingIdState">
                      <textarea v-model="shippingIds" name="shippingIds" id="shippingIds" required rows="5" cols="20" style="width:100%;height: auto;" @change="formatShipments"></textarea>
                    </b-form-group>
                  </div>
                </div>
                <div role="group" class="form-group">
                  <div>
                    <button type="submit" class="btn btn-primary" variant="primary" name="searchButton" size="sm">Submit</button>
                    <button type="button" class="btn btn-danger" @click="resetShipment()" size="sm"> Reset </button>
                  </div>
                </div>
              </form>
            </div>
            <div v-else-if="shipmentResult === true && shipments.length > 0 && ticketResultMsg == ''">
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-1 variant="info">Result</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                      <span v-if="validShippingIds.length>0"><b>Valid Shipping Ids</b> : <font color="green">{{validShippingIds.join(', ')}} </font></span> <br/>
                        <span v-if="invalidShippingIds.length>0"><b>Invalid Shipping Ids</b>: <font color="red">{{invalidShippingIds.join(', ')}}</font></span>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="info">Raise Ticket</b-button>
                  </b-card-header>
                  <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                    <b-card-body>
                        <div class="row form-group">
                          <div class="col-2">
                              <div role="group" class="mb-0 form-group">
                                <label>Business Flow : </label>
                              </div>
                            </div>
                            <div class="col-3">
                              <div role="group" class="mb-0 form-group">
                                <select v-model="businessFlow" class="form-control" @change="getBusinessFlow">
                                  <option value="">--Select--</option>
                                  <option value="Forward">Forward</option>
                                  <option value="Reverse">Reverse</option>
                                </select>
                              </div>
                            </div>
                            <div class="col-2">
                              <div role="group" class="mb-0 form-group">
                                <label>Search Tagging :  </label>
                              </div>
                            </div>
                            <div class="col-3">
                              <div role="group" class="mb-0 form-group">
                                <basic-select :options="searchOptions" v-model="searchId" :selected-option="selectedSearchObj"
                                placeholder="Search Tag" @select="selectedSearchTag">
                              </basic-select>
                              </div>
                            </div>
                        </div>
                        <div class="row form-group">
                            <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Source <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <basic-select :options="source" v-model="sourceId" :selected-option="selectedSourceObj"
                              placeholder="Select Source" @select="selectedSource">
                            </basic-select>
                            </div>
                          </div>

                            <!-- Address change feature -->
                          <div class="col-2">
                             <div role="group" class="mb-0 form-group">
                                <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                      || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                      || selectedSubReasonObj.text == 'Redirect to Bank' )
                                      && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED )">
                                <label class="label_text">Address : </label>
                                </div>
                              </div>
                          </div>

                            <div class="col-3">
                               <div role="group" class="mb-0 form-group">
                                  <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                      || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                      || selectedSubReasonObj.text == 'Redirect to Bank' )
                                      && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED )">

                                 <b-form-textarea v-model="address" name="address" placeholder=""
                                  v-validate="'required|min:3|max:200'" 
                                  ></b-form-textarea>
                                   </div>
                                <i v-show="errors.has('address')" class="fa fa-warning"></i>
                                <span v-show="errors.has('address')" class="help is-danger">{{ errors.first('address')
                                  }}</span>
                                
                              </div>
                            </div>
                            <!-- Address change feature -->

                             
                          </div>

                          <div class="row form-group">

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Ticket Type <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="ticketType" v-model="ticketTypeId" :selected-option="selectedTicketObj"
                                placeholder="Select Ticket" @select="selectedTicket"></basic-select>
                            </div>
                          </div>
               
                            <!-- Address(Pincode) change feature -->

                           <div class="col-2">
                              <div role="group" class="mb-0 form-group">
                                <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                    || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                    || selectedSubReasonObj.text == 'Change misroute pincode' || selectedSubReasonObj.text == 'Redirect to Bank'
                                    || selectedSubReasonObj.value == CHANGE_RTO_PINCODE || selectedSubReasonObj.value == CHANGE_DELIVERY_PINCODE
                                    || selectedSubReasonObj.value == CHANGE_DTO_PINCODE || selectedSubReasonObj.value == CHANGE_PICKUP_PINCODE )
                                    && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED)">
                                <label class="label_text">PinCode :</label>
                                </div>
                              </div>
                            </div>

                            <div class="col-3">
                              <div role="group" class="mb-0 form-group">
                                <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                    || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                    || selectedSubReasonObj.text == 'Change misroute pincode' || selectedSubReasonObj.text == 'Redirect to Bank'
                                    || selectedSubReasonObj.value == CHANGE_RTO_PINCODE || selectedSubReasonObj.value == CHANGE_DELIVERY_PINCODE
                                    || selectedSubReasonObj.value == CHANGE_DTO_PINCODE || selectedSubReasonObj.value == CHANGE_PICKUP_PINCODE )
                                    && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED)">
                                  <b-form-input name="pincode" v-model="pincode" placeholder=""
                                  v-validate="'required|numeric|digits:6'"
                                  :class="{'input': true, 'is-danger': errors.has('pincode') }"
                                 ></b-form-input>

                                <i v-show="errors.has('pincode')" class="fa fa-warning"></i>
                               
                                <!---- <button class="btn btn-primary cst_btn" id="pincodeservicable"
                                v-on:click.prevent="checkPinCodeServiceable"
                                style="width: 20%;float: right;margin-right: -284px;">Validate</button> --->

                                <span v-show="errors.has('pincode')" class="help is-danger">{{ errors.first('pincode')
                                  }}</span>
                                  </div>

                              </div>
                            </div>
                          <!-- Address(Pincode) change feature -->



                        </div>

                        <div class="row form-group">
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Reason <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="reason" v-model="reasonId" :selected-option="selectedReasonObj"
                                    placeholder="Select Reason" @select="selectedReason">
                                  </basic-select>
                            </div>
                          </div>

                          <div class="col-2" v-if="( selectedReasonObj.text == 'Arrange delivery' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (selectedReasonObj.text == 'Non Behavioral' && selectedSubReasonObj.text =='Delay in service' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'SR related' && selectedSubReasonObj.text == 'Fake update' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'Arrange pickup'  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (( selectedSubReasonObj.value == FAKE_NDR || selectedSubReasonObj.value == REFUSED_DOORSTEP_DELIVERY
                                    || selectedSubReasonObj.value == DELAY_IN_PICKUP_SUB_REASON || selectedSubReasonObj.value == FAKE_NPR  || selectedSubReasonObj.value == CHANGE_REATTEMPT_DATE
                                    || selectedSubReasonObj.value == FAKE_PICKUP || selectedSubReasonObj.value == DENIED_PICKUP )  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM  )">
                            <div role="group" class="mb-0 form-group">
                              <label>Reattempt Date <span class="compRedCss">*</span> :</label>
                            </div>
                          </div>
                          <div class="col-3" v-if="( selectedReasonObj.text == 'Arrange delivery' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (selectedReasonObj.text == 'Non Behavioral' && selectedSubReasonObj.text =='Delay in service' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'SR related' && selectedSubReasonObj.text == 'Fake update' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'Arrange pickup'  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (( selectedSubReasonObj.value == FAKE_NDR || selectedSubReasonObj.value == REFUSED_DOORSTEP_DELIVERY
                                    || selectedSubReasonObj.value == DELAY_IN_PICKUP_SUB_REASON || selectedSubReasonObj.value == FAKE_NPR  || selectedSubReasonObj.value == CHANGE_REATTEMPT_DATE
                                    || selectedSubReasonObj.value == FAKE_PICKUP || selectedSubReasonObj.value == DENIED_PICKUP )  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM  )">
                            <div role="group" class="mb-0 form-group">
                              <date-picker v-model="reAttemptDate" lang="en" type="date" :format="format"
                                    :not-before="startDate" :not-after="endDate"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                            <!-- ALternate mobile number -->
                             <div class="col-2">
                             <div role="group" class="mb-0 form-group">
                             <div
                                v-if="(( selectedSubReasonObj.value == UPDATE_ALTERNATE_CONTACT_NO && ( selectedActionObj.value == CONTACT_DETAILS_UPDATED || selectedActionObj.value == ASSIGNED_CS_TEAM ) )
                                || (( selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                || selectedSubReasonObj.text == 'Redirect to Bank' ) && ticketTaggingDisplay==false && alternateContactNo != null && ( selectedActionObj.value == ASSIGNED_CS_TEAM || this.selectedActionObj.value == ADDRESS_UPDATED ) ) )">
                                <label class="label_text">Alternate No :</label>
                                </div>
                              </div>
                          </div>
                            <div class="col-3">
                               <div role="group" class="mb-0 form-group">
                             <div
                                v-if="(( selectedSubReasonObj.value == UPDATE_ALTERNATE_CONTACT_NO && ( selectedActionObj.value == CONTACT_DETAILS_UPDATED || selectedActionObj.value == ASSIGNED_CS_TEAM ) )
                                || (( selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                || selectedSubReasonObj.text == 'Redirect to Bank' ) && ticketTaggingDisplay==false && alternateContactNo != null && ( selectedActionObj.value == ASSIGNED_CS_TEAM || this.selectedActionObj.value == ADDRESS_UPDATED ) ) )">

                               <b-form-input name="alternateContactNo" v-model="alternateContactNo"
                                v-validate="'required|digits:10|min:10|max:10'" placeholder=""
                                ></b-form-input>
                                   </div>
                                <i v-show="errors.has('alternateContactNo')" class="fa fa-warning"></i>
                                <span v-show="errors.has('alternateContactNo')" class="help is-danger">{{
                                  errors.first('alternateContactNo') }}</span>
                                
                              </div>
                            </div>
                            <!-- END ALternate mobile number -->
                        </div>
                        <div class="row form-group">
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Sub Reason <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="subReason" name="subReasonId" v-model="subReasonId"
                                :selected-option="selectedSubReasonObj" placeholder="Select Sub Reason"
                                @select="selectedSubReason"></basic-select>
                            </div>
                          </div>

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Resolution / Action <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="action" v-model="actionId" placeholder="Select Action"
                                :selected-option="selectedActionObj" @select="selectedAction"></basic-select>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group" v-if="shouldShowLabel">
                          <!-- #emailer_srid SR ID -->
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>SR ID  <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <basic-select :options="SRIDs" v-model="SRIDsId" placeholder="Select SR ID" :selected-option="selectedSRIDnObj"
                              @select="selectedSRID"></basic-select>
                            </div>
                          </div>

                          <!-- #emailer_srid SR Name -->
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>SR Name <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <basic-select :options="SRNames" v-model="SRNameId" placeholder="Select SR Name" :selected-option="selectedSRNamenObj"
                               @select="selectedSRName"></basic-select>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Ticket Status <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="ticketStatus" v-model="ticketStatusId" placeholder="Select Action"
                                :selected-option="selectedTicketStatusObj" @select="selectedTicketStatus"></basic-select>
                            </div>
                          </div>

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Comments <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-5">
                            <div role="group" class="mb-0 form-group">
                                <b-form-textarea v-model="comments" name="comments" placeholder="" v-validate="'min:3|max:300'"
                              rows="5"></b-form-textarea>
                            </div>
                          </div>
                        </div>
                          <div class="card c-email-app">
                          <div class="card-body">
                            <div>
                              
                              <div class="form-row mb-3">
                                  <label for="to" class="col-2 col-sm-1 col-form-label">Preview:</label>
                                  <div><p v-if="userRole.toLowerCase() === 'associate' ">

                                  <EmailPreviewRaiseTicket :setCaseID="[caseObj.caseid]" :buttonType="'eye'" >Preview </EmailPreviewRaiseTicket>
                                </p>
                                  </div>
                                </div>
                              <!-- <EmailPreviewRaiseTicket :setCaseID="[caseObj.caseid]" :buttonType="'eye'" >Preview </EmailPreviewRaiseTicket> -->
                                <div class="form-row mb-3">
                                  <label for="to" class="col-2 col-sm-1 col-form-label">From:</label>
                                  <div cols="12" class="col-sm-11">{{this.emailFrom}}</div>
                                </div>
                                <div class="form-row mb-3">
                                  <label for="to" class="col-2 col-sm-1 col-form-label">To:</label>
                                  
                                  <!-- <div cols="12" class="col-sm-11" v-if="caseObj.email != null || caseObj.replyto == this.emailFrom">
                                    <input type="email" name="to_email"  v-validate="'required|email'" id="to_email" placeholder="Type email" v-model="caseObj.email" class="form-control" >
                                    <i v-show="errors.has('to_email')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('to_email')" class="help is-danger">{{ errors.first('to_email') }}</span>
                                  </div> -->
                                  <!-- <div cols="12" class="col-sm-11" v-else> -->
                                  <div cols="12" class="col-sm-11">
                                    <input type="email" name="to_email"  v-validate="'required|email'" id="to_email" placeholder="Type email" v-model="caseObj.fromid" class="form-control">
                                    <i v-show="errors.has('to_email')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('to_email')" class="help is-danger">{{ errors.first('to_email') }}</span>
                                  </div>

                                </div>
                                <div class="form-row mb-3">
                                  <label for="cc" class="col-2 col-sm-1 col-form-label">CC:</label>
                                  <div cols="12" class="col-sm-11">
                                    <!-- <input type="email" name="cc_email" v-validate="'required|email'" id="cc_email" v-model="replyTocc" class="form-control"> -->
                                    <textarea name="replyTocc1" id="replyTocc1" v-model="replyTocc1" class="form-control"
                                    placeholder="Default - abcd@xpressbees.com" rows="2" cols="125" ></textarea>
                                    <small>To Add multiple Email ID give comma(,)</small>
                                    <!-- <i v-show="errors.has('cc_email')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('cc_email')" class="help is-danger">{{ errors.first('cc_email') }}</span> -->
                                  </div>
                                </div>
                                <b-alert show v-if='invalidEmailFlag' variant="danger">
                                    Invalid Email Ids<br>
                                    {{invalidEmail}}
                                </b-alert>

                              <div class="row">
                                <label for="cc" class="col-2 col-sm-2 col-form-label">Attachment:</label>
                                <div cols="12" class="col-sm-6">
                                    <input id="image-file" type="file" multiple/>
                                </div>
                              </div>
                              <div class="row">
                                <label data-v-685aa076="" for="message" class="col-1 col-sm-2 col-form-label">Message:</label>
                                <div class="ml-auto col-sm-11">
                                  <div class="form-group mt-4">
                                      <wysiwyg id="message" name="message" v-model="reply"></wysiwyg>
                                    <i v-show="errors.has('message')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <button class="btn btn-success"
                                :disabled="validated ? '' : ticket.disabled || errors.any()" 
                                v-on:click.prevent="saveBulkClick"><i class="fa fa-save"></i> Save</button>
                              <button class="btn btn-danger" v-on:click.prevent="resetAddTicket"><i class="fa fa-refresh"></i> Reset</button>
                            </div>
                          </div>
                        </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>
            <div v-else-if="shipmentResult == true && shipments.length === 0 && invalidShippingIds.length > 0 && validShippingIds.length == 0">
                <span>Invalid Shipping Ids: {{invalidShippingIds.join(', ')}}</span>
            </div>
            <div v-else-if="ticketResultMsg == '' && shipmentResult === true && shipments.length === 0 && invalidShippingIds.length === 0">
                <span>Invalid Shipping Ids: {{invalidShippingIds.join(', ')}}</span>
            </div>
            <div v-if="ticketResultMsg!= ''" v-html="ticketResultMsg">{{ticketResultMsg}}</div>
            
            <!-- Existing Update functionality -->
            <!-- <div><button style="margin-top: auto;" v-if="ticket.length>0" class="btn btn-primary"
              @click="listExisitngTicketModal=true;updateExistingBulkTicket=true;showBulkTicketDiv=false;">Update
              Ticket</button>
            </div> -->
            
            <div><button style="margin-top: auto;" v-if="ticket.length>0" class="btn btn-primary"
              @click="listExisitngTicketModal=true;updateExistingBulkTicket=true;showBulkTicketDiv=false;">Update
              Ticket </button>
            </div>
          </div>
        </b-card>
      </div>
    </b-modal>

    <!-- Raise Ticket Modal -->
    <b-modal size="vlg" ref="modal" @show="resetModal"
      @hidden="resetModal" v-model="isTicketModal1" :no-close-on-backdrop="true">
      <loading :active.sync="isModalLoading" :is-full-page="fullPage"></loading>
      <div>
        <b-card>
          <h5 class="modal-title">Raise Ticket</h5>
          <button type="button" aria-label="Close" @click="resetraiseticketform()" class="close">×</button>
          <div class="card-body modal-content">
             <div v-html="ticketResultMsg1"> {{ticketResultMsg1}} </div>
          </div>
        </b-card>
      </div>
    </b-modal>

    <!-- View Ticket Modal -->
    <b-modal size="vlg" ref="modal" v-model="showDetails">
      <loading :active.sync="isModalLoading" :is-full-page="fullPage"></loading>
      <div>
        <b-card>
            <h5 class="modal-title" style="display: inline-block;">Tickets</h5>
            <!-- <h5 style="display: inline;color: #fa8a00;margin-left: 30%;">Shipment Id : <span class="modal_ship_id">{{allTickets_shippingid}}</span></h5> -->
            <button type="button" aria-label="Close"@click="resetUpdateTicketModal()" class="close">×</button>
            <div class="card-body modal-content">
               <table class="table table-fixed table-hover table-bordered tableFixHeadBottom table-text-cente">
                  <thead class="table-head">
                    <th class="text-center tableheader" bind-title="Select All">
                      <input type="checkbox" v-model="selectAllRecord" @click="selectAllCheckbox">
                    </th>
                    <th class="row-ID">Ticket Id</th>
                    <th class="row-ID"><b>Shipping ID</b></th>
                    <th class="row-Date">Created Date</th>
                    <th class="row-ID">Source</th>
                    <th class="row-Desc">Ticket Type</th>
                    <th class="row-incident-level">Reason</th>
                    <th class="row-Date">Sub Reason</th>
                    <th class="row-Date">Resolution</th>
                    <th class="row-Date">Created By</th>
                    <th  v-if="userRole.toLowerCase() === 'associate' " class="row-Date">Action</th>

                    <th class="row-ID">Status</th>
                    <th class="row-Date">Ticket Log</th>
                  </thead>
                  <tbody class="position-relative" v-if="emailCasesArray[currentCaseId] && emailCasesArray[currentCaseId].allTickets">
                    <tr v-for="(ticket,index) in emailCasesArray[currentCaseId].allTickets">
                      <td>
                    <input style="margin-left:7px;" :value="ticket.ticketid" :id="ticket.ticketid" v-model="ticketIDS"
                    @click="selectTicket( ticket, index, $event )" type="checkbox">
                    </td>
                      <td>{{ticket.ticketid}}</td>
                      <td>{{ticket.shippingid}}</td>
                      <!-- <td>{{formatDatey(ticket.createddate)}}</td> -->
                      <td>{{ticket.createddate | formatDatesingle}}</td>
                                               <td>{{ticket.source}}</td>
                      <td>{{ticket.maintype}}</td>
                      <td>{{ticket.subtype}}</td>
                      <td>{{ticket.typename}}</td>
                      <td v-if="userRole.toLowerCase() === 'associate'">{{ticket.action}}</td>
                      <td>{{ticket.createdby}}</td>
                       <td>
                        <button class="btn btn-primary" :disabled="disablebtn"  @click="delayButtonClick( ticket )"
                        v-if="ticket.ticketstatus != 'Closed' "><i class="fa fa-upload"></i> Update</button>
 
                       <button class="btn btn-primary" :disabled="disablebtn" @click="delayButtonClick( ticket )"
                        v-if="ticket.ticketstatus == 'Closed' && ticket.clientid != null"><i class="fa fa-folder-open" aria-hidden="true"></i>Reopen</button>
                      </td>
                      <td>{{ticket.ticketstatus}}</td>
                      <td><button class="btn btn-primary" @click="getemailerTicketHistory(ticket)"><i class="fa fa-eye"></i> View</button></td>
                    </tr>
                  </tbody>
                </table>
            </div>
        </b-card>
      </div>
    </b-modal>

    <b-modal size="vlg" v-model="TicketLogModal1" :no-enforce-focus="true">
    <div class="col-lg-12" id="printPoContent" v-show="TicketLogModal1">
      <b-card style="background-color: transparent; border: 0px solid transparent;">
        <h6 class="modal-title" style="display: inline-block;">Ticket log</h6>
        <h5 class="ship_id_head">Ticket Id : <span class="modal_ship_id">{{ticketIDLog}}</span></h5>
        <button type="button" aria-label="Close" @click="TicketLogModal1=false" class="close">×</button>
        <div class="card-body">
          <div class="row rowFullTable">
            <div class="col-sm-12 col-xs-12 col-md-6 col-lg-12">
              <table class="table table-responsive table-bordered">
                <thead class="table-head">
                  <th>Last updated on</th>
                  <th>Resolution</th>
                  <th>Ticket Status</th>
                  <th>Comments</th>
                </thead>
                <tbody class="scrollDivCls" >
                  <!-- <tr v-if="resultTicket.length > 0" v-for="(ticket,index) in resultTicket"> -->
                  <tr v-for="(ticket,index) in resultTicket">
                    <td>{{ticket.createddate | formatDatesingle}}</td>
                    <td>{{ticket.action}}</td>
                    <td>{{ticket.ticketstatus}}</td>
                    <td>{{ticket.comments}}</td>
                  </tr>
                  <!-- <tr v-if="resultTicket.length==0">
                  <td colspan="10" align="center">Ticket Logs not found</td>
                  </tr> -->
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    </b-modal>
    <!-- Update Ticket MOdal -->
    <b-modal size="vlg" v-model="listExisitngTicketModal" style="border-radius: 5px;" :no-enforce-focus="true">
      <loading :active.sync="isModalLoading"></loading>
      <div class="col-lg-12" id="printPoContent" style="padding: 5px;">
      <b-card style="background-color: transparent; border: 0px solid transparent; margin-bottom: 0;">
        <h5 class="modal-title" style="display: inline;">Update Ticket</h5>
        <button type="button" aria-label="Close" @click="resetUpdateTicketModal(),listExisitngTicketModal=false;"
          class="close">×</button>
        <div class="card-body modal-content" style="padding: 10px;">
          <div class="row">
            <div class="col-md-12 cardlistheader" style="text-align:right;">
              <button type="button" class="btn btn-primary cst_btn" id="show-modal" v-show="updateExistingBulkTicket"
                @click="openUpdateTicketModal();">Update Ticket</button>
              <button type="button" class="btn btn-primary cst_btn" v-if="updateExistingBulkTicket==false"
                @click="updateExistingBulkTicket=true;showBulkTicketDiv=false;">Back</button>
            </div>
            <div class="col-md-12 col-lg-12" v-show="updateExistingBulkTicket" style="margin-left:0px;">
              <table class="table-bordered datatables cardtable tableFixHeadBottom">
                <thead class="table-head">
                  <tr class="text-primary cardreporttablerow">
                    <th class="text-center tableheader" bind-title="Select All">
                      <input type="checkbox" v-model="selectAllRecord" @click="selectAllCheckbox">
                    </th>
                    <th class="text-center tableheader"><b>Shipping ID</b></th>
                    <th class="text-center tableheader"><b>Ticket ID</b></th>
                    <th class="text-center tableheader"><b>Source</b></th>
                    <th class="text-center tableheader"><b>Ticket Type</b></th>
                    <th class="text-center tableheader"><b>Reason</b></th>
                    <th class="text-center tableheader"><b>Sub reason</b></th>
                    <th class="text-center tableheader"><b>Action</b></th>
                    <th class="text-center tableheader"><b>Ticket Status</b></th>
                    <th class="text-center tableheader"><b>Created Date</b></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- <tr v-for="zobj in scawshipments"> -->
                  <tr v-if="ticket.length>0" v-for="( data, index ) in ticket">
                    <td>
                      <input style="margin-left:7px;" :value="data.ticketid" :id="data.ticketid" v-model="ticketIDS"
                        @click="selectTicket( data, index, $event )" type="checkbox">
                    </td>
                    <td>{{data.shippingid}}</td>
                    <td>{{data.ticketid}}</td>
                    <td>{{data.source}}</td>
                    <td>{{data.maintype}}</td>
                    <td>{{data.subtype}}</td>
                    <td>{{data.typename}}</td>
                    <td>{{data.action}}</td>
                    <td>{{data.ticketstatus}}</td>
                    <td>{{data.createddate | formatDate}}</td>
                  </tr>
                  <tr v-if="ticket.length==0">
                    <td colspan="19" align="center">Data not found</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="col-lg-12" id="bulkEditTicketDiv" v-show="showBulkTicketDiv" style="width: 1170px !important;">
              <b-card-body>
                <div class="row form-group">
                    <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Source <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                      <basic-select :options="source" v-model="sourceId" :selected-option="selectedSourceObj"
                      placeholder="Select Source" @select="selectedSource">
                    </basic-select>
                    </div>
                  </div>

                  <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Ticket Type <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                        <basic-select :options="ticketType" v-model="ticketTypeId" :selected-option="selectedTicketObj"
                        placeholder="Select Ticket" @select="selectedTicket"></basic-select>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Reason <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                        <basic-select :options="reason" v-model="reasonId" :selected-option="selectedReasonObj"
                            placeholder="Select Reason" @select="selectedReason">
                          </basic-select>
                    </div>
                  </div>

                  <div class="col-2" v-if="( selectedReasonObj.text == 'Arrange delivery' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || (selectedReasonObj.text == 'Non Behavioral' && selectedSubReasonObj.text =='Delay in service' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || ( selectedReasonObj.text == 'SR related' && selectedSubReasonObj.text == 'Fake update' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || ( selectedReasonObj.text == 'Arrange pickup'  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || (( selectedSubReasonObj.value == FAKE_NDR || selectedSubReasonObj.value == REFUSED_DOORSTEP_DELIVERY
                            || selectedSubReasonObj.value == DELAY_IN_PICKUP_SUB_REASON || selectedSubReasonObj.value == FAKE_NPR  || selectedSubReasonObj.value == CHANGE_REATTEMPT_DATE
                            || selectedSubReasonObj.value == FAKE_PICKUP || selectedSubReasonObj.value == DENIED_PICKUP )  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM  )">
                    <div role="group" class="mb-0 form-group">
                      <label>Reattempt Date <span class="compRedCss">*</span> :</label>
                    </div>
                  </div>
                  <div class="col-3" v-if="( selectedReasonObj.text == 'Arrange delivery' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || (selectedReasonObj.text == 'Non Behavioral' && selectedSubReasonObj.text =='Delay in service' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || ( selectedReasonObj.text == 'SR related' && selectedSubReasonObj.text == 'Fake update' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || ( selectedReasonObj.text == 'Arrange pickup'  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                            || (( selectedSubReasonObj.value == FAKE_NDR || selectedSubReasonObj.value == REFUSED_DOORSTEP_DELIVERY
                            || selectedSubReasonObj.value == DELAY_IN_PICKUP_SUB_REASON || selectedSubReasonObj.value == FAKE_NPR  || selectedSubReasonObj.value == CHANGE_REATTEMPT_DATE
                            || selectedSubReasonObj.value == FAKE_PICKUP || selectedSubReasonObj.value == DENIED_PICKUP )  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM  )">
                    <div role="group" class="mb-0 form-group">
                      <date-picker v-model="reAttemptDate" lang="en" type="date" :format="format"
                            :not-before="startDate" :not-after="endDate"></date-picker>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Sub Reason <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                        <basic-select :options="subReason" name="subReasonId" v-model="subReasonId"
                        :selected-option="selectedSubReasonObj" placeholder="Select Sub Reason"
                        @select="selectedSubReason"></basic-select>
                    </div>
                  </div>

                  <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Resolution / Action <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                        <basic-select :options="action" v-model="actionId" placeholder="Select Action"
                        :selected-option="selectedActionObj" @select="selectedAction"></basic-select>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Ticket Status <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                        <basic-select :options="ticketStatus" v-model="ticketStatusId" placeholder="Select Action"
                        :selected-option="selectedTicketStatusObj" @select="selectedTicketStatus"></basic-select>
                    </div>
                  </div>

                  <div class="col-2">
                    <div role="group" class="mb-0 form-group">
                      <label>Comments <span class="compRedCss">*</span> : </label>
                    </div>
                  </div>
                  <div class="col-5">
                    <div role="group" class="mb-0 form-group">
                        <b-form-textarea v-model="comments" name="comments" placeholder="" v-validate="'min:3|max:300'"
                      rows="5"></b-form-textarea>
                    </div>
                  </div>
                </div>
                <div class="row form-group">
                  <div class="col-3">
                    <div role="group" class="mb-0 form-group">
                      <button class="btn btn-success"
                        :disabled="validated ? '' : ticket.disabled || errors.any()" 
                        v-on:click.prevent="saveBulkEditShipment">Save</button>
                      <button class="btn btn-danger" v-on:click.prevent="resetAddTicket">Reset</button>
                    </div>
                  </div>
                </div>
              </b-card-body>
            </div>
          </div>
        </div>
      </b-card>
    </div>
    </b-modal>
    <!-- Auto Reply Modal -->
    <b-modal size="vlg" v-model="autoReplyModal" ref="modal">
      <loading :active.sync="isModalLoading" :is-full-page="fullPage"></loading>
      <div>
        <b-card>
            <h5 class="modal-title">Auto Reply</h5>
            <button type="button" aria-label="Close" @click="autoReply()" style="display: inline;position: relative;bottom: 30px;" class="close">×</button>
            <div class="card-body modal-content">
            <form ref="form" @submit.stop.prevent="sendAutoReply" enctype="multipart/form-data">

            <div class="form-row mb-3">
              <label for="to" class="col-2 col-sm-1 col-form-label">To:</label>

                  <!-- <div cols="12" class="col-sm-11" v-if="caseObj.email != null">
                    <input type="email" name="to_email"  v-validate="'required|email'" id="to_email" placeholder="Type email" v-model="caseObj.fromid" class="form-control" >
                    <i v-show="errors.has('to_email')" class="fa fa-warning"></i>
                    <span v-show="errors.has('to_email')" class="help is-danger">{{ errors.first('to_email') }}</span>
                  </div> -->
                  <!-- <div cols="12" class="col-sm-11" v-else> -->
                  <div cols="12" class="col-sm-11">
                    <input type="email" name="to_email"  v-validate="'required|email'" id="to_email" placeholder="Type email" v-model="caseObj.fromid" class="form-control" >
                    <i v-show="errors.has('to_email')" class="fa fa-warning"></i>
                    <span v-show="errors.has('to_email')" class="help is-danger">{{ errors.first('to_email') }}</span>
                  </div>


            </div>
            <!-- <div class="form-row mb-3">
              <label for="cc" class="col-2 col-sm-1 col-form-label">CC:</label>
              <div cols="12" class="col-sm-11">
              <input type="email" name="cc_email" v-validate="'email'" id="cc_email" v-model="replyToccAutoreply" class="form-control">
              <i v-show="errors.has('cc_email')" class="fa fa-warning"></i>
              <span v-show="errors.has('cc_email')" class="help is-danger">{{ errors.first('cc_email') }}</span>
            </div>
            </div> -->
            <div class="form-row mb-3">
              <label for="cc" class="col-2 col-sm-1 col-form-label">CC:</label>
              <div cols="12" class="col-sm-11">
                <textarea name="replyTocc1" id="replyTocc1" v-model="replyTocc1" class="form-control"
                placeholder="Default - abcd@xpressbees.com" rows="2" cols="125" ></textarea>
                <small>To Add multiple Email ID give comma(,)</small>
              </div>
            </div>
            <b-alert show v-if='invalidEmailFlag' variant="danger">
                Invalid Email Ids<br>
                {{invalidEmail}}
            </b-alert>

             <div class="form-group">
                <label  class="col-form-label"></label>
                <select v-model="replyType" class="form-control" @change="getEmailTemplate()">
                  <option value="Auto Reply" selected>Auto Reply</option>
                  <option value="RTO Auto Reply">RTO - Auto Reply</option>
                  <option value="DTO Auto Reply">DTO - Auto Reply</option>
                  <option value="Business Auto Reply">Business - Auto-reply</option>
                  <option value="Franchisee Auto Reply">Franchisee - Auto-reply</option>
                </select>
              </div>
              <div class="form-row mb-3">
               <label for="to" class="col-2 col-sm-1 col-form-label">Subject:</label>
                <div cols="12" class="col-sm-11">
                <input type="subject" name="subject_email"  v-validate="'required|email'" id="subject_email" placeholder="Type subject" 
                v-model="caseObj.subject" class="form-control" readonly>
                <!-- <i v-show="errors.has('subject_email')" class="fa fa-warning"></i> -->
                <!-- <span v-show="errors.has('subject_email')" class="help is-danger">{{ errors.first('subject_email') }}</span> -->
                </div>
              </div>
              <div class="row">
                <label for="cc" class="col-2 col-sm-2 col-form-label">Attachment:</label>
                <div cols="12" class="col-sm-6">
                    <input id="imagefile1" type="file" multiple/>
                </div>
              </div>
              <div class="form-group" >
                <!-- <vue-editor id="editor" v-model="data"></vue-editor> -->
                <wysiwyg id="editor" v-model="data"></wysiwyg>
                <i v-show="errors.has('data')" class="fa fa-warning"></i>
                <span v-show="errors.has('data')" class="help is-danger">{{ errors.first('data') }}</span>
              </div>

              <div role="group" class="form-group">
                 <h5><div class="col-md-3">
                    <label>Close Cases</label>

                      <input @click="onCheckclosecasemodal( $event )" type="checkbox"
                        v-model="closecasemodalChkFlag">

                  </div></h5>
                  <button type="submit" class="btn btn-primary" variant="primary" name="searchButton" size="sm">Submit</button>
              </div>
            </form>
            </div>
        </b-card>
      </div>
    </b-modal>
    <!-- Edit emailer Ticket Modal -->
    <b-modal size="vlg" ref="modal" @show="resetModal"
      @hidden="resetModal" v-model="editEmailerTicketModal" :no-close-on-backdrop="true">
      <loading :active.sync="isModalLoading" :is-full-page="fullPage"></loading>
      <div>
        <b-card>
          <h5 class="modal-title">Update Raise Ticket</h5>
          <button type="button" aria-label="Close" @click="resetraiseticketform()" style="display: inline;position: relative;bottom: 30px;" class="close">×</button>
          <div class="card-body modal-content">
              <div>
                <b-card no-body class="mb-1">
                  <b-card-header header-tag="header" class="p-1" role="tab">
                    <b-button block variant="info">Update Raised Ticket</b-button>
                  </b-card-header>
                    <b-card-body>
                        <div class="row form-group">
                            <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Source <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <basic-select :options="source" v-model="sourceId" :selected-option="selectedSourceObj"
                              placeholder="Select Source" @select="selectedSource">
                            </basic-select>
                            </div>
                          </div>

<!-- address change code -->
                           <div class="col-2">
                             <div role="group" class="mb-0 form-group">
                                <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                      || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                      || selectedSubReasonObj.text == 'Redirect to Bank' )
                                      && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED )">
                                <label class="label_text">Address : </label>
                                </div>
                              </div>
                          </div>

                          <div class="col-3">
                               <div role="group" class="mb-0 form-group">
                                  <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                      || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                      || selectedSubReasonObj.text == 'Redirect to Bank' )
                                      && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED )">

                                 <b-form-textarea v-model="address" name="address" placeholder=""
                                  v-validate="'required|min:3|max:200'" 
                                  ></b-form-textarea>
                                   </div>
                                <i v-show="errors.has('address')" class="fa fa-warning"></i>
                                <span v-show="errors.has('address')" class="help is-danger">{{ errors.first('address')
                                  }}</span>
                                
                              </div>
                            </div>

                          </div>
                          
                        <div class="row form-group">

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Ticket Type <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="ticketType" v-model="ticketTypeId" :selected-option="selectedTicketObj"
                                placeholder="Select Ticket" @select="selectedTicket"></basic-select>
                            </div>
                          </div>

                             <div class="col-2">
                              <div role="group" class="mb-0 form-group">
                                <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                    || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                    || selectedSubReasonObj.text == 'Change misroute pincode' || selectedSubReasonObj.text == 'Redirect to Bank'
                                    || selectedSubReasonObj.value == CHANGE_RTO_PINCODE || selectedSubReasonObj.value == CHANGE_DELIVERY_PINCODE
                                    || selectedSubReasonObj.value == CHANGE_DTO_PINCODE || selectedSubReasonObj.value == CHANGE_PICKUP_PINCODE )
                                    && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED)">
                                <label class="label_text">PinCode :</label>
                                </div>
                              </div>
                            </div>

                            <div class="col-3">
                              <div role="group" class="mb-0 form-group">
                                <div
                                v-if="(selectedSubReasonObj.text == 'Change RTO address' || selectedSubReasonObj.text == 'Change delivery address'
                                    || selectedSubReasonObj.text == 'Change DTO address' || selectedSubReasonObj.text == 'Change Pickup address'
                                    || selectedSubReasonObj.text == 'Change misroute pincode' || selectedSubReasonObj.text == 'Redirect to Bank'
                                    || selectedSubReasonObj.value == CHANGE_RTO_PINCODE || selectedSubReasonObj.value == CHANGE_DELIVERY_PINCODE
                                    || selectedSubReasonObj.value == CHANGE_DTO_PINCODE || selectedSubReasonObj.value == CHANGE_PICKUP_PINCODE )
                                    && ( selectedActionObj.value == ASSIGNED_CS_TEAM || selectedActionObj.value == ADDDESS_CHANGE_REQUESTED || this.selectedActionObj.value == ADDRESS_UPDATED)">
                                  <b-form-input name="pincode" v-model="pincode" placeholder=""
                                  v-validate="'required|numeric|digits:6'"
                                  :class="{'input': true, 'is-danger': errors.has('pincode') }"
                                 ></b-form-input>

                                <i v-show="errors.has('pincode')" class="fa fa-warning"></i>
                                <!-- <button class="btn btn-primary cst_btn" id="pincodeservicable"
                                v-on:click.prevent="checkPinCodeServiceable"
                                style="width: 20%;float: right;margin-right: -284px;">Validate</button> -->
                                <span v-show="errors.has('pincode')" class="help is-danger">{{ errors.first('pincode')
                                  }}</span>
                                  </div>

                              </div>
                            </div>


                        </div>

                        <div class="row form-group">
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Reason <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="reason" v-model="reasonId" :selected-option="selectedReasonObj"
                                    placeholder="Select Reason" @select="selectedReason">
                                  </basic-select>
                            </div>
                          </div>

                          <div class="col-2" v-if="( selectedReasonObj.text == 'Arrange delivery' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (selectedReasonObj.text == 'Non Behavioral' && selectedSubReasonObj.text =='Delay in service' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'SR related' && selectedSubReasonObj.text == 'Fake update' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'Arrange pickup'  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (( selectedSubReasonObj.value == FAKE_NDR || selectedSubReasonObj.value == REFUSED_DOORSTEP_DELIVERY
                                    || selectedSubReasonObj.value == DELAY_IN_PICKUP_SUB_REASON || selectedSubReasonObj.value == FAKE_NPR  || selectedSubReasonObj.value == CHANGE_REATTEMPT_DATE
                                    || selectedSubReasonObj.value == FAKE_PICKUP || selectedSubReasonObj.value == DENIED_PICKUP )  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM  )">
                            <div role="group" class="mb-0 form-group">
                              <label>Reattempt Date <span class="compRedCss">*</span> :</label>
                            </div>
                          </div>
                          <div class="col-3" v-if="( selectedReasonObj.text == 'Arrange delivery' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (selectedReasonObj.text == 'Non Behavioral' && selectedSubReasonObj.text =='Delay in service' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'SR related' && selectedSubReasonObj.text == 'Fake update' && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || ( selectedReasonObj.text == 'Arrange pickup'  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM )
                                    || (( selectedSubReasonObj.value == FAKE_NDR || selectedSubReasonObj.value == REFUSED_DOORSTEP_DELIVERY
                                    || selectedSubReasonObj.value == DELAY_IN_PICKUP_SUB_REASON || selectedSubReasonObj.value == FAKE_NPR  || selectedSubReasonObj.value == CHANGE_REATTEMPT_DATE
                                    || selectedSubReasonObj.value == FAKE_PICKUP || selectedSubReasonObj.value == DENIED_PICKUP )  && selectedActionObj.value == ARRANGED_ASSIGN_OPS_TEAM  )">
                            <div role="group" class="mb-0 form-group">
                              <date-picker v-model="reAttemptDate" lang="en" type="date" :format="format"
                                    :not-before="startDate" :not-after="endDate"></date-picker>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Sub Reason <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="subReason" name="subReasonId" v-model="subReasonId"
                                :selected-option="selectedSubReasonObj" placeholder="Select Sub Reason"
                                @select="selectedSubReason"></basic-select>
                            </div>
                          </div>

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Resolution / Action <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="action" v-model="actionId" placeholder="Select Action"
                                :selected-option="selectedActionObj" @select="selectedAction"></basic-select>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group" v-if="shouldShowLabel">
                            <!-- #emailer_srid SR ID -->
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>SR ID  <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <basic-select :options="SRIDs" v-model="SRIDsId" placeholder="Select SR ID" :selected-option="selectedSRIDnObj"
                              @select="selectedSRID"></basic-select>
                            </div>
                          </div>

                          <!-- #emailer_srid SR Name -->
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>SR Name <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <basic-select :options="SRNames" v-model="SRNameId" placeholder="Select SR Name" :selected-option="selectedSRNamenObj"
                               @select="selectedSRName"></basic-select>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Ticket Status <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                                <basic-select :options="ticketStatus" v-model="ticketStatusId" placeholder="Select Action"
                                :selected-option="selectedTicketStatusObj" @select="selectedTicketStatus"></basic-select>
                            </div>
                          </div>

                          <div class="col-2">
                            <div role="group" class="mb-0 form-group">
                              <label>Comments <span class="compRedCss">*</span> : </label>
                            </div>
                          </div>
                          <div class="col-5">
                            <div role="group" class="mb-0 form-group">
                                <b-form-textarea v-model="comments" name="comments" placeholder="" v-validate="'min:3|max:300'"
                              rows="5"></b-form-textarea>
                            </div>
                          </div>
                        </div>
                        <div class="card c-email-app">
                          <div class="card-body">
                            <div>
                              
                              <div class="form-row mb-3">
                                  <label for="to" class="col-2 col-sm-1 col-form-label">Preview:</label>
                                  <div><p v-if="userRole.toLowerCase() === 'associate' ">

                                  <EmailPreviewRaiseTicket :setCaseID="[caseObj.caseid]" :buttonType="'eye'" >Preview </EmailPreviewRaiseTicket>
                                </p>
                                  </div>
                                </div>
                                
                                <div class="form-row mb-3">
                                  <label for="to" class="col-2 col-sm-1 col-form-label">From:</label>
                                  <div cols="12" class="col-sm-11">{{this.emailFrom}}</div>
                                </div>
                                <div class="form-row mb-3">
                                  <label for="to" class="col-2 col-sm-1 col-form-label">To:</label>

                                  <div cols="12" class="col-sm-11" v-if="caseObj.email != null">
                                    <input type="email" name="to_email"  v-validate="'required|email'" id="to_email" placeholder="Type email" v-model="caseObj.fromid" class="form-control" >
                                    <i v-show="errors.has('to_email')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('to_email')" class="help is-danger">{{ errors.first('to_email') }}</span>
                                  </div>
                                     <div cols="12" class="col-sm-11" v-else>
                                    <input type="email" name="to_email"  v-validate="'required|email'" id="to_email" placeholder="Type email" v-model="caseObj.fromid" class="form-control" >
                                    <i v-show="errors.has('to_email')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('to_email')" class="help is-danger">{{ errors.first('to_email') }}</span>
                                  </div>

                                </div>
                                <div class="form-row mb-3">
                                  <label for="cc" class="col-2 col-sm-1 col-form-label">CC:</label>
                                  <div cols="12" class="col-sm-11">
                                    <!-- <input type="email" name="cc_email" v-validate="'required|email'" id="cc_email" v-model="replyTocc" class="form-control"> -->
                                    <textarea  name="replyTocc1" id="replyTocc1" v-model="replyTocc1" class="form-control"
                                    placeholder="Default - abc@xpressbees.com" rows="2" cols="125" ></textarea>
                                    <small>To Add multiple Email ID give comma(,)</small>
                                    <!-- <i v-show="errors.has('cc_email')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('cc_email')" class="help is-danger">{{ errors.first('cc_email') }}</span> -->
                                  </div>
                                </div>
                                <b-alert show v-if='invalidEmailFlag' variant="danger">
                                    Invalid Email Ids<br>
                                    {{invalidEmail}}
                                </b-alert>

                              <!-- <div class="row">
                                <label for="cc" class="col-2 col-sm-2 col-form-label">Attachment:</label>
                                <div cols="12" class="col-sm-6">
                                    <input id="image-file" type="file" multiple/>
                                </div>
                              </div> -->
                              <div class="row">
                                <label data-v-685aa076="" for="message" class="col-1 col-sm-2 col-form-label">Message:</label>
                                <div class="ml-auto col-sm-11">
                                  <div class="form-group mt-4">
                                  <!-- <vue-editor id="message" name="message" v-model="reply"></vue-editor> -->
                                  <wysiwyg id="message" name="message" v-model="reply"></wysiwyg>
                                    <!--<textarea id="message" name="message" rows="12" v-model="reply" placeholder="Click here to reply" class="form-control"></textarea> -->
                                    <i v-show="errors.has('message')" class="fa fa-warning"></i>
                                    <span v-show="errors.has('message')" class="help is-danger">{{ errors.first('message') }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-3">
                            <div role="group" class="mb-0 form-group">
                              <button class="btn btn-success"
                                :disabled="validated ? '' : ticket.disabled || errors.any()"
                                v-on:click.prevent="saveBulkEditShipmentAndSendMail()">Update</button>
                         
   <!-- Reset Button is not required -->
                      <!--         <button class="btn btn-danger" v-on:click.prevent="resetAddTicket">Reset</button> -->
                          
                            </div>
                          </div>
                        </div>
                    </b-card-body>
                </b-card>
              </div>
            <div v-if="ticketResultMsg!= ''" v-html="ticketResultMsg">{{ticketResultMsg}}</div>
            <div><button style="margin-top: auto;" v-if="ticket.length>0 && ticketResultMsg!= ''" class="btn btn-primary"
              @click="listExisitngTicketModal=true;updateExistingBulkTicket=true;showBulkTicketDiv=false;">Update
              Ticket</button>
            </div>
          </div>
        </b-card>
    </div>
    </b-modal>
  </section>
</template>
<script>
  import Vue from 'vue'
  import VeeValidate from 'vee-validate'
  //import Buefy from 'buefy'
  //import 'buefy/dist/buefy.css'

  //import CONSTANTS from '@/utils/constants'
  //import stores from '@/stores'
 // import tinymce from 'vue-tinymce-editor'
  import { VueEditor, Quill } from "vue2-editor";
  import wysiwyg from "vue-wysiwyg";
  import filters from '@/filters/filter'
  import apiUrl from '../../../constants'
  import axios from 'axios'
  import moment from 'moment'
  import EmailPreview from './EmailPreview'
  import EmailPreviewRaiseTicket from './EmailPreviewRaiseTicket'
  //import EmailrCommonFunctions from '@/components/Emailr/EmailrCommonFunctions'
  import commonFunction from '../../../commonFunction'
  import constantVariable from '../../../constantVariable'
  import Paginate from 'vuejs-paginate'
  import DatePicker from 'vue2-datepicker';
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  import 'vue-wysiwyg/dist/vueWysiwyg.css';
  import {
    BasicSelect
  } from 'vue-search-select';
  import CryptoJS from 'crypto-js';

  import authFunction from '../../../authFunction';
  import { AES, enc } from 'crypto-js';


  const config = {
    errorBagName: 'errors', // change if property conflicts.
    fieldsBagName: 'fields',
    delay: 0,
    locale: 'en',
    dictionary: null,
    strict: true,
    enableAutoClasses: false,
    classNames: {
      touched: 'touched', // the control has been blurred
      untouched: 'untouched', // the control hasn't been blurred
      valid: 'valid', // model is valid
      invalid: 'invalid', // model is invalid
      pristine: 'pristine', // control has not been interacted with
      dirty: 'dirty' // control has been interacted with
    },
    events: 'input|blur',
    inject: true
  };
  Vue.use(VeeValidate,config);
  //Vue.use(Buefy);
  Vue.use(wysiwyg, {
    hideModules: {},
    // if the image option is not set, images are inserted as base64
    // image: {
    //   uploadURL: 'https://'+apiUrl.S3BUCKETNAME+'.s3.ap-south-1.amazonaws.com/Attachment/outbox/',
    //   dropzoneOptions: {}
    // },
    // limit content height if you wish. If not set, editor size will grow with content.
    maxHeight: "500px",
    // set to 'true' this will insert plain text without styling when you paste something into the editor.
    forcePlainTextOnPaste: false
  });
  export default {
    name: 'emailtracking',
    filters: {
      //dateFilter: filters.formatDate
    },
    components: {
      Loading,
      EmailPreview,
      EmailPreviewRaiseTicket,
      Paginate,
      DatePicker,
      BasicSelect,
      VueEditor
     // tinymce
    },
    data: () => ({
      constantVariable,                        
      loadCount:false,
      image: null,
      data:"",
      tabIndex: 0,
      reallocate: {
        agent: '',
        allocationreasoinid: '',
        comment: ''
      },
      arrDisplaySubTypes: [{
          'name': 'forward',
          'subtypes': [{
              'id': constantVariable.FUTURE_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SELF_COLLECT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.URGENT_DELIVERY,
              'types': [{
                  'id': constantVariable.ARRANGE_DELIVERY
                },
                {
                  'id': constantVariable.CANCELLATION_REQUEST
                },
                {
                  'id': constantVariable.HOLD_REASON
                }
              ]
            },
            {
              'id': constantVariable.CSAW_RTO_REATTEMPT,
              'types': [{
                  'id': constantVariable.CANCELLATION_REQUEST
                },
                {
                  'id': constantVariable.HOLD_REASON
                },
                {
                  'id': constantVariable.ARRANGE_DELIVERY
                }
              ]
            },
            {
              'id': constantVariable.HOLD_SUB_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.LATE_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PRICE_ISSUE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PRODUCT_ISSUE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DUPLICATE_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.FAKE_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.ODA_LOCATION,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.PURCHASED_FROM_OTHER_SOURCE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.MIND_CHANGE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_OUT_OF_STATION,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_WANT_OPEN_DELIVERY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DUE_TO_FAKE_UPDATE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NEVER_ORDERED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.COD_NOT_AVAILABLE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SR_DEMAND_FOR_EXTRA_AMOUNT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.ORDERED_BY_MISTAKE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NO_SUCH_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.NOT_INTERESTED_TO_TAKE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SR_MISBEHAVIOUR,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.INCORRECT_PINCODE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.CUSTOMER_SHIFTED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.SOMEONE_ELSE_ORDERED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.FORGOT_TO_APPLY_PROMOCODE,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.REFUND_PENDING_OF_PREVIOUS_ORDER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.DEMISE_IN_FAMILY,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            }
          ]
        },
        {
          'name': 'reverse',
          'subtypes': [{
              'id': constantVariable.FUTURE_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PICKUP_WITHOUT_QC,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.EXCEPTIONAL_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.URGENT_PICKUP,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.CSAW_DTO_REATTEMPT,
              'types': [{
                  'id': constantVariable.CANCELLATION_REQUEST
                },
                {
                  'id': constantVariable.HOLD_REASON
                },
                {
                  'id': constantVariable.ARRANGE_PICKUP
                }
              ]
            },
            {
              'id': constantVariable.HOLD_SUB_REASON,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_DELIVERY
              }]
            },
            {
              'id': constantVariable.QC_FAILED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.AS_PER_CLIENT,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PRODUCT_USED,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.PRODUCT_HANDEDOVER,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.OUT_SERVICE_AREA,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.DUPLICATE_REQUEST,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            },
            {
              'id': constantVariable.RETURN_REASON_MISMATCH,
              'types': [{
                'id': constantVariable.CANCELLATION_REQUEST
              }, {
                'id': constantVariable.HOLD_REASON
              }, {
                'id': constantVariable.ARRANGE_PICKUP
              }]
            }
          ]
        }
      ],
      TicketLogModal1 : false,
      resultTicket : [],
      editEmailerTicketModal : false,
      businessFlowOptions: [],
			businessFlowId: '',
			selectedbusinessFlowObj: {
				value: '',
				text: ''
			},
      PrexoType: '',
      PrexoShipment: '',
      invalidEmailFlag : false,
      getCaseObjData :[],
      isSearchModal_1 : false,
      pageName: 'emailr',
      isLoading: false,
      maxToDate: moment().format('YYYY-MM-DD'),
      agents: [],
      isShowReallocation: true,
      filter: {
        originatesource: '',
        mainType: '',
        type: '',
        subType: '',
        fromDate: '',
        toDate: '',
        searchAgent: '',
        fcaccountid: '',
        agingTime: '',
        status: 'inprocess',
        priorityEmail: true,
        caseid: '',

        agent: '',
        subdepartmentid: {
          subdepartmentid: '',
          subdeptname: ''
        },
        tlemailid: '',
        amemailid: '',
        manageremailid: '',
        subject: '',
        awbno: '',
        coid: '',
        aiassisted : '',
        isrepeatemail: true,
        repeatstatus: true,
        ccemail : ''
      },
      reasons: [],
      isActiveLogModal: false,
      checkAllSelected: false,
      allSelected: false,
      selectedRows: [],
      selectMode: 'multi',
      selected: [],
      emailCasesArray: [],
      page: 0,
      noOfPages: 1,
      totalPages: 0,
      pageSize: 50,   //Increased limit of email count
      pageItemList: [10, 20, 30],
      isSearch: false,
      fromemail: '',
      toemail: '',
      emailsubject: '',
      emailmessage: '',
      recipientid: '',
      carboncopy: '',
      agentDisabled: true,
      showReAllocationForm: false,
      showArtical: true,
      previetickid: '',
      loggedUser: {
        role: ''
      },
      hoverable: true,
      allocateCount: 0,
      inprocessCount: 0,
      totalCount: 0,
      isSearchModal: false,
      emailMessageArray: [],
      viewBody: '',
      teamLeads: [],
      teamLeadEmail: '',
      designation: '',
      userDetails: {},
      subDepartmentList: [],
      activeAgents: [],
      tlEmailId: '',
      tlemailid: '',
      tlMaster: [],
      showDetails: false,
      sourcename: 'ccemail', // this.userDetails.subdepartment[0].subdeptname
      sourceid: 5,
      selectedTab: 0,
      selectedCaseID: '',
      activeComponent: 'Case List',
      mainTypeMasterIds: [],
      typeMasterIds: [],
      subTypeMasterIds: [],
      localSubTypeMasterData: [],
      localTypeMasterData: [],
      userRole: '',
      username: '',
      userid: '',
      emailCaseLog: [],
      isLoadingPagination: false,
      fullPage: false,
      pageno: 0,
      pagecount: 0,
      perpage: 10,
      selectedCaseIds: [],
      shippingIds : '',
      shippingIdState : null,
      isTicketModal : false,
      isTicketModal1 : false,
      businessFlow: '',
      businessFlowState : null,
      shipments : [],
      shipmentResult : false,
      closecasemodal:'N',
      closecasemodalChkFlag: false,
      disablebtn : false,

      Modified_Date :'N',
      Created_Date :'Y',

      validShippingIds : [],
      invalidShippingIds :[],
      selectedZoneObj: {
        value: '',
        text: ''
      },
			selectedSourceObj: {
				value: '',
				text: ''
			},
			ticketType: [],
			ticketTypeId: '',
			selectedTicketObj: {
				value: '',
				text: ''
			},
			reason: [],
			reasonId: '',
			selectedReasonObj: {
				value: '',
				text: ''
			},
			subReason: [],
			subReasonId: '',
			selectedSubReasonObj: {
				value: '',
				text: ''
			},
			action: [],
			actionId: '',
			selectedActionObj: {
				value: '',
				text: ''
			},
			ticketStatus: [],
			ticketStatusId: '',
			selectedTicketStatusObj: {},
			searchOptions: [],
			searchId: '',
			selectedSearchObj: {
				value: '',
				text: ''
			},
			reAttemptDate: '',
			startDate: new Date(),
			endDate: new Date(),
			validated: false,
			shortcuts: [{
				text: 'Today',
				startDate: new Date()

			}],
			format: 'YYYY-MM-DD',
			disabledDates: {
				to: new Date(Date.now() - 8640000)
			},
			address: '',
			location: '',
			pincode: '',
			orderType: [{
					value: 'CashOnDelivery',
					text: 'CashOnDelivery'
				},
				{
					value: 'PrePaid',
					text: 'PrePaid'
				}
			],
			orderTypeId: '',
			selectedOrderTypeObj: {
				value: '',
				text: ''
			},
			comments: '',
      ARRANGED_ASSIGN_OPS_TEAM: 11,
      CALL_DROPPED: 9,
			ADDRESS_UPDATED: 8,
			ASSIGNED_OPS_TEAM: 12,
			STATUS_CHANGED: 15,
			ADDRESS_CHANGE :9,
			FAKE_NDR:133,
			REFUSED_DOORSTEP_DELIVERY : 136,
			DELAY_IN_PICKUP_SUB_REASON : 131,
			FAKE_NPR : 119,
			FAKE_PICKUP : 120,
			DENIED_PICKUP : 121,
			escalation: 0,
			fakeNdrStatus: 0,
			ticketResultMsg: '',
      ticketResultMsg1 :'',
      ticketResultData : '',
      ticketResultData1 : '',
			ticket: {
				disabled: false
			},
			submitted: false,
			ticketShipmentData: [],
			shipmentTickets: [],
			ticket: {},
			username: '',
			mobileNumber: '',
			ticketId: '',
      source: [],
			sourceId: '',
      isModalLoading : false,
      caseObj : {},
      currentCaseId : '',
      replyTocc : '',
      replyTocc1 : [],
      reply : '',
      listExisitngTicketModal: false,
      updateExistingBulkTicket: false,
      showBulkTicketDiv: false,
      ticketIDLog: '',
      selectAllRecord: false,
      newReAttemptDate: '',
      ARRANGED_ASSIGN_OPS_TEAM: 11,
      ADDRESS_CHANGE: 9,
      ADDRESS_UPDATED: 8,
      ASSIGNED_CS_TEAM: 14,
      ASSIGNED_OPS_TEAM: 12,
      STATUS_CHANGED: 15,
      PAYMENT_DETAILS_CHANGE_REQUESTED: 45,
      UPDATE_CONTACT_DETAILS: 17,
      UPDATE_EMAIL_ADDRESS: 97,
      UPDATE_ALTERNATE_CONTACT_NO: 98,
      CONTACT_DETAILS_UPDATED: 19,
      FAKE_NDR: 133,
      REFUSED_DOORSTEP_DELIVERY: 136,
      DELAY_IN_PICKUP_SUB_REASON: 131,
      FAKE_NPR: 119,
      FAKE_PICKUP: 120,
      DENIED_PICKUP: 121,
      CHANGE_REATTEMPT_DATE: 80,
      REATTEMPT_DATE_CHANGED: 40,
      ADDDESS_CHANGE_REQUESTED: 42,
      REQUEST_FOR_RTO_NOTIFICATION: 43,
      CHANGE_DELIVERY_PINCODE: 149,
      CHANGE_RTO_PINCODE: 150,
      CHANGE_DTO_PINCODE: 151,
      CHANGE_PICKUP_PINCODE: 152,
      ticketIDS : [],
      ticketExistedData : [],
      newReAttemptDate: '',
      newAddress: '',
      newPincode: '',
      newEmailAddress: '',
      autoReplyModal: false,
      replyToccAutoreply:'',
      template : {},
      tinyOptions: {
        'height': 300
      },
      replyType : '',
      OldDeliveryUserOrUserId:'',
      alreadyExistTicket:false,
      AI_ENABLED : constantVariable.AI_ENABLED,
      //#emailer_srid 
      SRIDs : [],
      SRIDsId : '',
      selectedSRIDnObj : {},
      SRNames : [],
      SRNameId : '',
      selectedSRNamenObj : {},
      shouldShowLabel: false,
      srid : '',
      srname : '',
      shouldShowSRLabel: false,
      srDetailsByShippingId:'',
      //#emailer_srid 
      latestStatusByCaseid : '', //#multiple_download
    }),

    created() {

      // this.emailFrom = apiUrl.EMAILR_CONFIG_DATA[0].EMAILR_ACK_EMAIL.trim().toLowerCase(); 
      [this.subDepartmentList, this.DepartmentID, this.userdetail, this.permissiondata, this.userTypeForTicket, this
        .SummarySelectOptionObj, this.SummaryOptionObj
      ] = commonFunction.getuserDetailsAndpermissionData();

   //Send mail departmentidwise

      if (this.DepartmentID == constantVariable.Walletnetmail) {
      this.emailFrom = apiUrl.EMAILR_CONFIG_DATA[1].EMAILR_ACK_EMAIL.trim().toLowerCase(); 
        } else {
      this.emailFrom = apiUrl.EMAILR_CONFIG_DATA[0].EMAILR_ACK_EMAIL.trim().toLowerCase(); 
      }

      this.userid = this.userdetail[0].userid;
      this.username = this.userdetail[0].username;
      this.userRole = this.userdetail[0].roles[0].rolename;
      this.filter.status = this.$route.query.status ? this.$route.query.status.toLowerCase() : ''
      this.designation = this.userRole;
      this.OldDeliveryUserOrUserId = this.userdetail[0].OldDeliveryUserOrUserId;
      this.filter.subdepartmentid.subdepartmentid = this.DepartmentID;

      if (!Object.keys(this.$route.query).length) {
        this.filter.status = 'allocated'
        this.filter.toDate = moment().format('YYYY-MM-DD')
        this.filter.fromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
      }
      if (this.$route.query && this.$route.query.repeatstatus) {
        this.filter.repeatstatus = true
      }
      if (this.$route.query.subdepartmentid) {
        this.filter.subdepartmentid.subdepartmentid = this.$route.query.subdepartmentid || this.DepartmentID;
      }

      if (this.filter.status === 'close' || this.filter.status === 'spam' || this.filter.status === 'trash' || this.filter.status === 'followup') {
        this.filter.toDate = moment().format('YYYY-MM-DD')
        this.filter.fromDate = moment().format('YYYY-MM-DD')
      }
      if (this.userRole.toLowerCase() === 'associate') {
        this.filter.agent = this.userdetail[0].email.toLowerCase();
      }
      this.checkConditions();
    },
    mounted() {
     var userSubDepartmentId = window.localStorage.getItem(
      "userSubDepartmentId"
    );
    let subdepartmentid = JSON.parse(userSubDepartmentId)
    if(subdepartmentid.value == 23){
      this.AI_ENABLED = false
    }
    },
    methods: {
// #emailer_report
//CRM Emailer AI Automation Report
 exportEmailerAIReport: function () {

 let emptyfilter = !this.filter.fromDate && !this.filter.toDate;
  
  if (emptyfilter) {
    return this.$alertify.error('Please select at least Date filter');
    return;
  }

  if ((this.filter.fromDate && !this.filter.toDate) || (!this.filter.fromDate && this.filter.toDate)) {
    return this.$alertify.error('Please select both From and To dates');
    return;
  }

  if (this.filter.toDate && this.filter.fromDate) {
    let dateDiff = moment(this.filter.toDate).diff(this.filter.fromDate, 'days')
    if (Number(dateDiff) >= 7) {
      return this.$alertify.error( 'Please select 7 days difference' )
    }
  }
   let getObj = {
          fromdate: (this.filter.fromDate !== '')? moment(this.filter.fromDate).format('YYYY-MM-DD')  : '',
          todate: (this.filter.toDate != '') ? moment((this.filter.toDate)).format('YYYY-MM-DD') : '',
          status: this.filter.status,
          caseid: this.filter.caseid,
          subdepartmentid: this.filter.subdepartmentid.subdepartmentid,
          fromid: this.filter.fromemail,
          toid: this.filter.toemail,
          ccid: this.filter.ccemail,
          ticketid: this.filter.ticketid,
          assignedto: this.filter.agent,
          subject: this.filter.subject,
          maintypeid: this.filter.mainType,
          typeid: this.filter.type,
          subtypeid: this.filter.subType,
         'Created_Date': this.Created_Date,
         'Modified_Date': this.Modified_Date,
          aiassisted : (this.filter.aiassisted==true)?this.filter.aiassisted:null
        }
    Object.keys(getObj).forEach((key) => {
          if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
            delete getObj[key]
          }
        })
  this.isLoading = true;
  axios({
    method: 'POST', // switch to POST to pass body data
    url: apiUrl.api_url + 'exportEmailerCsv',
    headers: {
      headers: commonFunction.getusertoken(),
      'Content-Type': 'application/json'
    },
    responseType: 'blob', // important for file download
    data: getObj
  }) .then((response) => {
      this.isLoading = false;
       if (response.status === 204) {
          this.$alertify.error('No data found');
        } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Email_Cases_Export.xlsx');
        document.body.appendChild(link);
        link.click();
  }
    })
    .catch((error) => {
      this.isLoading = false;
      let msg = error + " - downalodEmailerAIReport";
      this.$alertify.error(msg);   
    });
},
// #emailer_report

      autoReply(){
        $('input[type=file]').val('');
        this.replyTocc1='';
        this.autoReplyModal=false;
      },
      getemailerTicketHistory(ticket) {
        this.ticketIDLog = ticket.ticketid
        this.input = ({
          "ticketid": this.ticketIDLog
        })
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTicketHistory',
          headers: commonFunction.getusertoken(),
          'data': this.input
        }).then(result => {
          var resultTickets = result.data.data;
          if (resultTickets.status == true) {
            this.resultTicket = result.data.data.data;
            this.TicketLogModal1 = true;
          } else {
            let msg = this.resultTicket.msg;
            this.$alertify.error(msg);
          }
        }, error => {
          this.isLoading = false;
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        })
      },

      delayButtonClick(ticket){
       // console.log("ticket delayButtonClick ",ticket);
        this.disablebtn = true
        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.disablebtn = false
        }, 5000)
        this.editEmailerTicket(ticket);
      },


openUpdateTicketModal() {

//console.log( "this.ticket alrdd", this.ticket);


        if (this.ticketIDS.length == 0) {
          this.$alertify.error('Please select ticket.');
          return false;
        }

this.alreadyExistTicket=true;

        // To disable Update Ticket Button
this.ticketResultMsg='';
// let ticket=this.ticket;
// this.ticket=[];
// this.ticket.length=0;

        this.updateExistingBulkTicket = false;
          // this.editEmailerTicketModal = true;

   this.ticketLabel = "Edit Emailer Ticket";
          this.Ticketmodal = false;

          this.editEmailerTicketModal = true;
          // this.RaiseTicketDiv = true;
          this.ticketTaggingDisplay = false;

//this.listExisitngTicketModal = false; // testing


//{"caseid":"223073","ticketIds":"11887,11872","ticketData":[{"index":0,"shippingData":{"shippingid":"12551299507","ticketid":11887,"sourceid":1,"tickettypeid":3,"reasonid":7,"subreasonid":24,"ticketstatus":"Open","comments":"ttesdfds","businessflow":"Forward"}},{"index":0,"shippingData":{"shippingid":"1255228899","ticketid":11872,"sourceid":3,"tickettypeid":2,"reasonid":20,"subreasonid":133,"ticketstatus":"Follow Up","comments":"dfdsfsdfds","businessflow":"Forward"}}],"sourceId":"3","ticketTypeId":"2","reasonId":"20","subReasonId":"133","action":"11","ticketStatusId":"Follow Up","reAttemptDate":"2022-11-02","deptid":"3","userId":"27194","username":"sarita.nagtilak@xpressbees.com","comments":"sdfdsf","userType":"Inbound","IsFakeNDRStatus":0,"businessflow":"Forward","escalation":0,"toid":"xbdev.testing@xpressbees.com","fromid":"arjun.khote@xpressbees.com","replyTocc":"","inboxid":"267604","subject":"cvddv","reply":"sdf"}


//        this.showBulkTicketDiv = true;
        this.source = [];
        this.ticketType = [];
        this.reason = [];
        this.subReason = [];
        this.tableShipment = true;
         console.log( 'openUpdateTicketModal ticketExistedData : '+JSON.stringify( this.ticketExistedData ) );
        if (this.ticketExistedData.length == 1) {
          this.newReAttemptDate = this.ticketExistedData[0].shippingData.reattemptdate;
          this.newAddress = this.ticketExistedData[0].shippingData.address;

          this.newPincode = this.ticketExistedData[0].shippingData.pincode;
          this.orderTypeId = this.ticketExistedData[0].shippingData.ordertype;
          this.netPayment = this.ticketExistedData[0].shippingData.netpayment;
          this.newAlternateContactNo = this.ticketExistedData[0].shippingData.alternatecontactnumber;
          this.newEmailAddress = this.ticketExistedData[0].shippingData.emailaddress;
          this.comments= this.ticketExistedData[0].shippingData.comments;  //#common_fixes Encrypted comment content displayed in UI when updating existing ticket via emailer
        } else {
          let intTicketDataLength = this.ticketExistedData.length;
          let boolIsMultipleSource = false;
          if (intTicketDataLength > 1) {

            for (let i = 0; i < intTicketDataLength; i++) {

              if (this.ticketExistedData[0].shippingData.sourceid != this.ticketExistedData[i].shippingData.sourceid) {
                boolIsMultipleSource = true;
                break;
              }
            }

            if (true == boolIsMultipleSource) {
              this.selectedSourceObj.text = "Multiple";
              this.selectedSourceObj.value = "Multiple";
            }
          }
        }
        this.selectedTicketStatusObj = {
          text: '',
          value: ''
        };
        this.ticketStatus = [];
        this.ticketStatusId = '';
        this.action = [];
        this.actionId = '';
        this.selectedActionObj = {
          value: '',
          text: ''
        };


        if(this.subReasonId == 44){
          var method= {value: '',text: ''};
          if(this.ticketExistedData[0].shippingData.ordertype == 'PrePaid'){
            method= {value: 2,text: 'Prepaid'};
            this.selectedMethod(method);
          }
          else{
            method= {value: 1,text: 'COD'};
            this.selectedMethod(method);
          }
        }
        this.disPayment = true;
        this.disPaymentMethod = true;

        this.getTicketAction(this.subReasonId, 'Edit');
      },


      editEmailerTicket(ticket) {
        try {

//Existing
          if (Array.isArray(this.ticketExistedData) === true  && this.ticketExistedData.length <=0 ) {
            this.$alertify.error("Please Select Atleast one ticket.");
            return false;
          }

          
          // // console.log('ticket : ' + JSON.stringify(ticket));
          // this.resetForm();
          this.ticketLabel = "Edit Emailer Ticket";
          this.Ticketmodal = false;

          this.editEmailerTicketModal = true;
          // this.RaiseTicketDiv = true;
          this.ticketTaggingDisplay = false;

          this.tableShipment = true;
          this.source = [];
          this.selectedSourceObj.text = ticket.source;
          this.selectedSourceObj.value = this.sourceId = ticket.sourceid;

          this.ticketType = [];
          this.selectedTicketObj.text = ticket.maintype;
          this.selectedTicketObj.value = this.ticketTypeId = ticket.tickettypeid;

          this.reason = [];
          this.subReason = [];

          let enableSubReason = false;
          if (ticket.businessflow == 'Forward') {
            if (-1 !== this.arrDisplaySubTypes[0].subtypes.findIndex(o => o.id == ticket.subreasonid)) {
              this.getTrackingSubType(this.ticketTypeId, ticket.businessflow, 'Edit', ticket.subreasonid);
              enableSubReason = true;
            }
          } else {
            if (-1 !== this.arrDisplaySubTypes[1].subtypes.findIndex(o => o.id == ticket.subreasonid)) {
              this.getTrackingSubType(this.ticketTypeId, ticket.businessflow, 'Edit', ticket.subreasonid);
              enableSubReason = true;

            }
          }
          this.selectedReasonObj.text = ticket.subtype;
          this.selectedReasonObj.value = this.reasonId = ticket.reasonid;

          if (enableSubReason == true) {
            this.getTrackingType(this.reasonId, ticket.businessflow, 'Edit', ticket.subreasonid);
          }
          this.selectedSubReasonObj.text = ticket.typename;
          this.selectedSubReasonObj.value = this.subReasonId = ticket.subreasonid;

          this.reAttemptDate = ticket.reattemptdate;
          this.address = ticket.address;
          this.pincode = ticket.pincode;
          this.location = ticket.name;
          this.ticketId = ticket.ticketid;
          this.mobileNo = (ticket.mobilenumber != null && ticket.mobilenumber != '') ? ticket.mobilenumber : null;
          this.alternateContactNo = (ticket.alternatecontactnumber != null && ticket.alternatecontactnumber != '') ? ticket.alternatecontactnumber : null;
          this.emailAddress = (ticket.emailaddress != null && ticket.emailaddress != '') ? ticket.emailaddress : null;
          this.orderTypeId = ticket.ordertype;
          this.netPayment = ticket.netpayment;
          this.comments = ticket.comments; //#common_fixes Encrypted comment content displayed in UI when updating existing ticket via emailer
          this.validated = false;
          this.ticket = ticket;
          if(this.subReasonId == 44){
            var method= {value: '',text: ''};
            if(ticket.ordertype == 'PrePaid'){
              method= {value: 2,text: 'Prepaid'};
              this.selectedMethod(method);
            } else{
              method= {value: 1,text: 'COD'};
              this.selectedMethod(method);
            }
          }
          this.disPayment = true;
          this.disPaymentMethod = true;
          // Scroll Down everytime functionality
          setTimeout(function () {
            window.scrollTo(0, document.body.scrollHeight);
          }, 1000);


          this.getTicketAction(ticket.subreasonid, 'Edit');

        } catch (error) {
          this.Ticketmodal = false;
          let msg = error + " - editTicket";
          this.$alertify.error(msg);
        }
      },
      handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        // An example of using FormData
        // NOTE: Your key could be different such as:
        // formData.append('file', file)

        var formData = new FormData();
        formData.append("image", file);

        axios({
          url: "https://fakeapi.yoursite.com/images",
          method: "POST",
          data: formData
        })
        .then(result => {
          let url = result.data.url; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
          console.log(err);
        });
      },
      openUpdateTicketModalPratiksha() {

        if (this.ticketIDS.length == 0) {
          this.$alertify.error('Please select ticket.');
          return false;
        }
        this.updateExistingBulkTicket = false;
          // this.editEmailerTicketModal = true;
        this.showBulkTicketDiv = true;
        this.source = [];
        this.ticketType = [];
        this.reason = [];
        this.subReason = [];
        this.tableShipment = true;
        // console.log( ' ticketExistedData : '+JSON.stringify( this.ticketExistedData ) );
        if (this.ticketExistedData.length == 1) {
          this.newReAttemptDate = this.ticketExistedData[0].shippingData.reattemptdate;
          this.newAddress = this.ticketExistedData[0].shippingData.address;

          this.newPincode = this.ticketExistedData[0].shippingData.pincode;
          this.orderTypeId = this.ticketExistedData[0].shippingData.ordertype;
          this.netPayment = this.ticketExistedData[0].shippingData.netpayment;
          this.newAlternateContactNo = this.ticketExistedData[0].shippingData.alternatecontactnumber;
          this.newEmailAddress = this.ticketExistedData[0].shippingData.emailaddress;
        } else {
          let intTicketDataLength = this.ticketExistedData.length;
          let boolIsMultipleSource = false;
          if (intTicketDataLength > 1) {

            for (let i = 0; i < intTicketDataLength; i++) {

              if (this.ticketExistedData[0].shippingData.sourceid != this.ticketExistedData[i].shippingData.sourceid) {
                boolIsMultipleSource = true;
                break;
              }
            }

            if (true == boolIsMultipleSource) {
              this.selectedSourceObj.text = "Multiple";
              this.selectedSourceObj.value = "Multiple";
            }
          }
        }
        this.selectedTicketStatusObj = {
          text: '',
          value: ''
        };
        this.ticketStatus = [];
        this.ticketStatusId = '';
        this.action = [];
        this.actionId = '';
        this.selectedActionObj = {
          value: '',
          text: ''
        };


        if(this.subReasonId == 44){
          var method= {value: '',text: ''};
          if(this.ticketExistedData[0].shippingData.ordertype == 'PrePaid'){
            method= {value: 2,text: 'Prepaid'};
            this.selectedMethod(method);
          }
          else{
            method= {value: 1,text: 'COD'};
            this.selectedMethod(method);
          }
        }
        this.disPayment = true;
        this.disPaymentMethod = true;

        this.getTicketAction(this.subReasonId, 'Edit');
      },
      resetUpdateTicketModal() {
        this.resetraiseticketform() ;
        this.showDetails=false;
        this.selectAllRecord = false;
        this.ticketIDS = [];
        this.ticketExistedData = [];
        this.ticket = {};
      },
      getEmailInputs(inputs) {
        this.inputs = inputs
      },
      formatShipments() {
        this.shippingIds = this.shippingIds.replace(/(\r\n|\n|\r|\s)/gm,",");
        this.shippingIds = this.shippingIds.split(/[\s,]+/).join();
      },
      onChange: function (){
        if(this.fromDate!=null && this.toDate!=null) {
          if(this.fromDate!=''){
            let dateDisabled = new Date(this.fromDate);
            this.tillDate1=new Date();
            dateDisabled.setDate(this.fromDate.getDate()+30);
            this.tillDate1 = dateDisabled;
          }
          if(this.toDate!=''){
            let dateDisabled2 = new Date(this.toDate);
            this.tillDate2=new Date();
            dateDisabled2.setDate(this.toDate.getDate()-30);
            this.tillDate2 = dateDisabled2;
          }
        } else {
            this.fromDate='';
            this.toDate='';
            this.tillDate1='';
            this.tillDate2 ='';
        }
      },
      selectAllCase: function () {

          if (this.allSelected) {
            var i = 0;
            let totalEmailCases = this.emailCasesArray.length;
            for (i = 0; i < totalEmailCases; i++) {
               if (-1 == this.selectedRows.findIndex(o => o.caseid == this.emailCasesArray[i].caseid)) {
                 this.selectedRows.push( this.emailCasesArray[i] );
                 this.selectedCaseIds.push( this.emailCasesArray[i].caseid );
               }
            }
          } else {
            this.selectedCaseIds = [];
            this.selectedRows = [];
          }
      },
      selectCase: function (selectedObj, event) {
        this.allSelected = false;
        if (event.target.checked) {
            this.selectedRows.push( selectedObj );
        } else {
            this.selectedRows.splice(this.selectedRows.findIndex(o => o.caseid == selectedObj.caseid), 1);
        }
      },
      async getPaginationData(pageNum) {
          try{
            this.page = (pageNum - 1);
            await this.getEmailCases();
          } catch (error) {
            let msg = error + " - getPaginationData";
            this.$alertify.error(msg);
          }
      },
      onRowSelected(items) {
        this.selected = items
        // console.log('selected : ' + this.selected);
      },
      selectAllRows() {
        this.$refs.selectableTable.selectAllRows()
      },
      clearSelected() {
        this.$refs.selectableTable.clearSelected()
      },
      pushToMarkIssue: function (caseData) {
       /* if (this.filter.subdepartmentid.subdeptname && this.filter.subdepartmentid.subdeptname.toLowerCase() ===
          'babyhugemail') {
          this.sourcename = 'babyhugemail'
          this.sourceid = 11
        } else {
          this.sourcename = 'ccemail'
          this.sourceid = 5
        }*/
        this.$router.push({
          path: '/markissue',
          query: {
            caseid: caseData.caseid,
            isemailr: 'yes',
            fcaccountid: caseData.fcaccountid,
            coid: caseData.contactuscoid,
            maintypeid: caseData.contactusmaintypeid,
            typeid: caseData.contactustypeid,
            subtypeid: caseData.contactussubtypeid,
            action: 'edit',
            source: this.sourcename,
            sourceid: this.sourceid,
            emailfrom: caseData.fromid,
            subdept: caseData.subdepartmentid.toString()
          },
          target: '_blank'
        })
      },
      checkConditions: function () {
        if (this.$route.query && this.userRole.toLowerCase() !== 'teamlead') {
          //this.filter.tlemailid = this.$route.query.tlemail
          // this.getAgents()
          //this.getActiveAgents()
        }
        if (this.$route.query && this.$route.query.agentemail) {
          this.filter.agent = this.$route.query.agentemail
        }
        if (this.userRole.toLowerCase() === 'associate') {
          this.filter.agent = this.userdetail[0].email.toLowerCase()
          this.getEmailCases();
        } else if (this.userRole.toLowerCase() === 'team leader') {
          this.filter.tlemailid = this.$route.query.tlemail ? this.$route.query.tlemail : this.userDetails
            .emailaddress
          //this.getAllTeamLead()
          this.getActiveAgents()
         // this.getAgents()
          this.getEmailCases()
        } else if (this.userRole.toLowerCase() === 'assistantmanager') {
          this.filter.amemailid = this.userDetails.emailaddress
          this.getTeamLeads()
          this.getEmailCases()
        } else if (this.userRole.toLowerCase() === 'manager') {
          this.getTeamLeads()
          this.filter.manageremailid = this.userDetails.emailaddress
          this.getEmailCases()
        } else {
          this.getTeamLeads()
          this.getEmailCases()
        }
      },
      getAgentUnderTl: function () {
        this.agents = []
        this.getTeamLeads()
        if (this.filter.tlemailid) {
          let getAgentObj = {
            emailaddress: this.filter.tlemailid,
            systemid: this.loggedUser.systemId,
            subdepartmentid: this.filter.subdepartmentid.subdepartmentid
          }
          return http.post(`${CONSTANTS.API_URL}/api/usermgt/fetch/agentundertl`, getAgentObj)
            .then((result) => {
              if (result && result.data && result.data.length) {
                result.data.forEach((agent) => {
                  this.agents.push(agent.userroledetail.usermaster.emailaddress)
                })
              } else {
                return this.$buefy.toast.open({
                  message: `No agents found`,
                  type: 'is-danger'
                })
              }
            })
            .catch((httpException) => {
              return this.$buefy.toast.open({
                message: httpException.message,
                type: 'is-danger'
              })
            })
        }
      },
      getTeamLeads: function () {
        if (this.userDetails.role.toLowerCase() === 'teamlead') {
          this.getAllTeamLead()
        } else {
          let getRoleObj = {
            rolename: 'teamlead',
            emailaddress: this.loggedUser.emailaddress,
            subdepartmentid: this.filter.subdepartmentid.subdepartmentid,
            systemid: this.loggedUser.systemId
          }
          Object.keys(getRoleObj).forEach((key) => {
            if (getRoleObj[key] === '' || getRoleObj[key] === null || getRoleObj[key] === undefined) {
              delete getRoleObj[key]
            }
          })
          return http.get(`${CONSTANTS.API_URL}/api/get/supervisor/feedbackrole`, getRoleObj)
            .then((result) => {
              if (result && result.data.length) {
                this.tlMaster = []
                result.data.forEach((agent) => {
                  this.tlMaster.push(agent.emailaddress)
                })
              }
            })
            .catch((HTTPException) => {
              return this.$buefy.toast.open({
                message: HTTPException.message,
                type: 'is-danger'
              })
            })
        }
      },
      // Get reasons for manual reallocate cases to agent.
      getReallocationResaon: function () {
        if (this.loggedUser && this.userRole && this.userRole.toLowerCase() !== 'Associate') {
          return http.get(`${CONSTANTS.API_URL}/api/reallocationreasoon`)
            .then((result) => {
              if (result) {
                this.reasons = []
                result.forEach((reason) => {
                  this.reasons.push({
                    reasonname: reason.reasonname ? reason.reasonname : '',
                    allocationreasoinid: reason.allocationreasoinid ? Number(reason.allocationreasoinid) :
                      ''
                  })
                })
              }
            })
            .catch((httpException) => {
              return this.$buefy.toast.open({
                message: httpException.message,
                type: 'is-danger'
              })
            })
        }
      },
      getAgents: function () {
        let getAgentObj = {
          emailaddress: this.filter.tlemailid,
          systemid: this.loggedUser.systemId,
          subdepartmentid: this.filter.subdepartmentid.subdepartmentid
        }
        return http.post(`${CONSTANTS.API_URL}/api/usermgt/fetch/agentundertl`, getAgentObj)
          .then((result) => {
            this.agents = []
            if (result && result.data && result.data.length) {
              result.data.forEach((agent) => {
                this.agents.push(agent.userroledetail.usermaster.emailaddress)
              })
            }
          })
          .catch((httpException) => {
            return this.$buefy.toast.open({
              message: httpException.message,
              type: 'is-danger'
            })
          })
      },
      emailsStatusWiseCount: function (agents) {
        let getCountObj = {
          subdepartmentid: this.filter.subdepartmentid.subdepartmentid,
          tlemailid: this.filter.tlemailid || '',
          amemailid: this.filter.amemailid || '',
          manageremailid: this.filter.manageremailid || '',
          assignedto: this.filter.agent
        }
        Object.keys(getCountObj).forEach((key) => {
          if (getCountObj[key] === '' || getCountObj[key] === null || getCountObj[key] === undefined) {
            delete getCountObj[key]
          }
        })
        this.isLoading = true;
        return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'fetchcasestatuscount',
          headers: commonFunction.getusertoken(),
          'data': getCountObj
        }).then((result) => {
          this.isLoading = false;
          if (result.data) {
           // console.log("result.data--------------------",result.data);
            // this.allocateCount = result.data.allocated.length && result.data.allocated[0].count ? result.data
            //   .allocated[0].count : 0
            this.allocateCount = (result.data.allocated[0] && result.data.allocated[0].count) ? result.data
              .allocated[0].count : 0
            this.inprocessCount = (result.data.inprocess.length && result.data.inprocess[0].count) ? result.data
              .inprocess[0].count : 0
          }
        }).catch((httpException) => {
          return this.$alertify.error(httpException.message)
        })
      },
      formatDatey(datef) {
          if (datef) {
              return moment(datef).format('DD-MM-YYYY');
          } else {
              return 'NA'
          }
      },
      formaEmailtDate(datef) {
        if (datef) {
        //   //Created Date -  handling with PHP code
        //   var minutesToAdd = 330;
        //   var currentDate = new Date(datef);
        //   var futureDate = new Date(currentDate.getTime() + minutesToAdd*60000);
        //   return moment(futureDate).format('DD/MM/YYYY hh:mm A');

         // Node Js Emailer Created Date 
          var currentDate = new Date(datef);
          return moment(currentDate).format('DD/MM/YYYY hh:mm A');
        } else {
           return 'NA'
         }
      },
      getEmailCases: function (agents) {
        this.loadCount=true;
        this.emailsStatusWiseCount(this.agents)
        if (this.filter.status === 'allocated' || this.filter.status === 'allocationpending' || this.filter
          .repeatstatus) {
          this.showReAllocationForm = true
        } else {
          this.showReAllocationForm = false
        }

        if (this.isSearch) {
          this.page = 0
        }
        // console.log("aded--------",this.filter.subdepartmentid.subdepartmentid);
        let getObj = {
          page: Number(this.pageSize * this.page),
          pageSize: this.pageSize,
          fromdate: this.filter.fromDate,
          todate: this.filter.toDate,
          //fcaccountid: this.filter.fcaccountid,
          status: this.filter.status,
          caseid: this.filter.caseid,
         subdepartmentid: this.filter.subdepartmentid.subdepartmentid,
         //coid: this.filter.coid,
          fromid: this.filter.fromemail,
          toid: this.filter.toemail,
          ccid: this.filter.ccemail,
          ticketid: this.filter.ticketid,
          assignedto: this.filter.agent,
         //tlemailid: this.filter.tlemailid,
         //amemailid: this.filter.amemailid,
         //manageremailid: this.filter.manageremailid,
          subject: this.filter.subject,
         //priority: this.filter.priorityEmail ? this.filter.priorityEmail : '',
         //shippingreferenceno: this.filter.awbno,
         //isrepeatemail: this.filter.isrepeatemail,
         // repeatstatus: this.filter.repeatstatus,
          maintypeid: this.filter.mainType,
          typeid: this.filter.type,
          subtypeid: this.filter.subType,
         //originatesource: this.filter.originatesource
         'Created_Date': this.Created_Date,
         'Modified_Date': this.Modified_Date,
          aiassisted : (this.filter.aiassisted==true)?this.filter.aiassisted:null
        }
        Object.keys(getObj).forEach((key) => {
          if (getObj['caseid'] || getObj['fromid'] || getObj['fcaccountid'] || getObj['ticketid'] || getObj[
              'shippingreferenceno']) {
            //delete getObj['fromdate']
            //delete getObj['todate']
            //delete getObj['status']
            delete getObj['tlemailid']
            delete getObj['amemailid']
            delete getObj['manageremailid']
          }
          if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
            delete getObj[key]
          }
        })
        this.isLoading = true
        this.selectedRows = [];
        return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'getallemailcase',
          headers: commonFunction.getusertoken(),
          'data': getObj
        }).then((result) => {

          this.isLoading = false
          this.isSearch = false
          this.emailCasesArray = []
          this.totalCount = 0

          if (result.data.rows && result.data.rows.length) {
            this.isSearchModal = false
            this.totalCount = Number(result.data.count)
            this.getTotalPages(Number(result.data.count))
            //let finalResult = stores.user.setStatusWiseCSS(result.rows)
            let finalResult = result.data.rows;
            this.emailCasesArray = finalResult;

          }
          else{
          // this.isSearchModal = false
          // this.$alertify.error('Cases not found.')
          if(this.filter.fromemail!=null){
              this.isSearchModal = false;
              this.$alertify.error('Data not found for from Email.');
          }
          else if(this.filter.toemail!=null){
            this.isSearchModal = false;
              this.$alertify.error('Data not found for to Email.');
          }
          else if(this.filter.ccemail!=''){
            this.isSearchModal = false
              this.$alertify.error('Data not found for cc Email.');
          }
              else if(this.filter.subject!=''){
              this.isSearchModal = false
              this.$alertify.error('Please Enter the valid Email Subject.')
            }
            else if(this.filter.caseid!=''){
              this.isSearchModal = false
              this.$alertify.error('Please Enter the valid caseid.')
            }else{
              this.isSearchModal = false
              this.$alertify.error('No data found.')
            }

          }
        this.loadCount=false;

        }).catch((httpException) => {
        this.loadCount=false;

          this.isLoading = false
          return this.$alertify.error(httpException.message)
        })
      },
      reallocateCase: function () {
        if (!this.selectedRows.length) {
          return this.$alertify.error( 'Select Case ID to reallocate.' )
        } else {
          let caseids = []
          this.selectedRows.forEach((data) => {
            let caseObj = {}
            if (data && data.assignedto) {
              caseObj.assignedto = data.assignedto
            }
            caseObj.caseid = Number(data.caseid)
            caseids.push(caseObj)
          })
          let reallocateObj = {
            emailaddress: this.reallocate.agent,
            username:this.username,
            caseids: caseids,
           // allocationreasoinid: this.reallocate.allocationreasoinid.allocationreasoinid,
           // comment: `${this.reallocate.allocationreasoinid.reasonname}. Comment: ${this.reallocate.comment}`,
           
           subdepartmentid: this.filter.subdepartmentid.subdepartmentid
          }
           return axios({
              'method': 'POST',
              'url': apiUrl.api_url + 'bulkreallocate',
              headers: commonFunction.getusertoken(),
              'data': reallocateObj
            }).then((result) => {

              this.reallocate.agent = ''
             // this.reallocate.allocationreasoinid = ''
             // this.reallocate.comment = ''
              this.selectedRows = []
              if (result.status) {
                this.getEmailCases();
                if(result.data.data.alreadyallocated !== undefined && result.data.data.alreadyallocated.length) {
                  this.$alertify.error( 'Case ID: '+result.data.data.alreadyallocated+' already allocated.' )
                }
                if(result.data.data.allocatesuccess !== undefined && result.data.data.allocatesuccess.length) {
                  this.$alertify.success( 'Case ID: '+result.data.data.allocatesuccess+' allocated successfully.' )
                }
                if(result.data.data.notInPendingAllocated !== undefined && result.data.data.notInPendingAllocated && result.data.data.notInPendingAllocated.length) {
                  this.$alertify.error( 'Case ID: '+result.data.data.notInPendingAllocated+' are not in AllocationPending/Allocated status.' )
                }

              }
            })
            .catch((httpException) => {
              return this.$alertify.error( httpException.message )
            })
        }
      },
      loadMore: function () {
        this.page++
        this.getEmailCases()
      },
      loadPrev: function () {
        this.page--
        this.getEmailCases()
      },
      changePageSize: function () {
        this.page = 0
        this.getEmailCases()
      },
      getTotalPages: function (result) {
        let total = parseInt(result / this.pageSize)
        let remainder = result % this.pageSize
        if (remainder > 0) {
          this.totalPages = total + 1
        } else {
          this.totalPages = total
        }
      },
      reset: function () {
        this.filter.coid = ''
        this.filter.ticketId = ''
        this.filter.status = ''
        //this.filter.toDate = moment().format('YYYY-MM-DD')
        //this.filter.fromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
        this.filter.toDate = ''
        this.filter.fromDate = ''
        this.emailCasesArray = []
        this.filter.agent = ''
        this.filter.fcaccountid = ''
        this.filter.caseid = ''
        this.filter.ticketid = ''
        this.filter.awbno = ''
        this.filter.fromemail = ''
        this.filter.toemail = ''
        this.filter.subject = ''
        this.filter.priorityEmail = false
        this.totalCount = 0
        this.totalPages = 0
        this.filter.isrepeatemail = false
        this.filter.repeatstatus = false
        this.filter.mainType = ''
        this.filter.type = ''
        this.filter.subType = ''
        this.filter.originatesource = ''
      },

      resetFilter(){        
      this.filter.toDate = ''
      this.filter.fromDate = ''
      // this.filter.agent = ''
      this.filter.status = ''
      this.filter.subject = ''
      this.filter.caseid = ''
      this.filter.fromemail = ''
      this.filter.toemail = ''
      this.filter.ccemail = ''
       this.filter.aiassisted = ''
      
      },

      checkIsNumber: function (number) {
        stores.user.isNumber(number)
      },
      getActiveAgents: function () {
        this.activeAgents = []
        this.reallocate.agent = ''
        //if (this.filter.tlemailid) {
          let getAgentObj = {
            systemid: this.loggedUser.systemId,
            emailaddress: this.filter.tlemailid,
            subdepartmentid: this.filter.subdepartmentid.subdepartmentid
          }

          return axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'getactiveagents',
            headers: commonFunction.getusertoken(),
            'data': getAgentObj
          }).then((result) => {
              if (result && result.data.length) {
                result.data.forEach((each) => {
                  if (each) {
                    this.activeAgents.push(each.emailaddress)
                  }
                })
              } else {
                return this.$alertify.error('No active agents found')
              }
            })
            .catch((httpException) => {
              return this.$alertify.error( httpException.message )
            })
        //}
      },
      toggleModal: function () {
        this.isSearchModal = !this.isSearchModal
        this.filter.toDate = moment().format('YYYY-MM-DD')
        this.filter.fromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')
      },
      applyFilter: function () {
        this.isSearchModal = !this.isSearchModal
        // this.filter.toDate = moment().format('YYYY-MM-DD')
        // this.filter.fromDate = moment().subtract(7, 'days').format('YYYY-MM-DD')

        if (this.filter.toDate && this.filter.fromDate) {
          let dateDiff = moment(this.filter.toDate).diff(this.filter.fromDate, 'days')
          if (Number(dateDiff) > 30) {
            return this.$alertify.error( 'Please select 30 days difference' )
          }
        }
        if(this.filter.caseid!=''){
          if(isNaN(this.filter.caseid)){
            this.isSearchModal = false
            return this.$alertify.error( 'Please enter number.' )
          }
        }
        this.isSearch = true
        if (this.isSearch && !this.filter.status && !this.filter.fcaccountid && !this.filter.toDate &&
          !this.filter.fromDate && !this.filter.fromemail && !this.filter.caseid) {
          return this.$alertify.error( 'Please select atleast one filter option.' )
        } else {
          this.getEmailCases()
        }
      },
      closeModal: function () {
        this.isSearch = false
        this.isSearchModal = false
        this.filter.coid = ''
        this.filter.ticketid = ''
        this.filter.toDate = ''
        this.filter.fromDate = ''
        this.filter.agent = ''
        this.filter.awbno = ''
        this.filter.customer = ''
        this.filter.fcaccountid = ''
        this.filter.caseid = ''
        this.filter.ticketid = ''
        this.filter.fromemail = ''
        this.filter.toemail = ''
        this.filter.subject = ''
        this.filter.priorityEmail = false
        this.filter.mainType = ''
        this.filter.type = ''
        this.filter.subType = ''
        this.filter.originatesource = ''
      },
      getDetailLevel: function (data, index ) {
        this.currentCaseId = '';
        this.getCaseObjData = data;
        this.caseObj = data;
        let getObj = {
          caseid: data.caseid
        }
        Object.keys(getObj).forEach((key) => {
          if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
            delete getObj[key]
          }
        })
        this.showDetails = false;
        return axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'ticketdetails',
            headers: commonFunction.getusertoken(),
            'data': getObj
          })
          .then((result) => {

            this.isSearchModal = false;
            this.isSearchTicket = false;
            if (result.data.data.data.length) {
              this.emailCasesArray[this.emailCasesArray.indexOf(data)].allTickets = result.data.data.data;
              this.currentCaseId  = index;
            }
            this.allTickets_shippingid = result.data.data.data[0].shippingid
            this.srDetailsByShippingId= this.allTickets_shippingid ;   //#emailer_srid 
            
            this.showDetails = true;
          })
          .catch((httpException) => {
            this.showDetails = true;
            console.log('Error In ticketdetailso', httpException)
          })
      },
      getDetailTicketStatusClose: function (data, index ) {
        this.currentCaseId = '';
        this.getCaseObjData = data;
        this.ticketStatusDataArray = []
        this.caseObj = data;
        let getObj = {
          caseid: data.caseid
        }
        Object.keys(getObj).forEach((key) => {
          if (getObj[key] === '' || getObj[key] === null || getObj[key] === undefined) {
            delete getObj[key]
          }
        })
        this.showDetails = false;
        return axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'ticketdetails',
            headers: commonFunction.getusertoken(),
            'data': getObj
          })
          .then((result) => {
            this.isSearchModal = false;
            this.isSearchTicket = false;
            if (result.data.data.data.length) {
             
              for (var i = 0; i < result.data.data.data.length; i++) {
                this.ticketStatusDataArray[i] = result.data.data.data[i].ticketstatus

                if(result.data.data.data[i].ticketstatus == 'Open' || result.data.data.data[i].ticketstatus == 'Follow Up' ){
                  this.confirmMessage = `Please Close ticket :${result.data.data.data[i].ticketid} then Closed Case Id : ${data.caseid} `
                  if(this.confirmMessage){
                    this.$alertify.error(this.confirmMessage)
                  }    
                } else {
                    this.actionType('Close',data);
                }
              }
            }
            this.allTickets_shippingid = result.data.data.data[0].shippingid
            // this.showDetails = true;
          })
          .catch((httpException) => {
            this.showDetails = true;
            console.log('Error In ticketdetailso', httpException)
          })
      },
      actionType: async function (type, t ) {
        try {
          //let permission = stores.user.hasPermission('/emailr/emailtracking', 'Modify')
          //if (permission) {
            if (type === 'assigntome') {
              let getObj = {
                caseid: t.caseid,
               subdepartmentid: this.filter.subdepartmentid.subdepartmentid,
                status: 'allocated'
              }
              let result = await axios({
                'method': 'POST',
                'url': apiUrl.api_url + 'getallemailcase',
                headers: commonFunction.getusertoken(),
                'data': getObj
              });
               // To check assignedto value when click on AssignTo Me and Marks As Spam Button
              if (result.data && result.data.rows && result.data.rows.length && result.data.rows[0].assignedto && this.filter.agent &&
                result.data.rows[0].assignedto.toLowerCase() === this.filter.agent.toLowerCase()) {
                this.actiontype = 'assigntome'
                this.ticketId = t.caseid
                this.confirmMessage = `Are you sure want to mark Case ID:${this.ticketId} as InProcess ?`
                this.$alertify.confirmWithTitle('Assign To Me' ,this.confirmMessage, ()=> this.changeCaseStatus('assigntome'),
                 () =>this.$alertify.error("cancel")
                )
              } else {
                this.getEmailCases()
                return this.$alertify.error('This case is not allocated to you.')
              }
            }
            if (type === 'markasspam') {
              this.actiontype = 'markasspam'
              this.ticketId = t.caseid
              this.confirmMessage = `Are you sure want to mark Case ID:${this.ticketId} as Spam ?`
              this.$alertify.confirmWithTitle( 'Mark As Spam',this.confirmMessage, ()=>
                  this.changeCaseStatus('markasspam')
                ,() =>this.$alertify.error("cancel")
                )
            }
            if (type === 'raiseticket') {
               this.resetModal();
               this.getTrackingSource();
			         this.getTrackingMainType();
               this.isTicketModal = true;
               this.ticketId = t.caseid
               this.caseObj = t;
            }
            if (type === 'autoreply') {
               this.replyType = "Auto Reply";
               this.ticketId = t.caseid
               this.getEmailTemplate();
               this.autoReplyModal = true;
               this.caseObj = t;
            }
            if (type === 'Close') {
              this.replyType = "Ticket closed Auto Reply";
              this.ticketId = t.caseid
              this.getEmailTemplate();
              this.autoReplyModal = false;
              this.changeCaseStatus('Close')
              this.caseObj = t;
            }
            if (type === 'followup') {
               this.replyType = "Follow up";
               this.ticketId = t.caseid
               this.getEmailTemplate();
               this.autoReplyModal = false;
              this.changeCaseStatus('followup')
               this.caseObj = t;
            }
          /*
          } else {
            return this.$buefy.toast.open({
              message: 'You do not have modify access !',
              type: 'is-danger'
            })
          }*/
        } catch (e) {
          console.log('Error in update email case', e)
        }
      },

      changeCaseStatus: async function (status) {
        try {
          let changeObj = {
            caseid: this.ticketId,
            emailaddress: this.filter.agent,
            location: this.userDetails.location || ''
          }
          if (status === 'assigntome') {

             window.open("#/emailtracking?status=InProcess","_blank")
            //this.filter.status = 'inprocess'
            changeObj.status = 'inprocess'
            changeObj.comment = 'email case marked as inprocess'
            window.location.reload()

          } else if (status === 'markasspam') {
            this.filter.status = 'spam'
            changeObj.comment = 'email case marked as spam'
            changeObj.status = 'spam'
          } else if (status === 'Close') {
            this.filter.status = 'Close'
            changeObj.comment = 'email case marked as close'
            changeObj.status = 'Close'
          } else if (status === 'followup') {
            this.filter.status = 'followup'
            changeObj.comment = 'email case marked as followup'
            changeObj.status = 'followup'
          }
          //axios.post(apiUrl.api_url + 'updateemailcase', changeObj);
         // await http.put(`${CONSTANTS.API_URL}/api/updateemailcase`, changeObj)
        //this.page = 0
        // this.getEmailCases();
        //  return this.$alertify.success('Saved successfully.');
        return axios({
         'method': 'POST',
         'url': apiUrl.api_url + 'updateemailcase',
         headers: commonFunction.getusertoken(),
         'data': changeObj
        }).then((result) => {
           this.isLoading = false
           this.page = 0
           this.getEmailCases();
           return this.$alertify.success('Saved successfully.');
        }).catch((HTTPException) => {
           this.isLoading = false
           this.$alertify.error(HTTPException.message );
         })
        } catch (httpException) {
          return this.$alertify.error( httpException.message );
        }
      },

      autoPushToInProcess: function () {
        let agentData = {
          emailaddress: this.filter.agent,
         subdepartmentid: this.filter.subdepartmentid.subdepartmentid
        }
         return axios({
          'method': 'POST',
          'url': apiUrl.api_url + 'caseautoinprocess',
          headers: commonFunction.getusertoken(),
          'data': agentData
        }).then((result) => {
            this.isLoading = false
        }).catch((HTTPException) => {
            this.isLoading = false
            this.$alertify.error(HTTPException.message );
          })
      },

      notAllowedPreview: function (caseid, status) {
        if (status.toLowerCase() !== 'inprocess' || status.toLowerCase() !== 'close') {
          this.$alertify.error( 'Case status must be InProcess or Close' );
        }
      },
      /*
      switchTab: function (CASEID) {
        this.selectedCaseID = CASEID;
         this.activeComponent = '';
         this.activeComponent = () => import('@/components/Emailr/emailCaseLog')
         this.selectedTab = 1;

      },*/

      showModelPOPs : function (CaseId){
        this.emailCasesArray = [];
        this.getEmailCases();
        this.getEmailCaseLog( CaseId )
        this.isSearchModal_1 = true
      },

      switchTab: function ( tabName, CaseId ) {

        if( tabName == 'Case List' ) {
           this.getEmailCases();
           this.activeComponent = 'Case List';
        }
        if( tabName == 'Email Case' ) {
          this.emailCasesArray = [];
          this.getEmailCaseLog( CaseId )
          this.activeComponent = 'Email Case';

        }
      },

      resetModal() {
        this.ticketResultMsg = '';
        this.ticketResultData = '';
        this.ticketResultMsg = '';
        this.ticketResultData = '';
        this.shippingIds = '';
        this.shippingIdState = null;
        this.shipments = [];
        this.shipmentResult = false;
        this.validShippingIds = [];
        this.invalidShippingIds = [];
      },

      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.shippingIdState = valid
        return valid
      },

      handleSubmit() {

        let shippingIds = this.shippingIds.toString().replace(/^,|,$/g, '');
        if (shippingIds === '') {
          this.$alertify.error('Please enter Shipping Ids.');
          return false;
        }
        let shippingIdsArr = shippingIds.split(',');
         this.input = ({
          Shipments: shippingIdsArr
        })
         //#emailer_srid  Validate that only one Shipping ID is entered
        if (shippingIdsArr.length > 1) {
          this.$alertify.error('Please enter only 1 Shipping ID.');
          return false;
        }
                this.isModalLoading = true;
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getShippingDataToSendSMS',
          headers: commonFunction.getusertoken(),
          'data': this.input
        })
        .then(result => {
            this.isModalLoading = false;
            this.shipmentResult = true;
            let resultDataCrm = result.data.data;

            if (resultDataCrm.status) {
              let resultData = result.data.data.data;
              if (resultData.ReturnCode === 100) {
                for( let i=0; i<resultData.ShipmentDetails.length;i++) {
                  this.validShippingIds.push( resultData.ShipmentDetails[i].ShippingID );

                   this.shipments.push( { 'shippingData' : {
                      'clientname'          : resultData.ShipmentDetails[i].BusinessAccountName,
                      'businessflow'        : resultData.ShipmentDetails[i].BusinessFlow,
                      'clientid'            : resultData.ShipmentDetails[i].ClientID,
                      'shipmentcreateddate' : resultData.ShipmentDetails[i].createdOn,
                      'currenthubid'        : resultData.ShipmentDetails[i].CurrentHubID,
                      'totalattempts'       : 0,
                      'shipmentstatus'      : resultData.ShipmentDetails[i].ShipmentStatus,
                      'shippingid'          : resultData.ShipmentDetails[i].ShippingID,
                      'status'              : resultData.ShipmentDetails[i].Status,
                      'createdOn'           : resultData.ShipmentDetails[i].CreatedDate,
                      'prexoType'           : resultData.ShipmentDetails[i].ExchangeType,
                      'prexoShipment'       : resultData.ShipmentDetails[i].ReferenceShipment
                   } });
                }
              }
            }
            this.srDetailsByShippingId=this.shipments[0].shippingData.shippingid;  //#emailer_srid 
            this.invalidShippingIds = shippingIdsArr.filter(x => ! this.validShippingIds.includes(x));

            let Test = this.emailCasesArray.find(element => element.caseid === this.caseObj.caseid.toString());
            if(this.AI_ENABLED == true && Test.aiassisted == 'Y'){
              // calling api getEmaileraidraftByCaseId
              this.input = ({
                Shipments: shippingIdsArr
              })
              axios({
                method: 'POST',
                'url': apiUrl.api_url + 'getEmaileraidraftByCaseId',
                headers: commonFunction.getusertoken(),
                'data': {'caseid':this.caseObj.caseid}
              })
              .then(async (result) => {
                let resultData1 = result.data.data.data;
                if (resultData1.code === 200) {
                  let sourceName = this.source.find(sourceD => sourceD.value.toString() == resultData1.data.sourceid);
                  this.selectedSource(sourceName);
                  this.businessFlow = resultData1.data.businessflow;
                  this.latestStatusByCaseid = resultData1.data.latest_status; //#multiple_download 
                  let ticketName = this.ticketType.find(ticketTypeD => ticketTypeD.value.toString() == resultData1.data.maintypeid);
                  this.selectedTicket(ticketName);
                  this.isLoading = true;
                  let token = 'edw3r323432472748923';
                  const secretKey = constantVariable.enckey;
                  const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
                  let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
                  this.input = ({
                    'departmentid': ecDepartmentID,
                    'maintypeid': resultData1.data.maintypeid,
                    'businessFlow': (this.businessFlow == 'Banking Client') ? 'BankingClient' : this.businessFlow,
                    'page': this.pageName
                  });

                  axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'getTrackingSubType',
                    'data': this.input,
                    headers: commonFunction.getusertoken(),
                  }).then(result => {
                    this.isLoading = false;
                    this.reason = result.data.data.data;
                    if (this.reason) {
                      let reasonName = this.reason.find(reasonD => reasonD.value.toString() == resultData1.data.subtypeid);
                      this.selectedReason(reasonName);
                      let token = 'edw3r323432472748923';
                      this.input = ({
                        'departmentid': this.DepartmentID,
                        'subtypeid': resultData1.data.subtypeid,
                        'businessFlow': (this.businessFlow == 'Banking Client') ? 'BankingClient' : this.businessFlow,
                        'page': this.pageName,
                        'notificationType': '',
                        'notificationStatus': '',
                        'status' : ''
                      });
                      axios({
                        method: 'POST',
                        'url': apiUrl.api_url + 'getTrackingType',
                        'data': this.input,
                        headers: commonFunction.getusertoken(),
                      }).then(result => {
                        this.isLoading = false;
                          this.subReason = result.data.data.data;
                          if (this.subReason) {
                              let subReasonName = this.subReason.find(subReasonD => subReasonD.value.toString() == resultData1.data.typeid);
                              this.selectedSubReason(subReasonName);
                               this.isLoading = true;
                              let token = 'edw3r323432472748923';
                              this.input = ({
                                subReasonId: resultData1.data.subtypeid,
                                status: this.status,
                                'page': this.pageName,
                                "departmentId":this.DepartmentID,
                                role: this.userRole
                              });
                              axios({
                                method: 'POST',
                                'url': apiUrl.api_url + 'getTicketAction',
                                'data': this.input,
                                headers: commonFunction.getusertoken(),
                              }).then(result => {
                                this.isLoading = false;
                                this.action = result.data.data.data;
                                if (this.action) {
                                      let resolutionname = this.action.find(actionD => actionD.value.toString() == resultData1.data.resolution);
                                      this.selectedAction(resolutionname);
                                }

                              }, error => {
                                this.isLoading = false;
                                let msg = error;
                                this.$alertify.error(msg);
                              })
                            }

                      }, error => {
                        this.isLoading = false;
                        let msg = error;
                        this.$alertify.error(msg);
                      }) 
                    
                    }
                  }, error => {
                    this.$alertify.error(msg);
                  })

                  //this.comments = resultData1.data.templatecomment
                  this.reply = resultData1.data.templatecontent;
                }
              }, error => {
                  this.isModalLoading = false;
                  this.$alertify.error(error);
              })
            }

        }, error => {
            this.isModalLoading = false;
            this.$alertify.error(error);
        })
      },
      sendAutoReply() {
          let emailList = [];
          this.replyToccValid = '';
          var noSpacesString= this.replyTocc1.toString().replace(/ /g,'');
          let objEmail = {};  
          let formData = new FormData();
          if (noSpacesString.toString().trim() != "") {
            emailList = noSpacesString.toString().split(",");
            let validEmail = [];
            let invalidEmail = [];
            var emailValidator =
              /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
            emailList.forEach((element) => {
            let searchReplytoCCMailID = apiUrl.EMAILR_CONFIG_DATA.findIndex(o => o.EMAILR_ACK_EMAIL === element);
              if(-1 !== searchReplytoCCMailID ){
                  invalidEmail.push(element);
                  this.invalidEmailFlag = true;
                  this.invalidEmail = invalidEmail.toString();
              } else if (element != "") {
                if (!element.match(emailValidator)) {
                  invalidEmail.push(element);
                  this.invalidEmailFlag = true;
                  this.invalidEmail = invalidEmail.toString();
                } else {
                  validEmail.push(element);
                  this.invalidEmailFlag = false;
                  this.invalidEmail = "";
                  this.replyToccValid = validEmail
                }
              } else {
                invalidEmail.push(element);
                this.invalidEmailFlag = true;
                this.invalidEmail = invalidEmail.toString();
                // return resolve({ status: false, message: "AWB No Is Required." })
              }
            });
            console.log(`Valid ${validEmail} invalid ${invalidEmail}`);
            if(this.invalidEmail !==''){
              this.isModalLoading = false;
              return false;
            }else {
                objEmail.replyTocc = validEmail.toString().split(",").join();
              }
          }
          var xy = document.getElementById('imagefile1');
          var MAX_FILE_SIZE = 5 * 1024 * 1024;
          if ('files' in xy) {
            if (xy.files.length > 0) {
              for (var i = 0; i < xy.files.length; i++) {
                //  console.log('file size::::::::::::::::::::::::: '+ xy.files[i].size );
                  if (xy.files[i].size > MAX_FILE_SIZE) {
                      this.$alertify.error("File must not exceed 5 MB!");
                      return false;
                  }
                  formData.append('uploadedFile', xy.files[i]);
              }
            }
          }
          if( this.caseObj.fromid != '') {
             objEmail.fromid = this.caseObj.fromid;
          }

          if( this.caseObj.toid != '') {
              objEmail.toid = this.caseObj.toid;
          }
          if( this.reply != '') {
              // let htmlBody = this.reply.replace(/(?:\r\n|\r|\n)/g,"<br>");
              // objEmail.reply = htmlBody;
              objEmail.reply = this.reply
          }
          if( this.caseObj.subject != '') {
              objEmail.subject = this.caseObj.subject;
          }

          if( this.data.toString().trim() == '' ) {
              this.$alertify.error('Message field is required.');
              this.isModalLoading = false;
              return false;
          }
          let objEmailData = JSON.stringify( objEmail );
          const secretKey = constantVariable.enckey;
            const encryptedData = AES.encrypt(this.data, secretKey).toString();
            const cleanEncryptedData = encryptedData.replace(/[=]/g, '_');
          formData.append('email', objEmailData );
          formData.append('subdepartmentid', this.caseObj.subdepartmentid);

          formData.append('emailaddress', this.caseObj.fromid);
          formData.append('toid', this.caseObj.toid);
          formData.append('fromid', this.caseObj.fromid);
          formData.append('subject', this.caseObj.subject);
          formData.append('caseid', this.caseObj.caseid);
          formData.append('inboxid', this.caseObj.inboxid);
          formData.append('replytype', this.replyType);
          formData.append('data', cleanEncryptedData);
          formData.append('createdby', this.username);
          formData.append('closecaseModal', this.closecaseModal);

          let replyToccReq=(this.replyToccValid && this.replyToccValid.length > 0) ? this.replyToccValid : "" ;
          formData.append('replyTocc1', this.replyToccValid.toString().split(",").join());
                    this.isModalLoading = true;
          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'sendautoreply',
            'data': formData,
            headers: commonFunction.getusertoken(),
          }).then(result => {
            this.isModalLoading = false;
            if (result.data.data.status == true ) {

              if (this.closecaseModal == 'Y' ){
                this.actionType('Close',this.caseObj);
                // this.changeCaseStatus('Close')
              }
              this.$alertify.success('Auto reply sent successfully.');
              this.autoReplyModal=false;
              this.invalidEmailFlag = false;
              this.invalidEmail = "";
              this.replyToccValid ="";
              this.replyTocc1='';
              xy = $('input[type=file]').val('');
            } else {
              this.invalidEmailFlag = false;
              this.$alertify.error('Error in sending - Auto reply');
              this.invalidEmail = "";
              this.replyToccValid ="";
            }


          }, error => {
            this.isModalLoading = false;
            this.invalidEmailFlag = false;
            this.invalidEmail = "";
            this.replyToccValid ="";
            var commonVariable=commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
      },
      /**
       * [get list of main type id and name]
       * @return {[Array]}
       */
      getMainType: function () {
        this.subTypeMasterIds = []
        this.mainTypeMasterIds = JSON.parse(localStorage.getItem('mainType'))
        if (!this.mainTypeMasterIds) {
          return http.get(`${CONSTANTS.API_URL}/api/get/maintypes`)
            .then(result => {
              this.mainTypeMasterIds = result
              localStorage.setItem('mainType', JSON.stringify(this.mainTypeMasterIds))
            })
            .catch((HTTPException) => {
              this.$buefy.toast.open({
                message: HTTPException.message,
                type: 'is-danger'
              })
            })
        }
      },
      /**
       * [Get types array id and name ]
       * @param  {[mainTypeID]} maintype
       * @return {[Array]}
       */
      getTypes: function (maintype) {
        this.filter.type = ''
        this.filter.subType = ''
        this.subTypeMasterIds = []
        this.localTypeMasterData = JSON.parse(localStorage.getItem('typeMaster'))
        if (this.localTypeMasterData) {
          this.typeMasterIds = this.localTypeMasterData.filter(each => each.maintypeid === maintype)
        } else {
          return http.get(`${CONSTANTS.API_URL}/api/get/types`)
            .then(result => {
              localStorage.setItem('typeMaster', JSON.stringify(result))
              this.typeMasterIds = result.filter(each => each.maintypeid === maintype)
            })
            .catch((HTTPException) => {
              this.$buefy.toast.open({
                message: HTTPException.message,
                type: 'is-danger'
              })
            })
        }
      },
      /**
       * [get subtypes array id and Name]
       * @param  {[typeId]} typeid
       * @return {[type]}
       */
      getSubTypes: function (typeid) {
        this.localSubTypeMasterData = JSON.parse(localStorage.getItem('subTypeMaster'))
        if (this.localSubTypeMasterData) {
          this.subTypeMasterIds = this.localSubTypeMasterData.filter(each => each.typeid === typeid)
        } else {
          return http.get(`${CONSTANTS.API_URL}/api/get/subtypes`)
            .then(result => {
              localStorage.setItem('subTypeMaster', JSON.stringify(result))
              this.subTypeMasterIds = result.filter(each => each.typeid === typeid)
            })
            .catch((HTTPException) => {
              this.$buefy.toast.open({
                message: HTTPException.message,
                type: 'is-danger'
              })
            })
        }
      },

      getEmailCaseLog: function (emailCaseID) {
        let object = {
          caseid: [emailCaseID]
        }
        return axios({
            'method': 'POST',
            'url': apiUrl.api_url + 'getemailcaselog',
            headers: commonFunction.getusertoken(),
            'data': object
          }).then((result) => {

            if (result && result.data.length) {
              // let finalResult = stores.user.setStatusWiseCSS(result)
              let finalResult = result.data;
              this.emailCaseLog = finalResult;

            }
          }).catch((httpException) => {
            this.$alertify.error( httpException.message )
          })
      },

      getTrackingSource() {
        try{
          let projectID = CryptoJS.AES.encrypt('$#@COD&&Mang&*^%$$', "xb-cod-security");
          let accessToken;

          this.isLoading = true;
          let token = 'edw3r323432472748923';

          this.input = ({
            'departmentid': '1',
            'usertype':'Agent'
          });

          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getTrackingSource',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          }).then(result => {
            this.isLoading = false;;
            this.source = result.data.data.data;

          }, error => {
            this.isLoading = false;
            var commonVariable=commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
		    } catch (error) {
          this.isLoading = false;
          let msg = error+" - getTrackingSource";
          this.$alertify.error(msg);
        }
		  },

      getEmailTemplate() {
        try{
          this.isModalLoading = true;
          this.input = ({
            'templateType': this.replyType
          });

          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getemailtemplate',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          }).then(result => {
            this.isModalLoading = false;
            this.data = '';
            this.template = result.data.data;
            this.data = this.template[0].template;

          }, error => {
            this.isModalLoading = false;
            var commonVariable=commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
		    } catch (error) {
          this.isModalLoading = false;
          let msg = error+" - getEmalTemplate";
          this.$alertify.error(msg);
        }
		  },

      getBusinessFlow: function (businessFlow) {
       this.getSearchtags( businessFlow );
      },

      selectedSource(sourceData) {
        try{
          this.selectedSourceObj = sourceData;
          this.sourceId = sourceData.value;

        }	catch (error) {
            this.isLoading = false;
            let msg = error+" - selectedSource";
            this.$alertify.error(msg);
          }
      },

      selectedReason(reasonData) {
        try{
          this.selectedReasonObj = reasonData;
          this.reasonId = reasonData.value.toString();
          this.selectedSubReasonObj = {};
          this.selectedActionObj = {};
          this.selectedTicketStatusObj = {};
          this.ticketStatusId = '';

          this.getTrackingType(this.reasonId, this.businessFlow);

        } catch (error) {
          this.isLoading = false;
          let msg = error+" - selectedReason";
          this.$alertify.error(msg);
        }
      },

      selectedTicket(ticketData) {
        try{
          this.selectedTicketObj = ticketData;
          this.ticketTypeId = ticketData.value.toString();
          this.selectedReasonObj = {};
          this.selectedSubReasonObj = {};
          this.subReason = [];
          this.selectedActionObj = {};

          this.getTrackingSubType(this.ticketTypeId, this.businessFlow);
        } catch (error) {
          this.isLoading = false;
          let msg = error+" - selectedTicket";
          this.$alertify.error(msg);
        }
      },

      selectedSubReason(subReasonData) {
        try{

          this.reAttemptDate = '';

          this.selectedSubReasonObj = subReasonData;
          this.subReasonId = subReasonData.value.toString();
          this.selectedActionObj = {};
          this.selectedTicketStatusObj = {};
          this.ticketStatusId = '';
          this.escalation = subReasonData.isescalation;
          this.getTicketAction(this.subReasonId, 'Add');

          let AiAssisted = this.emailCasesArray.find(element => element.caseid === this.caseObj.caseid.toString());
          if(this.AI_ENABLED == true && AiAssisted.aiassisted == 'Y'){         
            this.getSearchttemplates();
          }
          
        } catch (error) {
          this.isLoading = false;
          let msg = error+" - selectedSubReason";
          this.$alertify.error(msg);
        }
      },

      selectedAction(actionData) {
        try{
          if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup'  && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date'
            && this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR
                  && this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

            this.endDate = null;
            if(this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed' ){
                let tomorrow = new Date();
              if (this.startDate.getHours() < 20) {
                tomorrow.setDate(tomorrow.getDate() + 1 );
                this.startDate = tomorrow;
              } else {
                tomorrow.setDate(tomorrow.getDate() + 2);
                this.startDate = tomorrow;
              }
              let dateDisabled = new Date();
              dateDisabled.setDate(dateDisabled.getDate() + 7);
              this.endDate = dateDisabled;
            }
          } else {
            this.startDate  = new Date();
            let dateDisabled2 = new Date();
            dateDisabled2.setDate(dateDisabled2.getDate() + 6);
            this.endDate = dateDisabled2;
          }

          this.selectedActionObj = actionData;
          this.actionId = actionData.value.toString();
          this.alternateContactNo = ''; // Clear alternate contact number on action change
          this.getTicketActionStatus(actionData.value);
        }
        catch (error) {
          this.isLoading = false;
          let msg = error+" - selectedAction";
          // let msg = "Resolution/Action not found";
          //  this.$alertify.error(msg);
        }
      },
      onCheckclosecasemodal: function (event) {
        if (event.target.checked) {
          this.closecaseModal = "Y";
        } else {
          this.closecaseModal = "N";
        }
      },
      
      onCheckModifiedDate: function (event) {
        if (event.target.checked) {
          this.Modified_Date = "Y";
          this.Created_Date = "N";
        } else {
          this.Modified_Date = "N";
          this.Created_Date = "Y";
        }
      },

      onCheckCreatedDate: function (event) {
        if (event.target.checked) {
           this.Modified_Date = "N";
           this.Created_Date = "Y";
        } else {
         this.Modified_Date = "Y";
          this.Created_Date = "N";
        }
      },
      selectedTicketStatus(ticketStatusData) {
        this.selectedTicketStatusObj = ticketStatusData;
        this.ticketStatusId = ticketStatusData.value.toString();
      },

      selectedSearchTag(SelectedTagData) {
        try{
          this.selectedSearchObj = SelectedTagData;
          this.searchId = SelectedTagData.value.toString();
          this.getSearchResult(SelectedTagData.id, SelectedTagData.type, this.businessFlow);
        }	catch (error) {
          this.isLoading = false;
          let msg = error+" - selectedSearchTag";
          this.$alertify.error(msg);
        }
      },

      getTicketActionStatus(actionId) {

        let accessToken;
        this.isLoading = true;
        let token = 'edw3r323432472748923';
        let status1 = (true == this.tableShipment) ? 'Edit' : 'Add';
        this.reAttemptDate = (status1 == 'Edit' && this.ticket.reattemptdate != null) ? this.ticket.reattemptdate : '';

        this.input = ({
          actionId: actionId,
          status: status1
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTicketActionStatus',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {

          this.isLoading = false;
          if (result.data.data.status == true) {
            let arrStatus = [];
            this.ticketStatus = [];
            arrStatus = result.data.data.data[0].ticketstatus.toString().split(",");

            for (let i = 0; i < arrStatus.length; i++) {
              this.ticketStatus.push({
                'value': arrStatus[i],
                'text': arrStatus[i]
              });
            }
            this.selectedTicketStatusObj = this.ticketStatus[0];
            this.ticketStatusId = this.selectedTicketStatusObj.value;
          }

        }, error => {

          let msg = error;
          this.$alertify.error(msg);
        })
      },

      getTrackingMainType() {

        let accessToken;

        this.isLoading = true;
        let token = 'edw3r323432472748923';

        this.input = ({
          'departmentid': '1',
          'page': this.pageName
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTrackingMainType',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          this.ticketType = result.data.data.data;

        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        })
      },

      getTrackingSubType(mainTypeId, businessFlow) {

        if( this.businessFlow == '' ) {
         // this.$alertify.error('Please select Business Flow.');
          return false;
        }
        let accessToken;

        this.isLoading = true;
        let token = 'edw3r323432472748923';
        const secretKey = constantVariable.enckey;
        const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
        let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
        this.input = ({
          'departmentid': ecDepartmentID,
          'maintypeid': mainTypeId,
          'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
          'page': this.pageName
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTrackingSubType',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          this.reason = result.data.data.data;
          if (this.reason) {
            if (this.businessFlow == 'Reverse' && this.ticketTypeId == '2') {
              var indexReason = this.reason.findIndex(o => o.text == 'POD related');
              if (-1 !== indexReason) {
                this.reason.splice(indexReason, 1);
              }
            }
          } else {
            let msg = constantVariable.UNAUTORISED_USER_MSG;
            this.$alertify.error(msg);
          }

        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        })
      },

      getTrackingType(subTypeId, businessFlow) {

        let accessToken;

        this.isLoading = true;
        let token = 'edw3r323432472748923';

        this.input = ({
          'departmentid': this.DepartmentID,
          'subtypeid': subTypeId,
          'businessFlow': (businessFlow == 'Banking Client') ? 'BankingClient' : businessFlow,
          'page': this.pageName,
          'notificationType': '',
          'notificationStatus': '',
          'status' : ''
        });
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTrackingType',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
            this.subReason = result.data.data.data;
            if (this.subReason) {

              let subReasonTempData = [];

              if (this.businessFlow == 'Forward' || this.businessFlow == 'Reverse') {
                // if ((this.SalesDemo.ClientID != constantVariable.ICICI_BANK_LTD && this.SalesDemo.ClientID != constantVariable.RBL_BANK) && this.SalesDemo.BusinessType != 'BFSI') {

                var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
                if (-1 !== indexRedirectBank) {
                  this.subReason.splice(indexRedirectBank, 1);
                }
                var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
                if (-1 !== indexSecondaryBank) {
                  this.subReason.splice(indexSecondaryBank, 1);
                }
                var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

                if (-1 !== indexPrimaryBank) {
                  this.subReason.splice(indexPrimaryBank, 1);
                }

              } else {

                var indexRedirectBank = this.subReason.findIndex(o => o.text == 'Redirect to Bank');
                if (-1 !== indexRedirectBank) {
                  subReasonTempData.push(this.subReason[indexRedirectBank]);
                  // this.subReason.splice(indexRedirectBank, 1);
                }

                var indexSecondaryBank = this.subReason.findIndex(o => o.text == 'Redirect to secondary address');
                if (-1 !== indexSecondaryBank) {
                  subReasonTempData.push(this.subReason[indexSecondaryBank]);
                  // this.subReason.splice(indexSecondaryBank, 1);
                }

                var indexPrimaryBank = this.subReason.findIndex(o => o.text == 'Redirect to primary address');

                if (-1 !== indexPrimaryBank) {
                  subReasonTempData.push(this.subReason[indexPrimaryBank]);
                  //  this.subReason.splice(indexPrimaryBank, 1);
                }

                this.subReason = subReasonTempData;
              }

            } else {
              let msg = constantVariable.UNAUTORISED_USER_MSG;
              this.$alertify.error(msg);
            }

        }, error => {
          this.isLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      },

      getTicketAction(subReasonId, status) {
        let accessToken;

        this.isLoading = true;
        let token = 'edw3r323432472748923';

        this.input = ({
          subReasonId: subReasonId,
          status: status,
          'page': this.pageName,
          "departmentId":this.DepartmentID,
          role: this.userRole
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getTicketAction',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          this.action = result.data.data.data;  
           //#emailer_srid get srid acccoridng to subreason
          if(constantVariable.SrSubReasonIdArr.includes(Number(subReasonId))){
             this.getSRID();
          } else {
            this.shouldShowLabel = false;
          }
          if (this.action) {

            let flag = false;
            let rvpflag = false;

            if (this.selectedSubReasonObj.text =='Delay in service') {
              var indexAction = this.action.findIndex(o => o.text == 'Information given');
              this.action[indexCsTeam].text = 'Information given';
            }

            var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');
            if (-1 !== indexCsTeam) {
              if( this.businessFlow == 'Forward' || this.businessFlow == 'Banking Client' ) {
                this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
              }
              if( this.businessFlow == 'Reverse' ) {
                this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
              }
            }

            if (this.subDepartmentList) {
              for (var i = 0; i < this.subDepartmentList.length; i++) {
                if( ( this.businessFlow == 'Forward'  || this.businessFlow == 'Banking Client' ) && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' ) {
                  if( this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT ) {
                    flag = true;
                    break;
                  }
                }
              }
              for (var i = 0; i < this.subDepartmentList.length; i++) {

              if( this.businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' ) {
                  if( this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT ) {
                      rvpflag = true;
                      break;
                  }
                }
              }
            }

            if( 'Admin' !== this.userRole && flag == false ) {
              var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
              if (-1 !== indexRTONotify) {
                if( this.businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team' ) {
                  this.action.splice(indexRTONotify, 1);
                }
                if( this.businessFlow  == 'Reverse' ) {
                  this.action.splice(indexRTONotify, 1);
                  }
              }
            }

            if( 'Admin' !== this.userRole ) {
              var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

              if (-1 !== indexPickupCancelled) {

                if( this.businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false ) {
                  this.action.splice(indexPickupCancelled, 1);
                }

                if( this.businessFlow == 'Forward' ) {
                  this.action.splice(indexPickupCancelled, 1);
                }

              }
            }
            if (this.selectedSubReasonObj.text =='Delay in service' || this.selectedSubReasonObj.text =='Fake update' ||
              this.selectedSubReasonObj.text =='PDD Crossed') {

              var indexAction = this.action.findIndex(o => o.text == 'Information given');
              if (-1 !== indexAction) {
                this.action.splice( indexAction, 1);
              }
            }

            if (this.selectedSubReasonObj.text =='Delivered - Product missing' || this.selectedSubReasonObj.text =='Delivered - Product Damaged') {

              var indexAction = this.action.findIndex(o => o.text == 'Assign to SLPV');
              if (-1 !== indexAction) {
                this.action.splice( indexAction, 1);
              }
            }

            if (this.selectedSubReasonObj.text =='Prospect franchisee owner') {

              var indexAction = this.action.findIndex(o => o.text == 'Assigned to Business Development');
              if (-1 !== indexAction) {
                this.action.splice( indexAction, 1);
              }
            }
             if ('Admin' !== this.userRole) {

            //Remove Address updated tagging for non admin user.
            var indexAddressUpdated = this.action.findIndex(o => o.text == 'Address Updated');
            if (-1 !== indexAddressUpdated) {
             
              if (flag == false && status == 'Edit') {
                this.action.splice(indexAddressUpdated, 1);
              }
            }
          }

            //Remove Contact details updated tagging for non admin user.
           if ('Admin' !== this.userRole) {
            var indexContactUpdated = this.action.findIndex(o => o.text == 'Contact details updated');
            if (-1 !== indexContactUpdated) {
           
              if ( flag == false && status == 'Edit') {
                this.action.splice(indexContactUpdated, 1);
              }
            }
          }

            if (this.selectedSubReasonObj.text =='Argued with the customer') {

              var indexAction = this.action.findIndex(o => o.text == 'Referred to L&D');
              if (-1 !== indexAction) {
                this.action.splice( indexAction, 1);
              }
            }
//              if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address') {

//             this.location = this.RTODetails.CustomerName;
//             if ('edit' == status) {
//               this.address = this.RTODetails.Address;
//               this.pincode = this.RTODetails.PinCode;
//             }
//           }

//           if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Redirect to Bank') {

//             this.location = this.CustomerDetails.CustomerName;
// console.log("this.CustomerDetails.CustomerName====================",this.CustomerDetails.CustomerName);
//             // if ('edit' == status) {
//             //   this.address = this.CustomerDetails.Address;
//             //   this.pincode = this.CustomerDetails.Pincode;
//             // }
//           }


          } else {
            let msg = constantVariable.UNAUTORISED_USER_MSG;
            this.$alertify.error(msg);
          }

        }, error => {
          this.isLoading = false;
          let msg = error;
          this.$alertify.error(msg);
        })
      },
      getSearchtags(businessFlow) {
        try{
          if( this.businessFlow == '' ) {
            this.$alertify.error('Please select Business Flow.');
            return false;
          }
          let accessToken;

          this.isLoading = true;
          let token = 'edw3r323432472748923';
          const secretKey = constantVariable.enckey;
          const encryptedData = AES.encrypt(this.DepartmentID.toString(), secretKey).toString();
          let ecDepartmentID = encryptedData.replace(/[=]/g, '_');
          this.input = ({
            "departmentid": ecDepartmentID,
            'businessFlow': this.businessFlow,
            "page": this.pageName
          });

          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getSearchOption',
            'data': this.input,
            headers: commonFunction.getusertoken(),
          }).then(result => {
            this.isLoading = false;
            this.searchOptions = result.data.data.data;

            Object.entries(this.searchOptions).forEach(entry => {
              entry[1].value = entry[1].id;
              entry[1].text = entry[1].name;
            });

          }, error => {
            this.isLoading = false;
            var commonVariable=commonFunction.showNetworkError(error);
            this.$alertify.error(commonVariable);
          })
        }	catch (error) {
          this.isLoading = false;
          let msg = error+" - getSearchtags";
          this.$alertify.error(msg);
        }
      },

      getSearchResult(id, type, businessFlow) {
        let accessToken;
        this.isLoading = true;
        let token = 'edw3r323432472748923';

        this.input = ({
          "id": id,
          "type": type,
          "businessFlow": businessFlow,
          "page": this.pageName,
          "departmentId": this.DepartmentID,
          "role":this.userRole
        });

        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSearchResult',
          'data': this.input,
          headers: commonFunction.getusertoken(),
        }).then(result => {
          this.isLoading = false;
          let flag = false;
					let rvpflag = false;

          if (undefined !== result.data.data.data.main_data) {
            this.ticketType = result.data.data.data.main_data;
            this.selectedTicketObj = this.ticketType.find(o => o.selected == 1);
            this.ticketTypeId = this.selectedTicketObj.value;
          }

          if (undefined !== result.data.data.data.sub_data) {
            this.reason = result.data.data.data.sub_data;
            this.selectedReasonObj = this.reason.find(o => o.selected == 1);
          }
          if (undefined !== result.data.data.data.type_data) {
            this.subReason = result.data.data.data.type_data;
            this.selectedSubReasonObj = this.subReason.find(o => o.selected == 1);
            
            this.escalation = ( undefined != this.selectedSubReasonObj ) ? this.selectedSubReasonObj.isescalation : 0;
             //#emailer_srid get srid accoridng to subreason
            if (this.subReason && this.subReason.length !=0 && (constantVariable.SrSubReasonIdArr.includes(Number(this.subReason[0].value)))) {
                this.getSRID();
            } else {
                this.shouldShowLabel = false;
            }

            this.escalation = ( undefined != this.selectedSubReasonObj ) ? this.selectedSubReasonObj.isescalation : 0;
            let AiAssistedflag = this.emailCasesArray.find(element => element.caseid === this.caseObj.caseid.toString());
            if(this.AI_ENABLED == true && AiAssistedflag.aiassisted == 'Y'){         
            this.getSearchttemplates();
            }

          }
          if (undefined !== result.data.data.data.action_data) {
            this.action = result.data.data.data.action_data;
            var indexCsTeam = this.action.findIndex(o => o.text == 'Assigned to Client Support');

            if (-1 !== indexCsTeam) {
              if (businessFlow == 'Forward') {
                this.action[indexCsTeam].text = 'Assigned to Fwd Client Support Team';
              } else {
                this.action[indexCsTeam].text = 'Assigned to Rvp Client Support Team';
              }
            }
            if (this.subDepartmentList) {
              for (var i = 0; i < this.subDepartmentList.length; i++) {
                if ( businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                  if (this.subDepartmentList[i].value === constantVariable.FWD_ClIENT_SUPPORT) {
                    flag = true;
                    break;
                  }
                }
              }
              for (var i = 0; i < this.subDepartmentList.length; i++) {

                if ( businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam] != undefined && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team') {
                  if (this.subDepartmentList[i].value === constantVariable.RVP_ClIENT_SUPPORT) {
                    rvpflag = true;
                    break;
                  }
                }
              }
            }
            if ('Admin' !== this.userRole && this.selectedSubReasonObj.text == 'Change Reattempt Date') {
              if (flag == false) {
                let indexOpsTeam = this.action.findIndex(o => o.text == 'Arranged - Assigned to Ops Team');
                if (-1 !== indexOpsTeam) {
                  this.action.splice(indexOpsTeam, 1);
                } else {
                  this.action.push('Assigned to Fwd Client Support Team');
                }
              } else {
                let indexFwdCsTeam = this.action.findIndex(o => o.text == 'Assigned to Fwd Client Support Team');
                if (-1 !== indexFwdCsTeam) {
                  this.action.splice(indexFwdCsTeam, 1);
                }
              }
            }

            if ('Admin' !== this.userRole && flag == false) {
              var indexRTONotify = this.action.findIndex(o => o.text == 'RTO Notified');
              if (-1 !== indexRTONotify) {
                if ( businessFlow == 'Forward' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Fwd Client Support Team') {
                  this.action.splice(indexRTONotify, 1);
                }

              }
            }
            if ('Admin' !== this.userRole) {
              var indexPickupCancelled = this.action.findIndex(o => o.text == 'Pickup Cancelled');

              if (-1 !== indexPickupCancelled) {

                if ( businessFlow == 'Reverse' && -1 !== indexCsTeam && this.action[indexCsTeam].text == 'Assigned to Rvp Client Support Team' && rvpflag == false) {
                  this.action.splice(indexPickupCancelled, 1);
                }
              }
            }

          // if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address') {

          //   this.location = this.RTODetails.CustomerName;
          //   // this.address = this.RTODetails.Address;
          //   // this.pincode = this.RTODetails.PinCode;

          // }

          // if (this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' || this.selectedSubReasonObj.text == 'Redirect to Bank') {

          //   this.location = this.CustomerDetails.CustomerName;
          //   console.log("this.CustomerDetails.CustomerName================4570==",this.CustomerDetails.CustomerName);
          //   // this.address = this.CustomerDetails.Address;
          //   // this.pincode = this.CustomerDetails.Pincode;
          // }
          // console.log("this.location==============4573,this.location");

            this.selectedActionObj = {};
          }

          if (undefined !== this.selectedReasonObj) {
            this.reasonId = this.selectedReasonObj.value;
          } else {
            this.reasonId = '';
            this.selectedReasonObj = {};
          }
          if (undefined !== this.selectedSubReasonObj) {
            this.subReasonId = this.selectedSubReasonObj.value;

          } else {
            this.subReasonId = '';
            this.selectedSubReasonObj = {};
          }

        }, error => {
          let msg = error;
          this.$alertify.error(msg);
        })
      },

	    resetAddTicket() {
        this.sourceId = '';
        this.selectedSourceObj = {
          value: '',
          text: ''
        };

			  this.ticketTypeId = '',
				this.selectedTicketObj = {
					value: '',
					text: ''
				};

			  this.reasonId = '',
				this.selectedReasonObj = {
					value: '',
					text: ''
				};

			  this.subReasonId = '',
				this.selectedSubReasonObj = {
					value: '',
					text: ''
				};

			  this.actionId = '',
				this.selectedActionObj = {
					value: '',
					text: ''
				};

			  this.ticketStatusId = '',
				this.selectedTicketStatusObj = {
					value: '',
					text: ''
				};

        this.searchId = '';
        this.selectedSearchObj = {
          value: '',
          text: ''
        };
        this.reAttemptDate = '';
        this.allSelected = false;
        this.comments = '';
        // this.listTotalCount = 0;
        this.replyTocc = '';
        this.replyTocc1 = [];
        this.reply  = '';
	  	},

     saveBulkClick(){
        this.validated = true
        // Re-enable after 5 seconds
        this.timeout = setTimeout(() => {
          this.validated = false
        }, 5000)
        this.saveBulkShipment();
      },

           async saveBulkShipment() {
        try{
          let accessToken;

          let token = 'edw3r323432472748923';
          if (this.shipments.length == 0) {
            this.$alertify.error('Please select shipment to create ticket.');
            return false;
          }

          if( this.businessFlow == '' ) {
             this.$alertify.error('Please select Business Flow.');
             return false;
          }

          if (this.sourceId === '') {
            this.$alertify.error('Please select Source.');
            return false;
          }

          if (this.ticketTypeId === '') {
            this.$alertify.error('Please select Ticket Type.');
            return false;
          }

          if (this.reasonId === '') {
            this.$alertify.error('Please select Reason.');
            return false;
          }

          if (this.subReasonId === '') {
            this.$alertify.error('Please select Sub Reason.');
            return false;
          }

          if (this.actionId === '') {
            this.$alertify.error('Please select Action.');
            return false;
          }
           //#emailer_srid  this should be auto enabled if the subreasonId matches only else no
              if (this.srid === '' && this.shouldShowLabel === true) {
                this.$alertify.error('Please select SR ID.');
                return false;
              }
              if (this.srname === '' && this.shouldShowLabel === true) {
                this.$alertify.error('Please select SR Name.');
                return false;
              }

          let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';
          let address = (this.address != null && this.address != '') ? this.address : '';
          let pincode = (this.pincode != null && this.pincode != '') ? this.pincode : '';
          let alternateContactNo = (this.alternateContactNo != null && this.alternateContactNo != '') ? this.alternateContactNo : '';
          

          if (attempDate.length != 10 && attempDate !== '') {
            attempDate = moment(String( attempDate )).format('YYYY-MM-DD');
          }

          if (9 == this.reasonId && this.excelFileUploadPath === '' && this.selectedBusinessFlowObj.text == 'Forward') {
            this.$alertify.error('Please Upload excel for address.');
            return false;
          }

          if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
            this.fakeNdrStatus = 1;
          }

        
          if (this.selectedReasonObj.text == 'Arrange delivery') {

            if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Urgent delivery' ||
              this.selectedSubReasonObj.text == 'Self collect') {

              if (this.reAttemptDate == '') {
                this.$alertify.error('Please enter reattempt date.');
                return false;
              }
            }
          }

        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
          this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
          this.selectedSubReasonObj.text == 'Redirect to Bank') &&
          (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (address === '') {
            this.$alertify.error('Please enter address details.');
            return false;
          }
        }


        if ((this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
          this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
          this.selectedSubReasonObj.text == 'Change misroute pincode' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
          this.selectedSubReasonObj.value == constantVariable.CHANGE_PINCODE || this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_PINCODE ||
          this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE) &&
          (this.selectedActionObj.text == 'Address Updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (pincode == '') {
            this.$alertify.error('Please enter pincode.');
            return false;
          }
        }
        
        if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No' &&
          (this.selectedActionObj.text == 'Contact details updated' || this.selectedActionObj.value == constantVariable.ASSIGNED_CS_TEAM)) {

          if (!alternateContactNo || !/^\d{10}$/.test(alternateContactNo)) {
            this.$alertify.error('Please enter Valid 10-digit alternate contact number.');
            return false;
          }
        }
        if (this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Redirect to Bank' && (this.BusinessType == 'Ecomm' || this.BusinessType == 'BFSI')) {
          console.log("this.selectedSubReasonObj.text");
          this.ServiceName = 'Delivery';
           }
   
          if(( this.selectedActionObj.text !=  "Already out for delivery" && this.selectedActionObj.text !="Already out for pickup" ) && ( this.selectedActionObj.text !=  "Information given" && this.selectedActionObj.text != "Already in Escalation ")) 
          {
            if((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
              (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update') || 
              this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
              this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR ||
              this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY   )  
             {
                if (this.reAttemptDate == '') {
                this.$alertify.error('Please enter reattempt date.');
                return false;
              }
              }
          }

          if (this.selectedReasonObj.text == 'Arrange pickup') {

            if (this.selectedSubReasonObj.text == 'Future pickup' || this.selectedSubReasonObj.text == 'Urgent pickup' ||
              this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup') {

              if (this.reAttemptDate == '') {
                this.$alertify.error('Please enter reattempt date.');
                return false;
              }
            }
          }
          if (this.comments === '') {
            this.$alertify.error('Please enter comments.');
            return false;
          }
          if( document.getElementById('to_email')== null || document.getElementById('to_email') == '' ) {
             this.$alertify.error('Email To field is required.');
             return false;
          }
    
        let businessFlow;

        if ((this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_ADDRESS || this.selectedSubReasonObj.value == constantVariable.CHANGE_RTO_PINCODE) && (this.BusinessType == 'Ecomm' || this.BusinessType == 'BFSI')) 
        {        
          this.ServiceName = 'RTO';
          this.businessFlow = 'Reverse';
        }

        if (this.selectedSubReasonObj.text == 'Change DTO address' || this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Redirect to Bank' ||
          this.selectedSubReasonObj.value == constantVariable.CHANGE_DTO_PINCODE || this.selectedSubReasonObj.value == constantVariable.CHANGE_DELIVERY_PINCODE &&
          (this.BusinessType == 'Ecomm' || this.BusinessType == 'BFSI')) {
          this.ServiceName = 'Delivery';

        }

         if (this.ServiceName && this.ServiceName =='IntraSDD') {
                 this.input.businessunit = 'Intracity';
          }
          if (location !== '' && location != null) {
          this.input.location = location;
          }
          
          if (alternateContactNo != '' && alternateContactNo != null) {
          this.input.alternateContactNo = alternateContactNo;
          }
          if( this.reply.toString().trim() == '' ) {
             this.$alertify.error('Message field is required.');
             return false;
          }
          let formData = new FormData();
          var x = document.getElementById('image-file');
          var MAX_FILE_SIZE = 5 * 1024 * 1024;
          if ('files' in x) {
            if (x.files.length > 0) {
              for (var i = 0; i < x.files.length; i++) {
                //  console.log('file size : '+ x.files[i].size );
                  if (x.files[i].size > MAX_FILE_SIZE) {
                      this.$alertify.error("File must not exceed 5 MB!");
                      return false;
                  }
                  formData.append('uploadedFile', x.files[i]);
              }
            }
          }

          // const secretKey = constantVariable.enckey;
          // const encryptedData = AES.encrypt(this.comments.toString(), secretKey).toString();
          // this.comments = encryptedData.replace(/[=]/g, '_');

          let shipmentsData = JSON.stringify( this.shipments );
          formData.append('sourceId', this.sourceId.toString() );
          formData.append('ticketTypeId', this.ticketTypeId.toString() );
          formData.append('reasonId', this.reasonId.toString() );
          formData.append('subReasonId', this.subReasonId.toString() );
          formData.append('action', this.actionId.toString() );
          formData.append('ticketStatusId', this.ticketStatusId.toString() );
          formData.append('reAttemptDate', attempDate );          
          formData.append('alternateContactNo', alternateContactNo );
          formData.append('address', address );
          formData.append('pincode', pincode );
          formData.append('location', this.location );
          formData.append('routemode', 'surface' );
          formData.append('businessunit',this.BusinessType );
          formData.append('businessservice', this.ServiceName );
          formData.append('pincodebusinessflow', this.businessFlow );
          formData.append('deptid', this.DepartmentID.toString() );
          formData.append('userId', this.userid );
          formData.append('username', this.username );
          formData.append('shippingData', shipmentsData );
          // formData.append('comments', this.comments );
          formData.append('userType', this.userTypeForTicket );
          formData.append('businessflow', this.businessFlow );
          formData.append('escalation', this.escalation );
          formData.append('subReason', this.selectedSubReasonObj.text );
          formData.append('caseId', this.caseObj.caseid );
          formData.append('inboxid', this.caseObj.inboxid );
          formData.append('configid', this.caseObj.configid );
          formData.append('assignedto', this.caseObj.assignedto );
          formData.append('page', this.pageName );
              //hub_escalation
          formData.append('SourceName',this.selectedSourceObj.text);
        //hub_escalation
          // console.log(formData,"====")
           //#emailer_srid push tikcet srid ticket data
          if (constantVariable.SrSubReasonIdArr.includes(Number(this.subReasonId))) {
            formData.append('srid',this.srid);
            formData.append('srname',this.srname);
           }       
           let objEmail = {};

          if( this.caseObj.fromid != '') {
             objEmail.fromid = this.caseObj.fromid;
          }

      
          if( this.caseObj.toid != '') {
              objEmail.toid = this.caseObj.toid;
          }
          // if( this.replyTocc != '') {
          //     objEmail.replyTocc = this.replyTocc;
          // }

          if( this.reply != '') {
              // let htmlBody = this.reply.replace(/(?:\r\n|\r|\n)/g,"<br>");
              // objEmail.reply = htmlBody;
              objEmail.reply = this.reply;
          }
          if( this.caseObj.subject != '') {
              objEmail.subject = this.caseObj.subject;
          }
            let emailList = []
            var noSpacesString= this.replyTocc1.toString().replace(/ /g,'');
            if (noSpacesString.toString().trim() != "") {
              emailList = noSpacesString.toString().split(",");
              let validEmail = []
              let invalidEmail = []
              var emailValidator = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
              emailList.forEach(element => {
                let searchReplytoCCMailID = apiUrl.EMAILR_CONFIG_DATA.findIndex(o => o.EMAILR_ACK_EMAIL === element);
                if(-1 !== searchReplytoCCMailID ){
                  invalidEmail.push(element);
                  this.invalidEmailFlag = true;
                  this.invalidEmail = invalidEmail.toString();
                } else if (element != "") {
                  if (!element.match(emailValidator)) {
                    invalidEmail.push(element);
                    this.invalidEmailFlag = true;
                    this.invalidEmail = invalidEmail.toString();
                  } else {
                    validEmail.push(element);
                    this.invalidEmailFlag = false;
                    this.invalidEmail = "";
                    this.replyTocc = validEmail
                  }
                } else {
                  invalidEmail.push(element);
                  this.invalidEmailFlag = true;
                  this.invalidEmail = invalidEmail.toString();
                  // return resolve({ status: false, message: "AWB No Is Required." })
                }
              });
              console.log(`Valid ${validEmail} invalid ${invalidEmail}`);
              if(this.invalidEmail !==''){
                this.isModalLoading = false;
                return false;
              } else {
                objEmail.replyTocc = validEmail.toString().split(",").join();
              }
          }
          let objEmailData = JSON.stringify( objEmail );
          const secretKey1 = constantVariable.enckey;
          const encryptedData1 = AES.encrypt(objEmailData.toString(), secretKey1).toString();
          objEmailData = encryptedData1.replace(/[=]/g, '_');
          formData.append('email', objEmailData );
          //PII ENC/DEC for comments field
          const secretKey = constantVariable.enckey;

          if (this.comments !== "" && this.comments != null) {
          if (
            this.selectedReasonObj.value === constantVariable.NON_BEHAVIORAL &&
            (this.selectedSubReasonObj.value ===
              constantVariable.VENDOR_DELAY_PICKUP ||
              this.selectedSubReasonObj.value ===
                constantVariable.VENDOR_FAKE_NPR)
          ) {
            this.comments =
              this.selectedSubReasonObj.text + " - " + this.comments;
          }
        }
          const encryptedData = AES.encrypt(this.comments.toString(), secretKey).toString();
          this.comments = encryptedData.replace(/[=]/g, '_');
          formData.append('comments', this.comments ); // Append  comment to form data
          this.isModalLoading = true;
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'createCswaTicket',
              'data':formData,
              'min': 1,
              'idle': 10000,
              'acquire': 10000,
              'evict': 60000,
              'handleDisconnects': true,
              headers: commonFunction.getusertoken(),
          })
          .then(result => {


if (result.data && result.data.data && result.data.data.status) {
     /*Start IP Tracking */
            let userTrackerObj = {};
            userTrackerObj.subReason = this.selectedSubReasonObj.text;
            userTrackerObj.ticketData = this.shipments;
            userTrackerObj.userid = this.userid;
            userTrackerObj.username = this.username;
            userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
            userTrackerObj.projectname = apiUrl.project_name;
            userTrackerObj.trackurl = this.$route.path;
            userTrackerObj.eventTrack ="EmailerCreateTicket " + userTrackerObj.subReason;
            authFunction.userTrackerEmailer(userTrackerObj);
            /*End IP Tracking */

}
          


              this.isModalLoading = false;
              this.ticketResultMsg = result.data.data.msg ? result.data.data.msg :"Ticket added successfully.";
              this.ticketResultModal = true;
              this.ticketResultData = '';
              this.ticketResultData = result.data.data;

              if (result.data.data.data != '') {
                this.ticket = result.data.data.data.data;
              // console.log("this.ticket1 ---- ",this.ticket);
              }
              // this.shipments = [];
              this.isTicketModal = true;
          
            }, error => {
              this.isLoading = false;
              console.error(error);
              this.isModalLoading = false;
            })
        }catch (error) {
          this.isLoading = false;
          let msg = error+" - saveBulkShipment";
          this.$alertify.error(msg);
        }
      },

      select: function (selectedObj, index, event) {

        this.allSelected = false;
        if (event.target.checked) {

          this.ticketShipmentData.push({
            'index': index,
            'shippingData': {
              'ShippingID': selectedObj.ShippingID,
              'CurrentHubID': selectedObj.CurrentHubID,
              "TotalAttemptCount": selectedObj.TotalAttemptCount,
              "UserProcess": selectedObj.UserProcess,
              "NotificationType": selectedObj.NotificationType,
              "NotificationStatus": selectedObj.NotificationStatus,
              "ClientName": selectedObj.ClientName,
              'BusinessFlow': selectedObj.BusinessFlow,
              "Status": selectedObj.Status,
              "CurrentStatus": selectedObj.CurrentStatus,
              "CreatedDate": selectedObj.CreatedDate,
              "OrderType": selectedObj.OrderType
            }
          });
        } else {
          this.ticketShipmentData.splice(this.ticketShipmentData.findIndex(o => o.index == index), 1);
        }
      },

      selectTicket(selectedObj, index, event) {
        this.allSelected = false;
        if (event.target.checked) {
          this.ticketExistedData.push({
            'index': index, // 'shippingData': selectedObj
            'shippingData': {
              'shippingid': selectedObj.shippingid,
              'ticketid': selectedObj.ticketid,
              'sourceid': selectedObj.sourceid,
              'tickettypeid': selectedObj.tickettypeid,
              'reasonid': selectedObj.reasonid,
              'subreasonid': selectedObj.subreasonid,
              'ticketstatus': selectedObj.ticketstatus,
              'hub': selectedObj.hub,
              'attempts': selectedObj.attempts,
              'comments': selectedObj.comments,
              'businessflow': selectedObj.businessflow
            }
          });
          let intPosition = this.ticketExistedData.findIndex(o => o.index == index);
          this.comments = selectedObj.comments;   //#common_fixes Encrypted comment content displayed in UI when updating existing ticket via emailer
          if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
            (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
            (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

            this.ticketExistedData[intPosition].shippingData.reattemptdate = selectedObj.reattemptdate;
          }

          if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
            this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
            this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

            this.ticketExistedData[intPosition].shippingData.name = selectedObj.name;
            this.ticketExistedData[intPosition].shippingData.address = selectedObj.address;
            this.ticketExistedData[intPosition].shippingData.pincode = selectedObj.pincode;
          }

          if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

            this.ticketExistedData[intPosition].shippingData.ordertype = selectedObj.ordertype;
            this.ticketExistedData[intPosition].shippingData.netpayment = selectedObj.netpayment;
          }

          if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

            this.ticketExistedData[intPosition].shippingData.alternatecontactnumber = selectedObj.alternatecontactnumber;
          }

          if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

            this.ticketExistedData[intPosition].shippingData.emailaddress = selectedObj.emailaddress;
          }

        } else {
          this.ticketExistedData.splice(this.ticketExistedData.findIndex(o => o.index == index), 1);
        }
      },

      selectAllCheckbox() {
        //this.rackIds = [];

        if (this.selectAllRecord == 'false') {
          this.$alertify.error("Please Select Atleast one ticket.")
          return false;
        }

        if (this.selectAllRecord) {
          var i = 0;

          for (let indexId in this.ticket) {

            if (this.ticketIDS.indexOf(this.ticket[indexId].ticketid) == -1) {
              this.ticketIDS.push(this.ticket[indexId].ticketid);

              this.ticketExistedData.push({
                'index': i, // 'shippingData': this.shipmentTickets[indexId],
                'shippingData': {
                  'shippingid': this.ticket[indexId].shippingid,
                  'hub': this.ticket[indexId].hub,
                  'attempts': this.ticket[indexId].attempts,
                  'comments': this.ticket[indexId].comments,
                  'businessflow': this.ticket[indexId].businessflow
                }

              });

              if (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup' ||
                (this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
                (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) {

                this.ticketExistedData[indexId].shippingData.reattemptdate = this.ticket[indexId].reattemptdate;
              }

              if (this.selectedSubReasonObj.text == 'Change RTO address' || this.selectedSubReasonObj.text == 'Change DTO address' ||
                this.selectedSubReasonObj.text == 'Change delivery address' || this.selectedSubReasonObj.text == 'Change Pickup address' ||
                this.selectedSubReasonObj.text == 'Redirect to Bank' || this.selectedSubReasonObj.text == 'Change misroute pincode') {

                this.ticketExistedData[indexId].shippingData.name = this.ticket[indexId].name;
                this.ticketExistedData[indexId].shippingData.address = this.ticket[indexId].address;
                this.ticketExistedData[indexId].shippingData.pincode = this.ticket[indexId].pincode;
              }

              if (this.selectedSubReasonObj.text == 'Change payment mode / amount') {

                this.ticketExistedData[indexId].shippingData.ordertype = this.ticket[indexId].ordertype;
                this.ticketExistedData[indexId].shippingData.netpayment = this.ticket[indexId].netpayment;
              }

              if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Alternate Contact No') {

                this.ticketExistedData[indexId].shippingData.alternatecontactnumber = this.ticket[indexId].alternatecontactnumber;
              }

              if (this.selectedReasonObj.text == 'Update Contact Details' && this.selectedSubReasonObj.text == 'Update Email Address') {

                this.ticketExistedData[indexId].shippingData.emailaddress = this.ticket[indexId].emailaddress;
              }
            }
            i++;
          }
        } else {
          for (let indexId in this.ticket) {
            if (this.ticketIDS.indexOf(this.ticket[indexId].ticketid) >= 0) {

              this.ticketIDS.splice(this.ticketIDS.indexOf(this.ticket[indexId].ticketid), 1);
              this.ticketExistedData.splice(this.ticketExistedData.findIndex(o => o.index == this.ticket[indexId].indexId), 1);
            }
          }
        }
      },

      updateSelectedAction(actionData) {

        try {

          if (this.selectedSubReasonObj.text !== 'Urgent delivery' && this.selectedSubReasonObj.text !== 'Urgent pickup' && this.selectedSubReasonObj.text !== 'RTO Reattempt' && this.selectedSubReasonObj.text !== 'Fake update' && this.selectedSubReasonObj.text !== 'DTO Reattempt' && this.selectedSubReasonObj.text !== 'Change Reattempt Date' &&
            this.selectedSubReasonObj.value !== constantVariable.DELAY_IN_PICKUP_SUB_REASON && this.selectedSubReasonObj.value !== constantVariable.FAKE_NPR &&
            this.selectedSubReasonObj.value !== constantVariable.DENIED_PICKUP && this.selectedSubReasonObj.value !== constantVariable.FAKE_NDR && this.selectedSubReasonObj.value !== constantVariable.REFUSED_DOORSTEP_DELIVERY && this.selectedSubReasonObj.text !== 'Delay in service') {

            this.endDate = null;
            if (this.selectedSubReasonObj.text == 'Future delivery' || this.selectedSubReasonObj.text == 'Future Pickup' || this.selectedSubReasonObj.text == 'Pickup without QC' || this.selectedSubReasonObj.text == 'Exceptional pickup' || this.selectedSubReasonObj.text == 'Self collect' || this.selectedSubReasonObj.text == 'PDD Crossed' ||
              this.selectedSubReasonObj.value == constantVariable.DELAY_IN_PICKUP_SUB_REASON || this.selectedSubReasonObj.value == constantVariable.FAKE_NPR ||
              this.selectedSubReasonObj.value == constantVariable.DENIED_PICKUP || this.selectedSubReasonObj.value == constantVariable.FAKE_NDR || this.selectedSubReasonObj.value == constantVariable.REFUSED_DOORSTEP_DELIVERY) {

              let tomorrow = new Date();
              if (this.startDate.getHours() < 20) {
                tomorrow.setDate(tomorrow.getDate() + 1);
                this.startDate = tomorrow;
              } else {
                tomorrow.setDate(tomorrow.getDate() + 2);
                this.startDate = tomorrow;
              }
              let dateDisabled = new Date();
              dateDisabled.setDate(dateDisabled.getDate() + 7);
              this.endDate = dateDisabled;
            }

          } else {
            this.startDate = new Date();
            let dateDisabled2 = new Date();
            dateDisabled2.setDate(dateDisabled2.getDate() + 6);
            this.endDate = dateDisabled2;
          }


          this.selectedActionObj = actionData;
          this.actionId = actionData.value.toString();
          this.tableShipment = true;
          this.getTicketActionStatus(actionData.value);

          this.disPayment = true;

        } catch (error) {
          this.isLoading = false;
          let msg = error + " - selectedAction";
          this.$alertify.error(msg);
        }
      },

      saveBulkEditShipment() {
        try {

          let token = 'edw3r323432472748923';

          if (this.ticketTypeId === '') {
            this.$alertify.error('Please select Ticket Type.');
            return false;
          }

          if (this.reasonId === '') {
            this.$alertify.error('Please select Reason.');
            return false;
          }

          if (this.subReasonId === '') {
            this.$alertify.error('Please select Sub Reason.');
            return false;
          }

          if (this.actionId === '') {
            this.$alertify.error('Please select Action.');
            return false;
          }
           //#emailer_srid 
          if (this.srid === '' && this.shouldShowLabel === true) {
          this.$alertify.error('Please select SR ID.');
          return false;
          }
          if (this.srname === '' && this.shouldShowLabel === true) {
            this.$alertify.error('Please select SR Name.');
            return false;
          }
          let attempDate = (this.newReAttemptDate != null && this.newReAttemptDate != '') ? this.newReAttemptDate : '';

          if (attempDate.length != 10 && attempDate !== '') {
            attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
          }

          if (this.ticketExistedData.length == 1 && (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup') && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

            if (attempDate == '') {
              this.$alertify.error('Please enter reattempt date.');
              return false;
            }
          }

          if (this.ticketExistedData.length == 1 && ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
              (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

            if (attempDate == '') {
              this.$alertify.error('Please enter reattempt date.');
              return false;
            }
          }

          if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
            this.fakeNdrStatus = 1;
          }

          this.input = ({
            ticketIds: this.ticketIDS.toString(),
            ticketData: this.ticketExistedData,
            sourceId: this.sourceId.toString(),
            ticketTypeId: this.ticketTypeId.toString(),
            reasonId: this.reasonId.toString(),
            subReasonId: this.subReasonId.toString(),
            action: this.actionId.toString(),
            ticketStatusId: this.ticketStatusId.toString(),
            reAttemptDate: attempDate,
            deptid: this.DepartmentID.toString(),
            userId: this.userid,
            username: this.username,
            filename: this.excelFileUploadPath,
            comments: this.comments,
            userType: this.userTypeForTicket,
            IsFakeNDRStatus: this.fakeNdrStatus,
            businessflow: this.ticketExistedData[0].shippingData.businessflow,
            // businessflow: this.getCaseObjData.allTickets[0].businessflow != ""  ? this.getCaseObjData.allTickets[0].businessflow  :  this.ticketExistedData[0].shippingData.businessflow ,
            escalation: this.escalation,
            editHoldTicket: this.editHoldTicket
          });
             //#emailer_srid 
          if (constantVariable.SrSubReasonIdArr.includes(Number(this.subReasonId))) {
            formData.append('srid',this.srid);
            formData.append('srname',this.srname);
           } 
          this.isModalLoading = true;
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'createBulkEditTickets',
              'data': JSON.stringify(this.input),
              'min': 1,
              'idle': 10000,
              'acquire': 10000,
              'evict': 60000,
              'handleDisconnects': true,
              headers: commonFunction.getusertoken(),
            })
            .then(result => {


if (result.data && result.data.data && result.data.data.status) {
   /*Start IP Tracking */
            let userTrackerObj = {};
            userTrackerObj.subReason = this.selectedSubReasonObj.text;
            userTrackerObj.ticketData = this.input.ticketData;
            userTrackerObj.userid = this.userid;
            userTrackerObj.username = this.username;
            userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
            userTrackerObj.projectname = apiUrl.project_name;
            userTrackerObj.trackurl = this.$route.path;
            userTrackerObj.eventTrack ="EmailerUpdateTicket " + userTrackerObj.subReason;
            authFunction.userTrackerEmailer(userTrackerObj);
            /*End IP Tracking */
}


              // this.resetAddTicket();
              this.isModalLoading = false;
              this.ticketResultMsg1 = '';
              this.ticketResultMsg1 = result.data.data.msg;

               this.ticketResultData1 = '';
              this.ticketResultData1 = result.data.data;
              this.ticketResultData1 = this.ticket[0];
              // console.log(" this.ticketResultData<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<", this.ticketResultData);
                 
                if (result.data.data.data != '') {
                this.ticket = result.data.data.data.data;
              }

              this.shipments = [];
              // this.isTicketModal = true;
              this.shipmentResult = true;
              this.allSelected = false;
              this.ticket = [];
              this.ticketIDS = [];
              this.ticketExistedData = []
              this.selectAllRecord = false;
              this.listExisitngTicketModal = false;
              this.updateExistingBulkTicket = false;
              this.showBulkTicketDiv = false;
               this.isTicketModal1 = true;

            }, error => {
              this.isLoading = false;
            })
          return false;
        } catch (error) {
          this.isLoading = false;
          let msg = error + " - saveBulkShipment";
          this.$alertify.error(msg);
        }
      },

      resetShipment(){
        this.shippingIds='';
      },
      resetraiseticketform(){
//console.log("resetraiseticketform this.selectedTicketStatusObj.text ",this.selectedTicketStatusObj.text);
//console.log("rrrrrrrrr this.this.ticketResultData1.status.status  ",this.ticketResultData1.status);

      this.isTicketModal1 = false;
      this.editEmailerTicketModal = false;
      this.isTicketModal=false;
      if( this.selectedTicketStatusObj.text === 'Closed' && this.ticketResultData.status == true ){
        // console.log("Close Ticket Redirect close case modal");
        this.actionType('Close',this.caseObj);
      } else if( this.selectedTicketStatusObj.text === 'Open' && this.ticketResultData.status == true  ){
        // console.log("Inprocess Ticket Redirect to followup");
        this.actionType('followup',this.caseObj);

} else if( this.selectedTicketStatusObj.text === 'Follow Up' && this.ticketResultData1.status == true  ){
         console.log("Inprocess already exist Ticket Redirect to followup");
        this.actionType('followup',this.caseObj);
      


      } else  if( this.selectedTicketStatusObj.text === 'Closed' && this.ticketResultData1.status == true ){
        // console.log("Update Close Ticket Redirect close case modal");
        this.actionType('Close',this.caseObj);
      }
      this.shippingIds='';
      this.businessFlow='';
      this.sourceId = '';
      this.ticketResultData = '';
      this.ticketResultData1 = '';
      this.ticketResultMsg = '';
      this.ticketResultMsg1 = '';
      this.invalidEmailFlag = false;
      this.invalidEmail = "";
      this.replyToccValid ="";

      this.selectedSourceObj = {
        value: '',
        text: ''
      };

      this.ticketTypeId = '';
      this.selectedTicketObj = {
        value: '',
        text: ''
      };

      this.reasonId = '';
      this.selectedReasonObj = {
        value: '',
        text: ''
      };

      this.subReasonId = '';
      this.selectedSubReasonObj = {
        value: '',
        text: ''
      };

      this.actionId = '';
      this.selectedActionObj = {
        value: '',
        text: ''
      };

      this.ticketStatusId = '';
      this.selectedTicketStatusObj = {
        value: '',
        text: ''
      };

      this.searchId = '';
      this.selectedSearchObj = {
        value: '',
        text: ''
      };
      this.reAttemptDate = '';
      this.location = '';
      this.address = '';
      this.pincode = '';
      this.ServiceName ='';
      this.alternateContactNo = '';
      //this.orderType = [{
      //  value: 'cod/prepaid',
      //  text: 'COD <> Prepaid'
      //}];
      this.netPayment = '';
      this.orderTypeId = '';
      this.selectedOrderTypeObj = {
        value: '',
        text: ''
      };
      this.reply  = '';
      //this.alternateContactNo = '';
      //this.mobileNo = '';
      this.comments = '';
      this.ticketShipmentData = [];
      this.ticket = {};
      //this.emailAddress = '';
      //this.OtherShipmentShippingIDCheckedArr = [];
      this.replyTocc1 = '';
      },
      saveBulkEditShipmentAndSendMail() {

        try {
          let token = 'edw3r323432472748923';

          if (this.ticketTypeId == '') {
            this.$alertify.error('Please select Ticket Type.');
            return false;
          }

          if (this.reasonId == '') {
            this.$alertify.error('Please select Reason.');
            return false;
          }

          if (this.subReasonId == '') {
            this.$alertify.error('Please select Sub Reason.');
            return false;
          }

          if (this.actionId == '') {
            this.$alertify.error('Please select Action.');
            return false;
          }

          // let attempDate = (this.newReAttemptDate != null && this.newReAttemptDate != '') ? this.newReAttemptDate : '';
          let attempDate = (this.reAttemptDate != null && this.reAttemptDate != '') ? this.reAttemptDate : '';
          if (attempDate.length != 10 && attempDate !== '') {
            attempDate = moment(String(attempDate)).format('YYYY-MM-DD');
          }

          if (this.ticketExistedData.length == 1 && (this.selectedReasonObj.text == 'Arrange delivery' || this.selectedReasonObj.text == 'Arrange pickup') && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

            if (attempDate == '') {
              this.$alertify.error('Please enter reattempt date.');
              return false;
            }
          }

          if (this.ticketExistedData.length == 1 && ((this.selectedReasonObj.text == 'Non Behavioral' && this.selectedSubReasonObj.text == 'Delay in service') ||
              (this.selectedReasonObj.text == 'SR related' && this.selectedSubReasonObj.text == 'Fake update')) && this.selectedActionObj.text == 'Arranged - Assigned to Ops Team') {

            if (attempDate == '') {
              this.$alertify.error('Please enter reattempt date.');
              return false;
            }
          }

          if (this.selectedReasonObj.text == 'Complaint' && this.selectedSubReasonObj.text == 'Fake update') {
            this.fakeNdrStatus = 1;
          }
          let emailList = [];
          this.replyToccValid = '';
          var noSpacesString= this.replyTocc1.toString().replace(/ /g,'');
          if (noSpacesString.toString().trim() != "") {
            emailList = noSpacesString.toString().split(",");
          // if (this.replyTocc1.toString() != "") {
          //   emailList = this.replyTocc1.toString().split(",");
            let validEmail = [];
            let invalidEmail = [];
            var emailValidator = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
            emailList.forEach((element) => {
            let searchReplytoCCMailID = apiUrl.EMAILR_CONFIG_DATA.findIndex(o => o.EMAILR_ACK_EMAIL === element);
              if(-1 !== searchReplytoCCMailID ){
                  invalidEmail.push(element);
                  this.invalidEmailFlag = true;
                  this.invalidEmail = invalidEmail.toString();
              } else if (element != "") {
                if (!element.match(emailValidator)) {
                  invalidEmail.push(element);
                  this.invalidEmailFlag = true;
                  this.invalidEmail = invalidEmail.toString();
                } else {
                  validEmail.push(element);
                  this.invalidEmailFlag = false;
                  this.invalidEmail = "";
                  this.replyToccValid = validEmail
                }
              } else {
                invalidEmail.push(element);
                this.invalidEmailFlag = true;
                this.invalidEmail = invalidEmail.toString();
                // return resolve({ status: false, message: "AWB No Is Required." })
              }
            });
            console.log(`Valid ${validEmail} invalid ${invalidEmail}`);
            if(this.invalidEmail !==''){
              this.isModalLoading = false;
              return false;
            }
          }

          if( this.reply.toString().trim() == '' ) {
              this.$alertify.error('Message field is required.');
              this.isModalLoading = false;
              return false;
          }


//console.log("this.ticket here ",this.ticket);
//console.log("this.ticketExistedData ",this.ticketExistedData);
//console.log("this.this.getCaseObjData.caseid ",this.getCaseObjData.caseid);

this.input = ({
          //  caseid : this.getCaseObjData.caseid, // Already Exist Scenario
            ticketIds: this.ticketIDS.toString(),
            ticketData: this.ticketExistedData,
            sourceId: this.sourceId.toString(),
            ticketTypeId: this.ticketTypeId.toString(),
            reasonId: this.reasonId.toString(),
            subReasonId: this.subReasonId.toString(),
            action: this.actionId.toString(),
            ticketStatusId: this.ticketStatusId.toString(),
            reAttemptDate: attempDate,
            deptid: this.DepartmentID.toString(),
            userId: this.userid,
            username: this.username,
            filename: this.excelFileUploadPath,
            comments: this.comments,
            userType: this.userTypeForTicket,
            IsFakeNDRStatus: this.fakeNdrStatus,
          // businessflow: this.getCaseObjData.allTickets[0].businessflow != ""  ? this.getCaseObjData.allTickets[0].businessflow  :  this.ticketExistedData[0].shippingData.businessflow ,
            escalation: this.escalation,
            editHoldTicket: this.editHoldTicket,
            toid : this.caseObj.toid,
            fromid : this.caseObj.fromid,
            // replyTocc : this.replyTocc1,
            replyTocc: this.replyToccValid.toString().split(",").join(),
            inboxid : this.caseObj.inboxid,
            subject : this.caseObj.subject,
            reply:this.reply,
          });
          
//console.log("this.caseObj ",this.caseObj);
//console.log("this.this.caseObj.caseid ",this.caseObj.caseid);


if (this.alreadyExistTicket) {
 // this.input.caseid = this.ticket[0].caseid?this.ticket[0].caseid:this.caseObj.caseid; // Already Exist Scenario
  this.input.caseid = this.caseObj.caseid; // Already Exist Scenario
  this.input.businessflow=this.ticketExistedData[0].shippingData.businessflow;
        } else {
  this.input.caseid = this.getCaseObjData.caseid;
   this.input.businessflow=this.getCaseObjData.allTickets[0].businessflow != ""  ? this.getCaseObjData.allTickets[0].businessflow  :  this.ticketExistedData[0].shippingData.businessflow;  // For Update already
 }


          let replyToccReq=(this.input.replyTocc && this.input.replyTocc.length > 0)?this.input.replyTocc:"";
          this.input.replyTocc=replyToccReq;

          this.isModalLoading = true;

          const secretKey = constantVariable.enckey;
          const encryptedData = AES.encrypt(this.input.reply, secretKey).toString();
          this.input.reply = encryptedData.replace(/[=]/g, '_');
          const encryptedcomments = AES.encrypt(this.input.comments, secretKey).toString();
          this.input.comments = encryptedcomments.replace(/[=]/g, '_');
          const encryptcomment = AES.encrypt(this.input.ticketData[0].shippingData.comments, secretKey).toString();
          this.input.ticketData[0].shippingData.comments = encryptcomment.replace(/[=]/g, '_');                    
          axios({
              method: 'POST',
              // 'url': apiUrl.api_url + 'createCswaTicket_update',
              'url' : apiUrl.api_url + 'createBulkShipmentTickets1',
              'data': this.input,
              'min': 1,
              'idle': 10000,
              'acquire': 10000,
              'evict': 60000,
              'handleDisconnects': true,
              headers: commonFunction.getusertoken(),
            })
            .then(result => {


if (result.data && result.data.data && result.data.data.status) {
 /*Start IP Tracking */
            let userTrackerObj = {};
            userTrackerObj.subReason = this.selectedSubReasonObj.text;
            userTrackerObj.ticketData = this.input.ticketData;
            userTrackerObj.userid = this.userid;
            userTrackerObj.username = this.username;
            userTrackerObj.olduserid = this.OldDeliveryUserOrUserId;
            userTrackerObj.projectname = apiUrl.project_name;
            userTrackerObj.trackurl = this.$route.path;
            userTrackerObj.eventTrack ="EmailerUpdateTicket " + userTrackerObj.subReason;
            authFunction.userTrackerEmailer(userTrackerObj);
            /*End IP Tracking */
}


              this.isModalLoading = false;
              this.ticketResultMsg1 = '';
              this.ticketResultMsg1 = result.data.data.msg;
              this.ticketResultData1 = '';
              this.ticketResultData1 = result.data.data;
              this.shipments = [];
              this.isTicketModal1 = true;
            }, error => {
              this.isLoading = false;
            })
          return false;
        } catch (error) {
          this.isLoading = false;
          let msg = error + " - saveBulkEditShipmentAndSendMail";
          this.$alertify.error(msg);
        }
      },

      getSearchttemplates() {
        try{

          this.isLoading = true;
          let ReturnMsg = 'The draft response is not found. Kindly provide the response to the Email manually.'

          this.input = ({
            "emaitypeid": this.selectedTicketObj.value.toString()            ,
            "categoryid": this.selectedReasonObj.value.toString(),
            "subcategoryid": this.selectedSubReasonObj.value.toString()
          });
          //#multiple_download fetch latestStatus By Caseid
          if (this.latestStatusByCaseid && this.latestStatusByCaseid.trim() !== '') {
              this.input.latest_status = this.latestStatusByCaseid;
          }

          axios({
            method: 'POST',
            'url': apiUrl.api_url + 'getemplatedata',
            'data': this.input,
            'headers': commonFunction.getusertoken(),
          }).then(result => {

            this.isLoading = false;

            if (result && result.data.data.data.template_content) {
              let searchTemplateOptions = result.data.data.data.template_content;
              let replacements = {
              AWB: this.shippingIds,
              };
              searchTemplateOptions = searchTemplateOptions.replace(/{(AWB)}/g, (match, p1) => replacements[p1]);
              this.reply = searchTemplateOptions
              this.latestStatusByCaseid = '';  //#multiple_download handle
            } else {
              this.reply = ''
              this.$alertify.error(ReturnMsg);
            }

          }, error => {
            this.isLoading = false;
            var commonVariable=commonFunction.showNetworkError(error);
            this.$alertify.error(ReturnMsg);
          })
        }	catch (error) {
          this.isLoading = false;
          let msg = error+" - getSearchttemplates";
          this.$alertify.error(ReturnMsg);
        }
      },

       //#emailer_srid  method to selectedSRID to get srName
    selectedSRID(selectedOption) {
      this.selectedSRIDnObj = selectedOption;
      this.srid = (this.selectedSRIDnObj.text) ? this.selectedSRIDnObj.text : this.selectedSRIDnObj;
      this.getSRName(this.selectedSRIDnObj);
    },
     //#emailer_srid method to get sr id 
    getSRID() {
      this.isLoading = true;
      this.SRIDsId = '';
      this.SRNameId = '';
      this.srid = '';
      this.srname = '';
      this.selectedSRIDnObj = {};
      this.selectedSRNamenObj = {};
      this.shouldShowLabel = true;
      
        let payload = {
          shippingid:   this.srDetailsByShippingId
        };
      axios({
        method: 'POST',
        'url': apiUrl.api_url + 'getSrIdByShipment',
        'data': payload,
        headers: commonFunction.getusertoken(),
      }).then(result => {
        this.isLoading = false;
        this.SRIDs = result.data.data ? result.data.data : [];
        console.log(this.SRIDs,"this.SRIDs");
        
        if (this.SRIDs && this.SRIDs.length === 1) {
          this.SRIDsId = this.SRIDs[0];
          this.srid = this.SRIDsId;
          if (this.srid && this.srid.includes('SR details are not being fetched at the moment')) {
            this.shouldShowLabel = false;
            this.$alertify.error('SR details are not being fetched at the moment.');
            return;
          }
          this.selectedSRIDnObj = { value: this.SRIDs[0], text: this.SRIDs[0] };
          this.getSRName(this.SRIDs[0]);
        } else {
          this.SRIDs = this.SRIDs.map(item => ({
            value: '',
            text: item
          }));
        }
      }, error => {
        this.isLoading = false;
        var commonVariable = commonFunction.showNetworkError(error);
        this.$alertify.error(commonVariable);
      }).catch((error) => {
        this.isLoading = false;
        this.$alertify.error(error);
      });
    },
    
    selectedSRName(selectedOption) {
      this.selectedSRNamenObj = selectedOption;
      this.srname = (this.selectedSRNamenObj.text) ? this.selectedSRNamenObj.text : this.selectedSRNamenObj
    },
     //#emailer_srid method to get srName accoridng to srId
    getSRName(selectedSRIDnObj){
        this.isLoading = true;
        this.SRNameId = '';
        this.selectedSRNamenObj = {};
        let payload = ({
          shippingid :   this.srDetailsByShippingId,
          srid : (selectedSRIDnObj.text) ? selectedSRIDnObj.text : selectedSRIDnObj
        })
        axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getSRNameById',
          'data': payload,
          headers: commonFunction.getusertoken(),
        }).then(result => {
            this.isLoading = false;
            this.SRNames = result.data.data ? result.data.data : [];
            if (this.SRNames && this.SRNames.length === 1) {
              this.SRNameId = this.SRNames[0].srid;
              this.srname = this.SRNames[0].srname;
              if (this.srname && this.srname.includes('SR details are not being fetched at the moment')) {
                this.shouldShowLabel = false;
                this.$alertify.error('SR details are not being fetched at the moment.');
                return;
              }
              this.selectedSRNamenObj = { value: this.SRNames[0].srid, text: this.SRNames[0].srname};
            } else {
              this.SRNames = this.SRNames.map(item => ({
                value: item.srid,
                text: item.srname
              }));
            }
        },  error => {
          this.isLoading = false;
          var commonVariable = commonFunction.showNetworkError(error);
          this.$alertify.error(commonVariable);
        }).catch((error) => {
          this.isLoading = false; 
          this.$alertify.error(error);
        });
    }
    }
  }
</script>
<style lang="css" scoped>
  .previewModal {
    width: 85% !important;
  }
  .compRedCss {
    color: red !important;
  }
  div.mce-edit-area {
    background: #FFF;
    filter: none;
    height: 200px;
  }
  /* .card-header[data-v-537bbe39] {
    padding: 0.75rem 1.25rem;
    border-bottom-color: #c2cad0;
    background-color: #dadfe2 !important;
    height: 40px;
  }
  .card-header .card-actions a,
  .card-header .card-actions button {
    display: block;
    float: left;
    width: 90px;
    padding: 0.75rem 0;
    margin: 0 !important;
    color: #151b1e;
    text-align: center;
    background: transparent;
    border: 0;
    box-shadow: 0;
  } */
</style>




// WEBPACK FOOTER //
// src/views/components/emailr/emailtracking.vue?1edf4942